import { useInView } from "react-intersection-observer";
export function Gardener() {
  const [ref, inView] = useInView({ threshold: 0.5 });
  return (
    <svg
      ref={ref}
      className={`${inView ? "animated" : ""}`}
      id="freepik_stories-flowers"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="15 110 470 390"
      version="1.1"
      height="90%"
    >
      <g
        id="freepik--Floor--inject-18"
        style={{ transformOrigin: "250px 351.025px 0px" }}
        className="animable"
      >
        <path
          d="M415.17,255.05c-91.82-53-240.2-53-331.42,0S-7,394,84.83,447s240.2,53,331.42,0S507,308.07,415.17,255.05Z"
          style={{
            fill: "#f4c4d9",
            transformOrigin: " 250px 351.025px 0px",
          }}
          id="elaznyvdk5pvd"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Shadows--inject-18"
        style={{ transformOrigin: " 241.819px 351.389px 0px" }}
        className="animable"
      >
        <path
          d="M217.9,252.64c-6.75-3.9-17.65-3.9-24.36,0s-6.67,10.21.08,14.11,17.66,3.89,24.36,0S224.65,256.53,217.9,252.64Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 205.758px 259.693px 0px",
          }}
          id="elw5sqz5u95dj"
          className="animable"
        ></path>
        <path
          d="M389.1,278.6c-11.7-6.76-30.61-6.76-42.24,0s-11.56,17.71.14,24.46,30.61,6.76,42.24,0S400.8,285.35,389.1,278.6Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 368.05px 290.828px 0px",
          }}
          id="el6cldyd7hjcy"
          className="animable"
        ></path>
        <path
          d="M403.79,382.16c-11.7-6.76-30.61-6.76-42.24,0s-11.56,17.71.14,24.46,30.61,6.76,42.24,0S415.49,388.91,403.79,382.16Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 382.74px 394.388px 0px",
          }}
          id="elaq0uhav260e"
          className="animable"
        ></path>
        <path
          d="M309.28,264.52c-14-8.1-36.69-8.1-50.63,0s-13.86,21.23.16,29.33,36.7,8.09,50.64,0S323.31,272.62,309.28,264.52Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 284.049px 279.183px 0px",
          }}
          id="el6fg6nf59rtt"
          className="animable"
        ></path>
        <path
          d="M213.34,399c-21.42-12.36-56-12.36-77.31,0s-21.17,32.42.25,44.79,56,12.36,77.31,0S234.76,411.38,213.34,399Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 174.81px 421.397px 0px",
          }}
          id="elnzo5ghe1pvr"
          className="animable"
        ></path>
        <path
          d="M300.81,343.24c-7-4-18.28-4-25.23,0s-6.91,10.58.08,14.61,18.29,4,25.24,0S307.81,347.27,300.81,343.24Z"
          style={{
            fill: "rgba(224, 224, 224,0.00)",
            transformOrigin: " 288.239px 350.551px 0px",
          }}
          id="el5egmql9sod"
          className="animable"
        ></path>
        <path
          d="M97.84,317.84c-6.16-3.56-16.12-3.56-22.24,0s-6.09,9.32.07,12.88,16.12,3.55,22.24,0S104,321.39,97.84,317.84Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 86.755px 324.278px 0px",
          }}
          id="elrl5xzdszr5r"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Windows--inject-18"
        style={{ transformOrigin: " 362.1px 140.03px 0px" }}
        className="animable animator-active animator-hidden"
      >
        <polygon
          points="344.4 66.79 338.61 63.48 338.25 190.17 338.26 190.18 384.98 216.86 385 210.22 385.34 90.16 344.4 66.79"
          style={{
            fill: " rgb(240, 240, 240)",
            transformOrigin: " 361.795px 140.17px 0px",
          }}
          id="el1srp9xf8ml5"
          className="animable"
        ></polygon>
        <g id="elxi6p9xl243q">
          <polygon
            points="344.06 186.85 344.4 66.79 338.61 63.48 338.25 190.17 338.26 190.18 344.08 186.86 344.06 186.85"
            style={{
              opacity: "0.1",
              transformOrigin: " 341.325px 126.83px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <g id="elvt0hhgay9f">
          <polygon
            points="385 210.22 344.08 186.86 338.26 190.18 384.98 216.86 385 210.22"
            style={{
              opacity: "0.2",
              transformOrigin: " 361.63px 201.86px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <polygon
          points="281.08 30.01 275.29 26.7 274.92 153.4 274.94 153.41 321.66 180.09 321.68 173.45 322.02 53.39 281.08 30.01"
          style={{
            fill: " rgb(240, 240, 240)",
            transformOrigin: " 298.47px 103.395px 0px",
          }}
          id="el49ghh7zdc5i"
          className="animable"
        ></polygon>
        <g id="el26skan0t58f">
          <polygon
            points="280.74 150.07 281.08 30.01 275.29 26.7 274.92 153.4 274.94 153.41 280.76 150.09 280.74 150.07"
            style={{ opacity: "0.1", transformOrigin: " 278px 90.055px 0px" }}
            className="animable"
          ></polygon>
        </g>
        <g id="elqvotc9zr6vn">
          <polygon
            points="321.68 173.45 280.76 150.09 274.94 153.41 321.66 180.09 321.68 173.45"
            style={{
              opacity: "0.2",
              transformOrigin: " 298.31px 165.09px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <polygon
          points="408.34 103.29 402.54 99.98 402.18 226.68 402.19 226.69 448.91 253.36 448.93 246.73 449.28 126.67 408.34 103.29"
          style={{
            fill: " rgb(240, 240, 240)",
            transformOrigin: " 425.73px 176.67px 0px",
          }}
          id="el3agiglrigg8"
          className="animable"
        ></polygon>
        <g id="elyjhh0ojyai">
          <polygon
            points="407.99 223.35 408.34 103.29 402.54 99.98 402.18 226.68 402.19 226.69 408.01 223.36 407.99 223.35"
            style={{
              opacity: "0.1",
              transformOrigin: " 405.26px 163.335px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
        <g id="elc2oq9yfqa68">
          <polygon
            points="448.93 246.73 408.01 223.36 402.19 226.69 448.91 253.36 448.93 246.73"
            style={{
              opacity: "0.2",
              transformOrigin: " 425.56px 238.36px 0px",
            }}
            className="animable"
          ></polygon>
        </g>
      </g>
      <g
        id="freepik--Shelf--inject-18"
        style={{ transformOrigin: " 133.78px 121.225px 0px" }}
        className="animable animator-hidden"
      >
        <path
          d="M144.29,109.27l-13.39.39-13.38-.39c-.58,9,1.18,18.25,3.62,22.75h0a6,6,0,0,0,2.65,2.7,15.7,15.7,0,0,0,14.25,0A5.9,5.9,0,0,0,140.7,132C143.12,127.43,144.86,118.27,144.29,109.27Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 130.904px 122.85px 0px",
          }}
          id="elpt76la9hrwq"
          className="animable"
        ></path>
        <path
          d="M140.34,103.79c5.24,3,5.27,7.94.06,11s-13.69,3-18.93,0-5.28-7.93-.06-11S135.09,100.76,140.34,103.79Z"
          style={{
            fill: " rgb(235, 235, 235)",
            transformOrigin: " 130.903px 109.283px 0px",
          }}
          id="eljdcy5vm2d99"
          className="animable"
        ></path>
        <path
          d="M138.26,105c4.09,2.37,4.11,6.2.05,8.56a16.29,16.29,0,0,1-14.77,0c-4.09-2.36-4.11-6.19-.05-8.56A16.29,16.29,0,0,1,138.26,105Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 130.9px 109.28px 0px",
          }}
          id="el2znc455lxpq"
          className="animable"
        ></path>
        <path
          d="M180.06,89l-13.38.39L153.29,89c-.58,9,1.19,18.25,3.62,22.75h0a6.14,6.14,0,0,0,2.65,2.7,15.72,15.72,0,0,0,14.26,0,6,6,0,0,0,2.64-2.77C178.89,107.13,180.63,98,180.06,89Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 166.674px 102.58px 0px",
          }}
          id="ellglkh6mt8a"
          className="animable"
        ></path>
        <path
          d="M176.11,83.49c5.24,3,5.27,7.93.06,11s-13.68,3-18.93,0-5.27-7.94-.06-11S170.86,80.46,176.11,83.49Z"
          style={{
            fill: " rgb(235, 235, 235)",
            transformOrigin: " 166.673px 88.9863px 0px",
          }}
          id="eltoi5ac4o33"
          className="animable"
        ></path>
        <path
          d="M174,84.69c4.09,2.36,4.11,6.19,0,8.56a16.29,16.29,0,0,1-14.77,0c-4.09-2.37-4.11-6.2,0-8.56A16.29,16.29,0,0,1,174,84.69Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 166.615px 88.97px 0px",
          }}
          id="el0yfyrsq6e2d"
          className="animable"
        ></path>
        <path
          d="M108.71,129.44l-13.38.39-13.39-.39c-.58,9,1.19,18.25,3.62,22.75h0a6.07,6.07,0,0,0,2.65,2.69,15.72,15.72,0,0,0,14.26,0,6,6,0,0,0,2.65-2.76C107.54,147.59,109.29,138.43,108.71,129.44Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 95.3255px 143.015px 0px",
          }}
          id="el45ums85rlkh"
          className="animable"
        ></path>
        <path
          d="M104.76,124c5.24,3,5.27,7.93.06,11s-13.68,3-18.93,0-5.27-7.94-.06-11S99.52,120.93,104.76,124Z"
          style={{
            fill: " rgb(235, 235, 235)",
            transformOrigin: " 95.3231px 129.489px 0px",
          }}
          id="el7q7mqjvl94j"
          className="animable"
        ></path>
        <path
          d="M102.69,125.16c4.09,2.36,4.11,6.19,0,8.56a16.27,16.27,0,0,1-14.76,0c-4.1-2.37-4.12-6.2,0-8.56A16.29,16.29,0,0,1,102.69,125.16Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 95.3062px 129.441px 0px",
          }}
          id="eltv1wfrw5x6r"
          className="animable"
        ></path>
        <path
          d="M95.21,130.78a.77.77,0,0,1-.77-.73,68.22,68.22,0,0,1,6.13-31.56.75.75,0,0,1,1-.38.76.76,0,0,1,.38,1A66.87,66.87,0,0,0,96,130a.76.76,0,0,1-.73.8Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 98.1916px 114.421px 0px",
          }}
          id="elxs1ulcdd3sc"
          className="animable"
        ></path>
        <g id="el3lflxfcxwfd">
          <g
            style={{
              opacity: "0.2",
              transformOrigin: " 98.1916px 114.421px 0px",
            }}
            className="animable"
          >
            <path
              d="M95.21,130.78a.77.77,0,0,1-.77-.73,68.22,68.22,0,0,1,6.13-31.56.75.75,0,0,1,1-.38.76.76,0,0,1,.38,1A66.87,66.87,0,0,0,96,130a.76.76,0,0,1-.73.8Z"
              id="elfh7lvdc98yf"
              style={{ transformOrigin: " 98.1916px 114.421px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M106.45,82.93a3.7,3.7,0,0,1,2.16-1.65c1.42-.32,2.84.53,3.93,1.49a11.32,11.32,0,0,1,2.88,3.68A7.08,7.08,0,0,1,116,91a4.87,4.87,0,0,1-7.43,3.13,6.93,6.93,0,0,1-2.88-3.67A8.51,8.51,0,0,1,106.45,82.93Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 110.645px 88.0641px 0px",
          }}
          id="eleyv5vqyj5ri"
          className="animable"
        ></path>
        <g id="eltn1qcs1e4l">
          <path
            d="M106.45,82.93a3.7,3.7,0,0,1,2.16-1.65c1.42-.32,2.84.53,3.93,1.49a11.32,11.32,0,0,1,2.88,3.68A7.08,7.08,0,0,1,116,91a4.87,4.87,0,0,1-7.43,3.13,6.93,6.93,0,0,1-2.88-3.67A8.51,8.51,0,0,1,106.45,82.93Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.1",
              transformOrigin: " 110.645px 88.0641px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M96.42,82.27a6.47,6.47,0,0,1,4.36-3.09,5.41,5.41,0,0,1,5,1.73,8.1,8.1,0,0,1,1.5,3.37,10.76,10.76,0,0,1,.36,3.65,5.25,5.25,0,0,1-1.49,3.28,4.94,4.94,0,0,1-4,1.19,7.54,7.54,0,0,1-3.85-1.85c-1-.82-2.46-2.19-2.79-3.45A7.13,7.13,0,0,1,96.42,82.27Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 101.541px 85.7739px 0px",
          }}
          id="elfn4t5kufsjj"
          className="animable"
        ></path>
        <path
          d="M100.78,83.52a3,3,0,0,1,2.81-.39,16.81,16.81,0,0,1,2,1.45,15.35,15.35,0,0,0,3.76,1.16,6.44,6.44,0,0,1,3.17,2.11,4.93,4.93,0,0,1,1,3.63,4,4,0,0,1-2.15,3c-1.59.76-3.48.25-5.15-.35a14.94,14.94,0,0,1-5.13-2.74C99,89.4,98,85.54,100.78,83.52Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 106.317px 88.9027px 0px",
          }}
          id="elmsoekh0ns"
          className="animable"
        ></path>
        <g id="el67ynis4hb7p">
          <path
            d="M100.78,83.52a3,3,0,0,1,2.81-.39,16.81,16.81,0,0,1,2,1.45,15.35,15.35,0,0,0,3.76,1.16,6.44,6.44,0,0,1,3.17,2.11,4.93,4.93,0,0,1,1,3.63,4,4,0,0,1-2.15,3c-1.59.76-3.48.25-5.15-.35a14.94,14.94,0,0,1-5.13-2.74C99,89.4,98,85.54,100.78,83.52Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 106.317px 88.9027px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M102.9,87.25a2.4,2.4,0,0,1,0-1.75,1.33,1.33,0,0,1,1.45-.8,1.84,1.84,0,0,1,1,.78,7.41,7.41,0,0,1,1.2,2.46c.27,1,0,3.37-1.64,2.69-.48-.2-.72-.81-.93-1.24A19.34,19.34,0,0,1,102.9,87.25Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 104.688px 87.716px 0px",
          }}
          id="elu7tdxdhx95"
          className="animable"
        ></path>
        <g id="ell0en2coxc2">
          <path
            d="M102.9,87.25a2.4,2.4,0,0,1,0-1.75,1.33,1.33,0,0,1,1.45-.8,1.84,1.84,0,0,1,1,.78,7.41,7.41,0,0,1,1.2,2.46c.27,1,0,3.37-1.64,2.69-.48-.2-.72-.81-.93-1.24A19.34,19.34,0,0,1,102.9,87.25Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 104.688px 87.716px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M106.49,88.58a3,3,0,0,1,2-.77,2.16,2.16,0,0,1,1,.23,1.32,1.32,0,0,1,.64.81,1.41,1.41,0,0,1-.43,1.28,3.36,3.36,0,0,1-1.2.7A2.34,2.34,0,0,1,106,90.6C105.36,90,106,89.06,106.49,88.58Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 107.941px 89.4492px 0px",
          }}
          id="ellu0xf7ycgt"
          className="animable"
        ></path>
        <g id="el1o84k6oksg9">
          <path
            d="M106.49,88.58a3,3,0,0,1,2-.77,2.16,2.16,0,0,1,1,.23,1.32,1.32,0,0,1,.64.81,1.41,1.41,0,0,1-.43,1.28,3.36,3.36,0,0,1-1.2.7A2.34,2.34,0,0,1,106,90.6C105.36,90,106,89.06,106.49,88.58Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 107.941px 89.4492px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M103.83,88a4.91,4.91,0,0,0,1.75,1.46c1,.38,2.07.16,3,.61a2.91,2.91,0,0,1,1.34,3.07,4.54,4.54,0,0,1-4.47,3.56,5.78,5.78,0,0,1-4.93-3.28,8.93,8.93,0,0,1-.44-6C100.65,85.16,102.9,87,103.83,88Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 104.867px 91.521px 0px",
          }}
          id="el9jibniz3zt"
          className="animable"
        ></path>
        <path
          d="M111.51,92.3c.86-.65,1.86-1.43,2.9-1.12a2,2,0,0,1,1.31,1.75,4.65,4.65,0,0,1-.41,2.25,14.39,14.39,0,0,1-9,8.38,6.53,6.53,0,0,1-5.17-.2,4.25,4.25,0,0,1-2-3.94c.2-2.48,2.27-3.85,4.49-4.09A15.84,15.84,0,0,0,111.51,92.3Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 107.429px 97.5543px 0px",
          }}
          id="el3ngxakuv04w"
          className="animable"
        ></path>
        <g id="el0qpc2ytaytgb">
          <path
            d="M111.51,92.3c.86-.65,1.86-1.43,2.9-1.12a2,2,0,0,1,1.31,1.75,4.65,4.65,0,0,1-.41,2.25,14.39,14.39,0,0,1-9,8.38,6.53,6.53,0,0,1-5.17-.2,4.25,4.25,0,0,1-2-3.94c.2-2.48,2.27-3.85,4.49-4.09A15.84,15.84,0,0,0,111.51,92.3Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 107.429px 97.5543px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M93,94.65A11.24,11.24,0,0,1,95.43,86c.86-1,2.25-2,3.49-1.44a3.73,3.73,0,0,1,1.57,1.87l2.86,5.61A11.24,11.24,0,0,1,105,97.26a5.65,5.65,0,0,1-2.35,4.44C97.82,105.15,93.63,99,93,94.65Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 98.9471px 93.5542px 0px",
          }}
          id="eldq452093uml"
          className="animable"
        ></path>
        <g id="el7oip6gko58e">
          <path
            d="M93,94.65A11.24,11.24,0,0,1,95.43,86c.86-1,2.25-2,3.49-1.44a3.73,3.73,0,0,1,1.57,1.87l2.86,5.61A11.24,11.24,0,0,1,105,97.26a5.65,5.65,0,0,1-2.35,4.44C97.82,105.15,93.63,99,93,94.65Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 98.9471px 93.5542px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M112.88,109.7c-6.89-4.27-14.23-1.4-16.41,6.4C103.36,120.37,110.71,117.5,112.88,109.7Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 104.675px 112.9px 0px",
          }}
          id="elshg7rqj3s4p"
          className="animable"
        ></path>
        <g id="elmapsevp0lan">
          <path
            d="M112.88,109.7c-6.89-4.27-14.23-1.4-16.41,6.4C103.36,120.37,110.71,117.5,112.88,109.7Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 104.675px 112.9px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elmex7msdr9a">
          <path
            d="M111.49,110.24a89.93,89.93,0,0,0-13.63,5.32A89.93,89.93,0,0,0,111.49,110.24Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 104.675px 112.9px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M84.34,100.21c8-1.08,13.56,4.54,12.36,12.56C88.67,113.85,83.13,108.23,84.34,100.21Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 90.5185px 106.49px 0px",
          }}
          id="elp0iiy6u68q"
          className="animable"
        ></path>
        <g id="elwre14fv98f">
          <path
            d="M84.34,100.21c8-1.08,13.56,4.54,12.36,12.56C88.67,113.85,83.13,108.23,84.34,100.21Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 90.5185px 106.49px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elx5rlmwx1bpe">
          <path
            d="M85.39,101.28A91,91,0,0,1,95.65,111.7,91,91,0,0,1,85.39,101.28Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 90.52px 106.49px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M130.91,109.86a.61.61,0,0,0,.61-.59,37.79,37.79,0,0,1,6.21-20,.62.62,0,0,0-.17-.84.61.61,0,0,0-.84.17,39.15,39.15,0,0,0-6.41,20.69.6.6,0,0,0,.59.61Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 134.068px 99.1152px 0px",
          }}
          id="el4f1i0likicf"
          className="animable"
        ></path>
        <g id="elktg8fdtszdo">
          <g
            style={{
              opacity: "0.2",
              transformOrigin: " 134.068px 99.1152px 0px",
            }}
            className="animable"
          >
            <path
              d="M130.91,109.86a.61.61,0,0,0,.61-.59,37.79,37.79,0,0,1,6.21-20,.62.62,0,0,0-.17-.84.61.61,0,0,0-.84.17,39.15,39.15,0,0,0-6.41,20.69.6.6,0,0,0,.59.61Z"
              id="elnuk28yfjmf"
              style={{ transformOrigin: " 134.068px 99.1152px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M132.93,81.6c1.84,3.19,4.25,5,5.41,4s.59-4.34-1.24-7.53-4.25-5-5.4-4S131.1,78.41,132.93,81.6Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 135.021px 79.835px 0px",
          }}
          id="el8c7nmgkz18"
          className="animable"
        ></path>
        <path
          d="M140.73,95.17c-1.83-3.19-2.39-6.56-1.23-7.53s3.57.83,5.4,4,2.38,6.56,1.23,7.52S142.56,98.35,140.73,95.17Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 142.813px 93.399px 0px",
          }}
          id="elwu96mmlg14"
          className="animable"
        ></path>
        <path
          d="M134.76,93.87c2.64-2.22,4.12-5.15,3.32-6.54s-3.58-.72-6.22,1.49-4.12,5.15-3.32,6.54S132.13,96.09,134.76,93.87Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 133.31px 91.3462px 0px",
          }}
          id="el0vplw74qj9uh"
          className="animable"
        ></path>
        <path
          d="M146,84.43c-2.63,2.22-5.42,2.89-6.22,1.5s.69-4.32,3.32-6.54,5.42-2.89,6.22-1.49S148.6,82.22,146,84.43Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 144.549px 81.9114px 0px",
          }}
          id="elp1548ori36l"
          className="animable"
        ></path>
        <g id="el47nhxq7jxr">
          <g
            style={{
              opacity: "0.1",
              transformOrigin: " 138.915px 86.6077px 0px",
            }}
            className="animable"
          >
            <path
              d="M132.93,81.6c1.84,3.19,4.25,5,5.41,4s.59-4.34-1.24-7.53-4.25-5-5.4-4S131.1,78.41,132.93,81.6Z"
              id="elc32nbnrb41"
              style={{ transformOrigin: " 135.021px 79.835px 0px" }}
              className="animable"
            ></path>
            <path
              d="M140.73,95.17c-1.83-3.19-2.39-6.56-1.23-7.53s3.57.83,5.4,4,2.38,6.56,1.23,7.52S142.56,98.35,140.73,95.17Z"
              id="elwkbk55avuu"
              style={{ transformOrigin: " 142.813px 93.399px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <g id="elohxj9xp7haq">
          <g
            style={{
              opacity: "0.1",
              transformOrigin: " 138.928px 86.6278px 0px",
            }}
            className="animable"
          >
            <path
              d="M134.76,93.87c2.64-2.22,4.12-5.15,3.32-6.54s-3.58-.72-6.22,1.49-4.12,5.15-3.32,6.54S132.13,96.09,134.76,93.87Z"
              id="elevmmdjy5iic"
              style={{ transformOrigin: " 133.31px 91.3462px 0px" }}
              className="animable"
            ></path>
            <path
              d="M146,84.43c-2.63,2.22-5.42,2.89-6.22,1.5s.69-4.32,3.32-6.54,5.42-2.89,6.22-1.49S148.6,82.22,146,84.43Z"
              id="elw1uvhrj099s"
              style={{ transformOrigin: " 144.549px 81.9114px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M137.62,78c-.56,3.83.1,7.17,1.48,7.47s3-2.56,3.52-6.38-.09-7.16-1.47-7.46S138.19,74.13,137.62,78Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 140.112px 78.5498px 0px",
          }}
          id="el5bpnlg678y9"
          className="animable"
        ></path>
        <path
          d="M135.21,94.22c.57-3.83,2.15-6.68,3.53-6.38s2,3.64,1.47,7.46-2.15,6.68-3.53,6.38S134.64,98,135.21,94.22Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 137.702px 94.76px 0px",
          }}
          id="eluq47xdwdey"
          className="animable"
        ></path>
        <path
          d="M131.75,88.19c3.16.69,5.92-.11,6.17-1.78s-2.12-3.58-5.27-4.27-5.92.11-6.17,1.78S128.59,87.51,131.75,88.19Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 132.2px 85.165px 0px",
          }}
          id="elj11n4rtan5"
          className="animable"
        ></path>
        <path
          d="M145.19,91.11c-3.16-.68-5.52-2.59-5.27-4.26s3-2.47,6.16-1.78,5.52,2.59,5.27,4.26S148.34,91.8,145.19,91.11Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 145.635px 88.09px 0px",
          }}
          id="el4gpv5r2z7iu"
          className="animable"
        ></path>
        <path
          d="M134.73,85.72c-.42,2.8,1.12,5.48,3.43,6s4.53-1.36,5-4.16-1.13-5.48-3.44-6S135.14,82.92,134.73,85.72Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 138.952px 86.64px 0px",
          }}
          id="elfuaon1x2o5"
          className="animable"
        ></path>
        <path
          d="M165.86,87.08a7.06,7.06,0,0,0,6.28,1.43,6.59,6.59,0,0,0,4.4-4.45,12.89,12.89,0,0,1-3.44-2.39,8.79,8.79,0,0,1,4.87.18,5,5,0,0,0,.36-4.65,8.5,8.5,0,0,0-5.8-.4A7.7,7.7,0,0,1,178.4,75a22.54,22.54,0,0,0-1.41-9c-4,.2-7.86,1.92-9.17,3.16a14.66,14.66,0,0,0,.44,4.24,3.43,3.43,0,0,1-1.85-2.74c-2.5.63-3.57,1.87-4,2.82a10.46,10.46,0,0,0,2.37,4.79,5.76,5.76,0,0,1-3.3-3.32C159.21,80.36,159.65,86.55,165.86,87.08Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 169.482px 77.3646px 0px",
          }}
          id="el546prim9wui"
          className="animable"
        ></path>
        <g id="elk5pgw70se4">
          <path
            d="M165.86,87.08a7.06,7.06,0,0,0,6.28,1.43,6.59,6.59,0,0,0,4.4-4.45,12.89,12.89,0,0,1-3.44-2.39,8.79,8.79,0,0,1,4.87.18,5,5,0,0,0,.36-4.65,8.5,8.5,0,0,0-5.8-.4A7.7,7.7,0,0,1,178.4,75a22.54,22.54,0,0,0-1.41-9c-4,.2-7.86,1.92-9.17,3.16a14.66,14.66,0,0,0,.44,4.24,3.43,3.43,0,0,1-1.85-2.74c-2.5.63-3.57,1.87-4,2.82a10.46,10.46,0,0,0,2.37,4.79,5.76,5.76,0,0,1-3.3-3.32C159.21,80.36,159.65,86.55,165.86,87.08Z"
            style={{
              opacity: "0.2",
              transformOrigin: " 169.482px 77.3646px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M165.72,87.67h0a.22.22,0,0,1-.21-.24c.38-5.05,3.26-13.37,10.14-20.23a.23.23,0,0,1,.32.32c-6.78,6.78-9.63,15-10,19.94A.23.23,0,0,1,165.72,87.67Z"
          style={{
            fill: " rgb(245, 245, 245)",
            transformOrigin: " 170.76px 77.415px 0px",
          }}
          id="el01u6eb2bgqjh"
          className="animable"
        ></path>
        <path
          d="M167.6,89.78a6.55,6.55,0,0,1-10.25-2.7,10.71,10.71,0,0,0,3.1-2.11,8.87,8.87,0,0,0-4.6.14,4.3,4.3,0,0,1-.64-4.14,8.52,8.52,0,0,1,5.48-.33A8.08,8.08,0,0,0,155,79a18.38,18.38,0,0,1,.76-8c3.81.23,7.58,1.81,8.88,2.92a12,12,0,0,1-.15,3.77,2.76,2.76,0,0,0,1.57-2.42c2.39.57,3.46,1.69,3.89,2.53A8.29,8.29,0,0,1,168,81.94,4.7,4.7,0,0,0,170.92,79C173.4,83.86,173.36,89.32,167.6,89.78Z"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 163.669px 81.129px 0px",
          }}
          id="elvxoxl0695nl"
          className="animable"
        ></path>
        <g id="elga27zfnwmkg">
          <path
            d="M167.6,89.78a6.55,6.55,0,0,1-10.25-2.7,10.71,10.71,0,0,0,3.1-2.11,8.87,8.87,0,0,0-4.6.14,4.3,4.3,0,0,1-.64-4.14,8.52,8.52,0,0,1,5.48-.33A8.08,8.08,0,0,0,155,79a18.38,18.38,0,0,1,.76-8c3.81.23,7.58,1.81,8.88,2.92a12,12,0,0,1-.15,3.77,2.76,2.76,0,0,0,1.57-2.42c2.39.57,3.46,1.69,3.89,2.53A8.29,8.29,0,0,1,168,81.94,4.7,4.7,0,0,0,170.92,79C173.4,83.86,173.36,89.32,167.6,89.78Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 163.669px 81.129px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M167.76,90.33a.22.22,0,0,1-.23-.2c-.66-4.39-3.85-11.67-10.68-17.76a.24.24,0,0,1,0-.33.25.25,0,0,1,.33,0c6.92,6.17,10.16,13.58,10.82,18a.23.23,0,0,1-.19.27Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 162.394px 81.154px 0px",
          }}
          id="elap4r1bqz72d"
          className="animable"
        ></path>
        <polygon
          points="60.53 151.62 96.47 172.24 207.02 108.28 171.08 87.67 60.53 151.62"
          style={{
            fill: " rgb(235, 235, 235)",
            transformOrigin: " 133.775px 129.955px 0px",
          }}
          id="elgdd33azojh"
          className="animable"
        ></polygon>
        <polygon
          points="60.53 151.62 60.54 155.83 96.48 176.45 96.47 172.24 60.53 151.62"
          style={{
            fill: "#f0b4ce",
            transformOrigin: " 78.505px 164.035px 0px",
          }}
          id="eljte2bsr8ybr"
          className="animable"
        ></polygon>
        <polygon
          points="96.47 172.24 96.48 176.45 207.03 112.5 207.02 108.28 96.47 172.24"
          style={{
            fill: " rgb(240, 240, 240)",
            transformOrigin: " 151.75px 142.365px 0px",
          }}
          id="elo6a84eecjs"
          className="animable"
        ></polygon>
      </g>
      <g
        id="freepik--flowers-3--inject-18"
        style={{ transformOrigin: " 283.785px 205.411px 0px" }}
        className="animable"
      >
        <path
          d="M325.28,185.24l-41.14,1.2L243,185.24c-.39,6.23-.43,37.7-.16,43.81.92,21.15,5.49,40.6,11.29,51.33h0c1.34,3,4,5.91,8.14,8.28,12.14,7,31.75,7,43.81,0,4.18-2.43,6.87-5.38,8.14-8.5,5.75-10.77,10.26-30.1,11.18-51.11C325.71,222.94,325.67,191.47,325.28,185.24Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 284.136px 239.575px 0px",
          }}
          id="elv0u6m174z2"
          className="animable"
        ></path>
        <g id="el588gxbm1txe">
          <path
            d="M325.28,185.24l-41.14,1.2L243,185.24c-.39,6.23-.43,37.7-.16,43.81.92,21.15,5.49,40.6,11.29,51.33h0c1.34,3,4,5.91,8.14,8.28,12.14,7,31.75,7,43.81,0,4.18-2.43,6.87-5.38,8.14-8.5,5.75-10.77,10.26-30.1,11.18-51.11C325.71,222.94,325.67,191.47,325.28,185.24Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.6",
              transformOrigin: " 284.136px 239.575px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M313.13,168.4c16.12,9.3,16.21,24.39.19,33.69s-42.05,9.31-58.17,0S239,177.7,255,168.4,297,159.09,313.13,168.4Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 284.154px 185.245px 0px",
          }}
          id="elrksc2k1am3e"
          className="animable"
        ></path>
        <g id="el9op18oe5yyd">
          <g
            style={{
              opacity: "0.8",
              transformOrigin: " 284.154px 185.245px 0px",
            }}
            className="animable"
          >
            <path
              d="M313.13,168.4c16.12,9.3,16.21,24.39.19,33.69s-42.05,9.31-58.17,0S239,177.7,255,168.4,297,159.09,313.13,168.4Z"
              style={{
                fill: " rgb(255, 255, 255)",
                transformOrigin: " 284.154px 185.245px 0px",
              }}
              id="elp4xjnyvie1"
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M308.49,171.09c13.54,7.82,13.61,20.49.16,28.3s-35.32,7.82-48.85,0-13.61-20.48-.16-28.3S295,163.28,308.49,171.09Z"
          style={{
            fill: " rgb(55, 71, 79)",
            transformOrigin: " 284.147px 185.24px 0px",
          }}
          id="el2rqysug3zbg"
          className="animable"
        ></path>
        <path
          d="M336.7,159c0-5.8-3.89-10.85-9.63-13.49a9,9,0,0,0,2.23-5.83c0-5.62-5.53-10.17-12.35-10.17a14.54,14.54,0,0,0-4.48.7c-2.32-4.15-7.39-7-13.29-7a16.87,16.87,0,0,0-8.25,2.1c-2.07-4.49-7.34-7.69-13.52-7.69-6.42,0-11.87,3.45-13.75,8.23a21.71,21.71,0,0,0-3.64-.31c-9.82,0-17.78,6.56-17.78,14.65a11.67,11.67,0,0,0,.3,2.58c-6.73,1.62-11.64,6.73-11.64,12.79,0,5,3.3,9.29,8.18,11.58a11.12,11.12,0,0,0-1.27,5.15c0,5.44,4,10.11,9.72,12.11a10.13,10.13,0,0,0-1.3,4.9c0,6.58,6.48,11.91,14.46,11.91a16.77,16.77,0,0,0,7.27-1.63c3.29,4.75,9.48,7.95,16.59,7.95s13.49-3.29,16.74-8.15a17.53,17.53,0,0,0,6.76,1.34c8.27,0,15-5.53,15-12.34a10.66,10.66,0,0,0-2-6.17l.49,0c6.78,0,12.28-4.53,12.28-10.12a8.49,8.49,0,0,0-.89-3.76A13.69,13.69,0,0,0,336.7,159Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 283.8px 162.575px 0px",
          }}
          id="elvoozdzqoax"
          className="animable"
        ></path>
        <g id="eltxaujk6lomg">
          <path
            d="M336.7,159c0-5.8-3.89-10.85-9.63-13.49a9,9,0,0,0,2.23-5.83c0-5.62-5.53-10.17-12.35-10.17a14.54,14.54,0,0,0-4.48.7c-2.32-4.15-7.39-7-13.29-7a16.87,16.87,0,0,0-8.25,2.1c-2.07-4.49-7.34-7.69-13.52-7.69-6.42,0-11.87,3.45-13.75,8.23a21.71,21.71,0,0,0-3.64-.31c-9.82,0-17.78,6.56-17.78,14.65a11.67,11.67,0,0,0,.3,2.58c-6.73,1.62-11.64,6.73-11.64,12.79,0,5,3.3,9.29,8.18,11.58a11.12,11.12,0,0,0-1.27,5.15c0,5.44,4,10.11,9.72,12.11a10.13,10.13,0,0,0-1.3,4.9c0,6.58,6.48,11.91,14.46,11.91a16.77,16.77,0,0,0,7.27-1.63c3.29,4.75,9.48,7.95,16.59,7.95s13.49-3.29,16.74-8.15a17.53,17.53,0,0,0,6.76,1.34c8.27,0,15-5.53,15-12.34a10.66,10.66,0,0,0-2-6.17l.49,0c6.78,0,12.28-4.53,12.28-10.12a8.49,8.49,0,0,0-.89-3.76A13.69,13.69,0,0,0,336.7,159Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 283.8px 162.575px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elzn3czhd3j5d">
          <path
            d="M336.7,159a13.06,13.06,0,0,0-1.64-6.3,13.84,13.84,0,0,1-2.16,8.84,13,13,0,0,1-12.51,5.54,7.64,7.64,0,0,1-3,7.84c-2.45,1.69-6.24,2.22-8.7.55a14.23,14.23,0,0,1-9.17,8.13c-4.07,1.15-9,.64-12.44-1.85a14.73,14.73,0,0,1-11.53,6.76c-4.62.22-9.53-2.55-12.36-6.21a5.72,5.72,0,0,1-8-5.89,9.91,9.91,0,0,1-7.91-4.21,9.77,9.77,0,0,1-.92-8.84c-4.27-1.14-8.48-3.1-11.31-6.49a12.84,12.84,0,0,1-2.89-6.55,11.25,11.25,0,0,0-1.29,5.21c0,5,3.3,9.29,8.18,11.58a11.12,11.12,0,0,0-1.27,5.15c0,5.44,4,10.11,9.72,12.11a10.13,10.13,0,0,0-1.3,4.9c0,6.58,6.48,11.91,14.46,11.91a16.77,16.77,0,0,0,7.27-1.63c3.29,4.75,9.48,7.95,16.59,7.95s13.49-3.29,16.74-8.15a17.53,17.53,0,0,0,6.76,1.34c8.27,0,15-5.53,15-12.34a10.66,10.66,0,0,0-2-6.17l.49,0c6.78,0,12.28-4.53,12.28-10.12a8.49,8.49,0,0,0-.89-3.76A13.69,13.69,0,0,0,336.7,159Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 283.785px 178.91px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M272.17,141.41a31.24,31.24,0,0,0-5.47,0,12.48,12.48,0,0,0-2.82.51,5.78,5.78,0,0,0-2.48,1.53,3,3,0,0,0-.2,3.88,5,5,0,0,0,4.42,1.34,10.14,10.14,0,0,0,4.75-2,16.58,16.58,0,0,0,3.18-3.27A4.45,4.45,0,0,1,272.17,141.41Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 267.067px 145.023px 0px",
          }}
          id="el1tjh9c90wuu"
          className="animable"
        ></path>
        <g id="eltk0tmzphmb">
          <path
            d="M272.17,141.41a31.24,31.24,0,0,0-5.47,0,12.48,12.48,0,0,0-2.82.51,5.78,5.78,0,0,0-2.48,1.53,3,3,0,0,0-.2,3.88,5,5,0,0,0,4.42,1.34,10.14,10.14,0,0,0,4.75-2,16.58,16.58,0,0,0,3.18-3.27A4.45,4.45,0,0,1,272.17,141.41Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 267.067px 145.023px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M269.84,146.18a5.08,5.08,0,0,0-1.41,3.86,4.78,4.78,0,0,0,3.27,3.54,7.87,7.87,0,0,0,5.86-.24,5.25,5.25,0,0,0,2.85-2.93,4.92,4.92,0,0,0-.22-3.4,15.22,15.22,0,0,0-1.7-2.89,1.83,1.83,0,0,0-.84-.78,3.17,3.17,0,0,0-1.2-.16c-1.2,0-2.72-.28-3.64.38A17.69,17.69,0,0,0,269.84,146.18Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 274.516px 148.577px 0px",
          }}
          id="elz88tkifd78"
          className="animable"
        ></path>
        <g id="eljdbnc77wt2">
          <path
            d="M269.84,146.18a5.08,5.08,0,0,0-1.41,3.86,4.78,4.78,0,0,0,3.27,3.54,7.87,7.87,0,0,0,5.86-.24,5.25,5.25,0,0,0,2.85-2.93,4.92,4.92,0,0,0-.22-3.4,15.22,15.22,0,0,0-1.7-2.89,1.83,1.83,0,0,0-.84-.78,3.17,3.17,0,0,0-1.2-.16c-1.2,0-2.72-.28-3.64.38A17.69,17.69,0,0,0,269.84,146.18Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 274.516px 148.577px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M272.77,139.51c-1.52-1.69-2.31-4-4.07-5.43a5.31,5.31,0,0,0-4.19-1.15,4.49,4.49,0,0,0-3.36,2.67,3.83,3.83,0,0,0,.89,4.12,7.16,7.16,0,0,0,3.64,1.4l6.17,1.1C272.17,141.41,272.46,140.31,272.77,139.51Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 266.83px 137.544px 0px",
          }}
          id="eltyswzhaibls"
          className="animable"
        ></path>
        <g id="eliciqq00elf">
          <path
            d="M272.77,139.51c-1.52-1.69-2.31-4-4.07-5.43a5.31,5.31,0,0,0-4.19-1.15,4.49,4.49,0,0,0-3.36,2.67,3.83,3.83,0,0,0,.89,4.12,7.16,7.16,0,0,0,3.64,1.4l6.17,1.1C272.17,141.41,272.46,140.31,272.77,139.51Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 266.83px 137.544px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M278.09,139.51c1.52-1.69,2.3-4,4.07-5.43a5.31,5.31,0,0,1,4.19-1.15,4.49,4.49,0,0,1,3.36,2.67,3.83,3.83,0,0,1-.89,4.12,7.16,7.16,0,0,1-3.65,1.4l-6.17,1.1C278.69,141.41,278.4,140.31,278.09,139.51Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 284.03px 137.544px 0px",
          }}
          id="elbvw0novlmzm"
          className="animable"
        ></path>
        <g id="el8i01taloji6">
          <path
            d="M278.09,139.51c1.52-1.69,2.3-4,4.07-5.43a5.31,5.31,0,0,1,4.19-1.15,4.49,4.49,0,0,1,3.36,2.67,3.83,3.83,0,0,1-.89,4.12,7.16,7.16,0,0,1-3.65,1.4l-6.17,1.1C278.69,141.41,278.4,140.31,278.09,139.51Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 284.03px 137.544px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M278.69,141.41a31.24,31.24,0,0,1,5.47,0,12.58,12.58,0,0,1,2.82.51,5.68,5.68,0,0,1,2.47,1.53,3,3,0,0,1,.21,3.88,5,5,0,0,1-4.42,1.34,10.06,10.06,0,0,1-4.75-2,16.58,16.58,0,0,1-3.18-3.27A4.53,4.53,0,0,0,278.69,141.41Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 283.791px 145.023px 0px",
          }}
          id="elwyuodow331"
          className="animable"
        ></path>
        <path
          d="M270.33,136.78a6.79,6.79,0,0,1-.86-4.52,5.2,5.2,0,0,1,3-3.66,5.4,5.4,0,0,1,4.72.24,5.48,5.48,0,0,1,2.49,3,7.17,7.17,0,0,1,.06,3.9,20.57,20.57,0,0,1-1.37,3.7,2.29,2.29,0,0,1-.77,1.08,2.24,2.24,0,0,1-1.15.22c-1.15,0-2.63.39-3.49-.53A19.26,19.26,0,0,1,270.33,136.78Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 274.683px 134.496px 0px",
          }}
          id="elb6sddl9dye8"
          className="animable"
        ></path>
        <g id="el0ysy3uorgcm">
          <path
            d="M278.69,141.41a31.24,31.24,0,0,1,5.47,0,12.58,12.58,0,0,1,2.82.51,5.68,5.68,0,0,1,2.47,1.53,3,3,0,0,1,.21,3.88,5,5,0,0,1-4.42,1.34,10.06,10.06,0,0,1-4.75-2,16.58,16.58,0,0,1-3.18-3.27A4.53,4.53,0,0,0,278.69,141.41Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 283.791px 145.023px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elruwuwsfua">
          <path
            d="M270.33,136.78a6.79,6.79,0,0,1-.86-4.52,5.2,5.2,0,0,1,3-3.66,5.4,5.4,0,0,1,4.72.24,5.48,5.48,0,0,1,2.49,3,7.17,7.17,0,0,1,.06,3.9,20.57,20.57,0,0,1-1.37,3.7,2.29,2.29,0,0,1-.77,1.08,2.24,2.24,0,0,1-1.15.22c-1.15,0-2.63.39-3.49-.53A19.26,19.26,0,0,1,270.33,136.78Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 274.683px 134.496px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M280.56,142.17c0,2.16-2.3,3.91-5.13,3.91s-5.13-1.75-5.13-3.91,2.3-3.91,5.13-3.91S280.56,140,280.56,142.17Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 275.43px 142.17px 0px",
          }}
          id="elwmwbe8xost"
          className="animable"
        ></path>
        <path
          d="M291.35,123.65a15.3,15.3,0,0,0-2.79,0,6.51,6.51,0,0,0-1.44.26,3,3,0,0,0-1.27.78,1.52,1.52,0,0,0-.1,2,2.56,2.56,0,0,0,2.26.68,5.13,5.13,0,0,0,2.42-1,8.48,8.48,0,0,0,1.62-1.67A2.26,2.26,0,0,1,291.35,123.65Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 288.736px 125.5px 0px",
          }}
          id="elgr97h9lukes"
          className="animable"
        ></path>
        <path
          d="M290.16,126.08a2.56,2.56,0,0,0-.72,2,2.45,2.45,0,0,0,1.67,1.81,4.06,4.06,0,0,0,3-.12,2.71,2.71,0,0,0,1.45-1.5,2.49,2.49,0,0,0-.11-1.74,8.36,8.36,0,0,0-.87-1.47,1,1,0,0,0-.43-.4,1.53,1.53,0,0,0-.61-.08,3.28,3.28,0,0,0-1.86.2A9.11,9.11,0,0,0,290.16,126.08Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 292.549px 127.323px 0px",
          }}
          id="eli3j8hbp7ja"
          className="animable"
        ></path>
        <g id="ellz6kb95378t">
          <path
            d="M290.16,126.08a2.56,2.56,0,0,0-.72,2,2.45,2.45,0,0,0,1.67,1.81,4.06,4.06,0,0,0,3-.12,2.71,2.71,0,0,0,1.45-1.5,2.49,2.49,0,0,0-.11-1.74,8.36,8.36,0,0,0-.87-1.47,1,1,0,0,0-.43-.4,1.53,1.53,0,0,0-.61-.08,3.28,3.28,0,0,0-1.86.2A9.11,9.11,0,0,0,290.16,126.08Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 292.549px 127.323px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M291.65,122.68c-.77-.86-1.17-2-2.07-2.77a2.72,2.72,0,0,0-2.14-.59,2.26,2.26,0,0,0-1.71,1.36,2,2,0,0,0,.45,2.11,3.65,3.65,0,0,0,1.86.71l3.15.56C291.35,123.65,291.49,123.09,291.65,122.68Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 288.626px 121.674px 0px",
          }}
          id="elouze7yrnq2m"
          className="animable"
        ></path>
        <g id="elzjamg4wylbp">
          <path
            d="M291.65,122.68c-.77-.86-1.17-2-2.07-2.77a2.72,2.72,0,0,0-2.14-.59,2.26,2.26,0,0,0-1.71,1.36,2,2,0,0,0,.45,2.11,3.65,3.65,0,0,0,1.86.71l3.15.56C291.35,123.65,291.49,123.09,291.65,122.68Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 288.626px 121.674px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M294.37,122.68c.77-.86,1.17-2,2.07-2.77a2.73,2.73,0,0,1,2.14-.59,2.26,2.26,0,0,1,1.71,1.36,2,2,0,0,1-.45,2.11,3.65,3.65,0,0,1-1.86.71l-3.15.56C294.68,123.65,294.53,123.09,294.37,122.68Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 297.394px 121.675px 0px",
          }}
          id="elawexe8u2dwm"
          className="animable"
        ></path>
        <g id="elu75pbcrugc">
          <path
            d="M294.37,122.68c.77-.86,1.17-2,2.07-2.77a2.73,2.73,0,0,1,2.14-.59,2.26,2.26,0,0,1,1.71,1.36,2,2,0,0,1-.45,2.11,3.65,3.65,0,0,1-1.86.71l-3.15.56C294.68,123.65,294.53,123.09,294.37,122.68Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 297.394px 121.675px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M294.67,123.65a15.3,15.3,0,0,1,2.79,0,6.51,6.51,0,0,1,1.44.26,3,3,0,0,1,1.27.78,1.51,1.51,0,0,1,.1,2,2.56,2.56,0,0,1-2.26.68,5.18,5.18,0,0,1-2.42-1,8.48,8.48,0,0,1-1.62-1.67A2.26,2.26,0,0,0,294.67,123.65Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 297.286px 125.5px 0px",
          }}
          id="elm2ezdjuz7c"
          className="animable"
        ></path>
        <path
          d="M290.41,121.29A3.49,3.49,0,0,1,290,119a2.67,2.67,0,0,1,1.51-1.87,2.79,2.79,0,0,1,2.41.12,2.83,2.83,0,0,1,1.27,1.54,3.73,3.73,0,0,1,0,2,10.73,10.73,0,0,1-.7,1.89,1.16,1.16,0,0,1-.39.55,1.18,1.18,0,0,1-.59.11c-.59,0-1.34.2-1.78-.27A9.68,9.68,0,0,1,290.41,121.29Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 292.64px 120.147px 0px",
          }}
          id="eltv9wz7rgzi"
          className="animable"
        ></path>
        <path
          d="M295.63,124c0,1.11-1.17,2-2.62,2s-2.62-.89-2.62-2,1.18-2,2.62-2S295.63,122.93,295.63,124Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 293.01px 124px 0px",
          }}
          id="el94hcz8xdz97"
          className="animable"
        ></path>
        <path
          d="M255.88,128a16.16,16.16,0,0,0-2.63.93,7.05,7.05,0,0,0-1.27.73,3,3,0,0,0-.93,1.15,1.51,1.51,0,0,0,.55,1.9,2.55,2.55,0,0,0,2.36-.1,5.12,5.12,0,0,0,1.95-1.77,8.51,8.51,0,0,0,1-2.11A2.28,2.28,0,0,1,255.88,128Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 253.91px 130.476px 0px",
          }}
          id="eltlerfk1ztn9"
          className="animable"
        ></path>
        <g id="elro3vu4sqc">
          <path
            d="M255.88,128a16.16,16.16,0,0,0-2.63.93,7.05,7.05,0,0,0-1.27.73,3,3,0,0,0-.93,1.15,1.51,1.51,0,0,0,.55,1.9,2.55,2.55,0,0,0,2.36-.1,5.12,5.12,0,0,0,1.95-1.77,8.51,8.51,0,0,0,1-2.11A2.28,2.28,0,0,1,255.88,128Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 253.91px 130.476px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M255.57,130.69a2.61,2.61,0,0,0,0,2.1,2.47,2.47,0,0,0,2.18,1.15,4,4,0,0,0,2.77-1.1,2.69,2.69,0,0,0,.88-1.9,2.52,2.52,0,0,0-.68-1.6,8,8,0,0,0-1.3-1.1,1.11,1.11,0,0,0-.54-.24,1.67,1.67,0,0,0-.61.13c-.58.2-1.35.33-1.69.8A9.19,9.19,0,0,0,255.57,130.69Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 258.375px 130.971px 0px",
          }}
          id="elf0botrkk5mu"
          className="animable"
        ></path>
        <g id="elnaaab812eq">
          <path
            d="M255.57,130.69a2.61,2.61,0,0,0,0,2.1,2.47,2.47,0,0,0,2.18,1.15,4,4,0,0,0,2.77-1.1,2.69,2.69,0,0,0,.88-1.9,2.52,2.52,0,0,0-.68-1.6,8,8,0,0,0-1.3-1.1,1.11,1.11,0,0,0-.54-.24,1.67,1.67,0,0,0-.61.13c-.58.2-1.35.33-1.69.8A9.19,9.19,0,0,0,255.57,130.69Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 258.375px 130.971px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M255.85,127c-1-.55-1.79-1.53-2.88-1.92a2.71,2.71,0,0,0-2.21.16,2.25,2.25,0,0,0-1.16,1.85,1.94,1.94,0,0,0,1.12,1.83,3.63,3.63,0,0,0,2,.06l3.16-.51C255.88,128,255.84,127.43,255.85,127Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 252.739px 127.004px 0px",
          }}
          id="elbngv1743sk6"
          className="animable"
        ></path>
        <g id="elgzjfyuxxn8p">
          <path
            d="M255.85,127c-1-.55-1.79-1.53-2.88-1.92a2.71,2.71,0,0,0-2.21.16,2.25,2.25,0,0,0-1.16,1.85,1.94,1.94,0,0,0,1.12,1.83,3.63,3.63,0,0,0,2,.06l3.16-.51C255.88,128,255.84,127.43,255.85,127Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 252.739px 127.004px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M258.41,126.09c.45-1.07.44-2.32,1-3.3a2.74,2.74,0,0,1,1.82-1.27,2.28,2.28,0,0,1,2.07.72,1.94,1.94,0,0,1,.27,2.13,3.49,3.49,0,0,1-1.52,1.29l-2.78,1.58C259,126.9,258.7,126.42,258.41,126.09Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 261.091px 124.364px 0px",
          }}
          id="eljm6qo9cugl9"
          className="animable"
        ></path>
        <g id="elvw1e5v237as">
          <path
            d="M258.41,126.09c.45-1.07.44-2.32,1-3.3a2.74,2.74,0,0,1,1.82-1.27,2.28,2.28,0,0,1,2.07.72,1.94,1.94,0,0,1,.27,2.13,3.49,3.49,0,0,1-1.52,1.29l-2.78,1.58C259,126.9,258.7,126.42,258.41,126.09Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 261.091px 124.364px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M259,126.9a16.46,16.46,0,0,1,2.64-.92,6.76,6.76,0,0,1,1.44-.22,3,3,0,0,1,1.45.31,1.51,1.51,0,0,1,.76,1.83,2.59,2.59,0,0,1-1.91,1.4,5.16,5.16,0,0,1-2.62-.17,8.66,8.66,0,0,1-2.09-1A2.31,2.31,0,0,0,259,126.9Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 262.019px 127.576px 0px",
          }}
          id="elfyyfpvbcyp7"
          className="animable"
        ></path>
        <path
          d="M254.22,126.08a3.39,3.39,0,0,1-1.18-2,2.63,2.63,0,0,1,.81-2.26,2.72,2.72,0,0,1,2.3-.68,2.76,2.76,0,0,1,1.72,1,3.66,3.66,0,0,1,.68,1.87,11.26,11.26,0,0,1,0,2,1.21,1.21,0,0,1-.19.65,1.23,1.23,0,0,1-.52.3c-.55.2-1.2.63-1.77.33A9.65,9.65,0,0,1,254.22,126.08Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 255.806px 124.247px 0px",
          }}
          id="ela7lj1ljazeu"
          className="animable"
        ></path>
        <g id="el9p1vibxzh17">
          <path
            d="M259,126.9a16.46,16.46,0,0,1,2.64-.92,6.76,6.76,0,0,1,1.44-.22,3,3,0,0,1,1.45.31,1.51,1.51,0,0,1,.76,1.83,2.59,2.59,0,0,1-1.91,1.4,5.16,5.16,0,0,1-2.62-.17,8.66,8.66,0,0,1-2.09-1A2.31,2.31,0,0,0,259,126.9Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 262.019px 127.576px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="eldefic6gmt68">
          <path
            d="M254.22,126.08a3.39,3.39,0,0,1-1.18-2,2.63,2.63,0,0,1,.81-2.26,2.72,2.72,0,0,1,2.3-.68,2.76,2.76,0,0,1,1.72,1,3.66,3.66,0,0,1,.68,1.87,11.26,11.26,0,0,1,0,2,1.21,1.21,0,0,1-.19.65,1.23,1.23,0,0,1-.52.3c-.55.2-1.2.63-1.77.33A9.65,9.65,0,0,1,254.22,126.08Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 255.806px 124.247px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M260.05,127c.36,1-.45,2.27-1.81,2.75a2.37,2.37,0,0,1-3.13-1c-.36-1,.44-2.27,1.81-2.75A2.37,2.37,0,0,1,260.05,127Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 257.58px 127.875px 0px",
          }}
          id="elwd8vqxxtwng"
          className="animable"
        ></path>
        <path
          d="M283.43,164.13a14.56,14.56,0,0,0-2.47,0,5.48,5.48,0,0,0-1.27.24,2.43,2.43,0,0,0-1.12.68,1.33,1.33,0,0,0-.1,1.75,2.29,2.29,0,0,0,2,.61,4.52,4.52,0,0,0,2.14-.91,7.67,7.67,0,0,0,1.44-1.47A2,2,0,0,1,283.43,164.13Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 281.119px 165.762px 0px",
          }}
          id="elstxualm6ez"
          className="animable"
        ></path>
        <g id="ela6rfo1lg1ff">
          <path
            d="M283.43,164.13a14.56,14.56,0,0,0-2.47,0,5.48,5.48,0,0,0-1.27.24,2.43,2.43,0,0,0-1.12.68,1.33,1.33,0,0,0-.1,1.75,2.29,2.29,0,0,0,2,.61,4.52,4.52,0,0,0,2.14-.91,7.67,7.67,0,0,0,1.44-1.47A2,2,0,0,1,283.43,164.13Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 281.119px 165.762px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M282.37,166.28a2.29,2.29,0,0,0-.63,1.75,2.17,2.17,0,0,0,1.47,1.6,3.62,3.62,0,0,0,2.65-.11,2.38,2.38,0,0,0,1.28-1.32,2.2,2.2,0,0,0-.1-1.54,7,7,0,0,0-.76-1.3.94.94,0,0,0-.38-.36,1.6,1.6,0,0,0-.54-.07,3.1,3.1,0,0,0-1.65.17A8.39,8.39,0,0,0,282.37,166.28Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 284.484px 167.358px 0px",
          }}
          id="elxd9rmyzdzl"
          className="animable"
        ></path>
        <g id="eltk2u8ezcv4">
          <path
            d="M282.37,166.28a2.29,2.29,0,0,0-.63,1.75,2.17,2.17,0,0,0,1.47,1.6,3.62,3.62,0,0,0,2.65-.11,2.38,2.38,0,0,0,1.28-1.32,2.2,2.2,0,0,0-.1-1.54,7,7,0,0,0-.76-1.3.94.94,0,0,0-.38-.36,1.6,1.6,0,0,0-.54-.07,3.1,3.1,0,0,0-1.65.17A8.39,8.39,0,0,0,282.37,166.28Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 284.484px 167.358px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M283.69,163.28c-.68-.76-1-1.81-1.83-2.45a2.4,2.4,0,0,0-1.89-.52,2,2,0,0,0-1.52,1.2,1.75,1.75,0,0,0,.4,1.86,3.09,3.09,0,0,0,1.65.63l2.78.5C283.42,164.14,283.55,163.64,283.69,163.28Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 281.013px 162.391px 0px",
          }}
          id="elhy2jc1o0tbe"
          className="animable"
        ></path>
        <g id="elhb2vexrf7mn">
          <path
            d="M283.69,163.28c-.68-.76-1-1.81-1.83-2.45a2.4,2.4,0,0,0-1.89-.52,2,2,0,0,0-1.52,1.2,1.75,1.75,0,0,0,.4,1.86,3.09,3.09,0,0,0,1.65.63l2.78.5C283.42,164.14,283.55,163.64,283.69,163.28Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 281.013px 162.391px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M286.1,163.28c.68-.76,1-1.81,1.83-2.45a2.4,2.4,0,0,1,1.89-.52,2,2,0,0,1,1.52,1.2,1.75,1.75,0,0,1-.4,1.86,3.09,3.09,0,0,1-1.65.63l-2.78.5C286.37,164.14,286.24,163.64,286.1,163.28Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 288.777px 162.391px 0px",
          }}
          id="elr0mvzeftaaa"
          className="animable"
        ></path>
        <g id="elk0wz6dnd19">
          <path
            d="M286.1,163.28c.68-.76,1-1.81,1.83-2.45a2.4,2.4,0,0,1,1.89-.52,2,2,0,0,1,1.52,1.2,1.75,1.75,0,0,1-.4,1.86,3.09,3.09,0,0,1-1.65.63l-2.78.5C286.37,164.14,286.24,163.64,286.1,163.28Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 288.777px 162.391px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M286.36,164.13a14.56,14.56,0,0,1,2.47,0,5.48,5.48,0,0,1,1.27.24,2.43,2.43,0,0,1,1.12.68,1.33,1.33,0,0,1,.1,1.75,2.29,2.29,0,0,1-2,.61,4.52,4.52,0,0,1-2.14-.91,7.67,7.67,0,0,1-1.44-1.47A2,2,0,0,0,286.36,164.13Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 288.671px 165.762px 0px",
          }}
          id="el5ghgac0pj9"
          className="animable"
        ></path>
        <path
          d="M282.6,162.05a3.06,3.06,0,0,1-.39-2,2.32,2.32,0,0,1,1.33-1.65,2.42,2.42,0,0,1,2.13.1,2.48,2.48,0,0,1,1.13,1.36,3.29,3.29,0,0,1,0,1.76,8.39,8.39,0,0,1-.62,1.67,1,1,0,0,1-.34.49,1.15,1.15,0,0,1-.52.1c-.52,0-1.19.17-1.58-.24A8.7,8.7,0,0,1,282.6,162.05Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 284.548px 161.058px 0px",
          }}
          id="elk98spyma4st"
          className="animable"
        ></path>
        <g id="elwdak63mpyh">
          <path
            d="M286.36,164.13a14.56,14.56,0,0,1,2.47,0,5.48,5.48,0,0,1,1.27.24,2.43,2.43,0,0,1,1.12.68,1.33,1.33,0,0,1,.1,1.75,2.29,2.29,0,0,1-2,.61,4.52,4.52,0,0,1-2.14-.91,7.67,7.67,0,0,1-1.44-1.47A2,2,0,0,0,286.36,164.13Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 288.671px 165.762px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el9vgr38jalno">
          <path
            d="M282.6,162.05a3.06,3.06,0,0,1-.39-2,2.32,2.32,0,0,1,1.33-1.65,2.42,2.42,0,0,1,2.13.1,2.48,2.48,0,0,1,1.13,1.36,3.29,3.29,0,0,1,0,1.76,8.39,8.39,0,0,1-.62,1.67,1,1,0,0,1-.34.49,1.15,1.15,0,0,1-.52.1c-.52,0-1.19.17-1.58-.24A8.7,8.7,0,0,1,282.6,162.05Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 284.548px 161.058px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elqym3qr409an">
          <path
            d="M291.22,165.06a2.43,2.43,0,0,0-1.12-.68,5.48,5.48,0,0,0-1.27-.24h-.26l.72-.13a3.09,3.09,0,0,0,1.65-.63,1.75,1.75,0,0,0,.4-1.86,2,2,0,0,0-1.52-1.2,2.4,2.4,0,0,0-1.89.52,11.07,11.07,0,0,0-1.61,2.15,8.07,8.07,0,0,0,.5-1.4,3.29,3.29,0,0,0,0-1.76,2.48,2.48,0,0,0-1.13-1.36,2.42,2.42,0,0,0-2.13-.1,2.32,2.32,0,0,0-1.33,1.65,2.57,2.57,0,0,0,.08,1.26,3.57,3.57,0,0,0-.43-.44,2.4,2.4,0,0,0-1.89-.52,2,2,0,0,0-1.52,1.2,1.75,1.75,0,0,0,.4,1.86,3.09,3.09,0,0,0,1.65.63l.72.13H281a5.48,5.48,0,0,0-1.27.24,2.43,2.43,0,0,0-1.12.68,1.33,1.33,0,0,0-.1,1.75,2.29,2.29,0,0,0,2,.61,4.11,4.11,0,0,0,1.49-.5,1.89,1.89,0,0,0-.22,1.11,2.17,2.17,0,0,0,1.47,1.6,3.62,3.62,0,0,0,2.65-.11,2.38,2.38,0,0,0,1.28-1.32,2.2,2.2,0,0,0-.1-1.54,3.4,3.4,0,0,0-.26-.5,4.55,4.55,0,0,0,2.54,1.26,2.29,2.29,0,0,0,2-.61A1.33,1.33,0,0,0,291.22,165.06ZM284,165a2.07,2.07,0,0,1-.56-.86h0c.07-.23.15-.46.23-.68l.12.15c.39.41,1.06.24,1.58.24a1.15,1.15,0,0,0,.52-.1.79.79,0,0,0,.27-.35c.09.23.17.49.25.74h0a2,2,0,0,1-.56.85,1.61,1.61,0,0,0-.44,0A4.8,4.8,0,0,0,284,165Z"
            style={{ opacity: "0.1", transformOrigin: " 284.926px 164px 0px" }}
            className="animable"
          ></path>
        </g>
        <path
          d="M287.21,164.48a2.4,2.4,0,1,1-2.32-1.77A2.1,2.1,0,0,1,287.21,164.48Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 284.894px 165.103px 0px",
          }}
          id="el0bikjyyeh6x"
          className="animable"
        ></path>
        <path
          d="M327.26,148.88a14.55,14.55,0,0,0-2.47,0,5.68,5.68,0,0,0-1.27.24,2.73,2.73,0,0,0-1.12.68,1.36,1.36,0,0,0-.09,1.76,2.28,2.28,0,0,0,2,.6,4.5,4.5,0,0,0,2.14-.91,7.32,7.32,0,0,0,1.43-1.47A2.09,2.09,0,0,1,327.26,148.88Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 324.955px 150.513px 0px",
          }}
          id="elcxt22j362o"
          className="animable"
        ></path>
        <g id="elycj1323vmr">
          <path
            d="M327.26,148.88a14.55,14.55,0,0,0-2.47,0,5.68,5.68,0,0,0-1.27.24,2.73,2.73,0,0,0-1.12.68,1.36,1.36,0,0,0-.09,1.76,2.28,2.28,0,0,0,2,.6,4.5,4.5,0,0,0,2.14-.91,7.32,7.32,0,0,0,1.43-1.47A2.09,2.09,0,0,1,327.26,148.88Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 324.955px 150.513px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M326.21,151a2.25,2.25,0,0,0-.63,1.74,2.14,2.14,0,0,0,1.47,1.6,3.54,3.54,0,0,0,2.64-.11,2.4,2.4,0,0,0,1.29-1.32,2.27,2.27,0,0,0-.1-1.54,6.84,6.84,0,0,0-.77-1.3.77.77,0,0,0-.38-.35,1.57,1.57,0,0,0-.54-.08c-.54,0-1.23-.12-1.64.18A8.39,8.39,0,0,0,326.21,151Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 328.322px 152.08px 0px",
          }}
          id="elnqvconegc7"
          className="animable"
        ></path>
        <g id="elaw85qh6jth">
          <path
            d="M326.21,151a2.25,2.25,0,0,0-.63,1.74,2.14,2.14,0,0,0,1.47,1.6,3.54,3.54,0,0,0,2.64-.11,2.4,2.4,0,0,0,1.29-1.32,2.27,2.27,0,0,0-.1-1.54,6.84,6.84,0,0,0-.77-1.3.77.77,0,0,0-.38-.35,1.57,1.57,0,0,0-.54-.08c-.54,0-1.23-.12-1.64.18A8.39,8.39,0,0,0,326.21,151Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 328.322px 152.08px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M327.53,148a20.28,20.28,0,0,0-1.83-2.45,2.45,2.45,0,0,0-1.89-.52,2,2,0,0,0-1.52,1.2,1.75,1.75,0,0,0,.4,1.86,3.09,3.09,0,0,0,1.65.63l2.78.5C327.26,148.88,327.39,148.38,327.53,148Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 324.853px 147.112px 0px",
          }}
          id="el4bqw20lvmda"
          className="animable"
        ></path>
        <g id="elscemqy7tisp">
          <path
            d="M327.53,148a20.28,20.28,0,0,0-1.83-2.45,2.45,2.45,0,0,0-1.89-.52,2,2,0,0,0-1.52,1.2,1.75,1.75,0,0,0,.4,1.86,3.09,3.09,0,0,0,1.65.63l2.78.5C327.26,148.88,327.39,148.38,327.53,148Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 324.853px 147.112px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M329.93,148c.69-.76,1-1.8,1.84-2.45a2.43,2.43,0,0,1,1.89-.52,2,2,0,0,1,1.51,1.2,1.71,1.71,0,0,1-.4,1.86,3.09,3.09,0,0,1-1.64.63l-2.79.5C330.2,148.88,330.07,148.38,329.93,148Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 332.61px 147.112px 0px",
          }}
          id="ell6cdk2q5b4"
          className="animable"
        ></path>
        <g id="eln7diaiu2xjr">
          <path
            d="M329.93,148c.69-.76,1-1.8,1.84-2.45a2.43,2.43,0,0,1,1.89-.52,2,2,0,0,1,1.51,1.2,1.71,1.71,0,0,1-.4,1.86,3.09,3.09,0,0,1-1.64.63l-2.79.5C330.2,148.88,330.07,148.38,329.93,148Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 332.61px 147.112px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M330.2,148.88a14.55,14.55,0,0,1,2.47,0,5.68,5.68,0,0,1,1.27.24,2.67,2.67,0,0,1,1.12.68,1.36,1.36,0,0,1,.09,1.76,2.26,2.26,0,0,1-2,.6,4.5,4.5,0,0,1-2.15-.91,7.61,7.61,0,0,1-1.43-1.47A2,2,0,0,0,330.2,148.88Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 332.5px 150.514px 0px",
          }}
          id="elyryv74nrq"
          className="animable"
        ></path>
        <path
          d="M326.43,146.79a3.06,3.06,0,0,1-.39-2,2.38,2.38,0,0,1,1.34-1.65,2.42,2.42,0,0,1,3.25,1.47,3.28,3.28,0,0,1,0,1.76A10.07,10.07,0,0,1,330,148a1,1,0,0,1-.35.49,1,1,0,0,1-.51.1c-.52,0-1.19.17-1.58-.24A8.41,8.41,0,0,1,326.43,146.79Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 328.379px 145.785px 0px",
          }}
          id="elbo48umkhf5f"
          className="animable"
        ></path>
        <g id="el7516dwbc1nc">
          <path
            d="M330.2,148.88a14.55,14.55,0,0,1,2.47,0,5.68,5.68,0,0,1,1.27.24,2.67,2.67,0,0,1,1.12.68,1.36,1.36,0,0,1,.09,1.76,2.26,2.26,0,0,1-2,.6,4.5,4.5,0,0,1-2.15-.91,7.61,7.61,0,0,1-1.43-1.47A2,2,0,0,0,330.2,148.88Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 332.5px 150.514px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elmlq3fbns2ra">
          <path
            d="M326.43,146.79a3.06,3.06,0,0,1-.39-2,2.38,2.38,0,0,1,1.34-1.65,2.42,2.42,0,0,1,3.25,1.47,3.28,3.28,0,0,1,0,1.76A10.07,10.07,0,0,1,330,148a1,1,0,0,1-.35.49,1,1,0,0,1-.51.1c-.52,0-1.19.17-1.58-.24A8.41,8.41,0,0,1,326.43,146.79Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 328.379px 145.785px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <ellipse
          cx="328.73"
          cy="149.22"
          rx="2.31"
          ry="1.76"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 328.73px 149.22px 0px",
          }}
          id="elthwy5m0rbf"
          className="animable"
        ></ellipse>
        <path
          d="M262.31,174.27a22.49,22.49,0,0,0-3.61-1.5,8.82,8.82,0,0,0-2-.43,4.15,4.15,0,0,0-2,.32,2.11,2.11,0,0,0-1.2,2.5,3.57,3.57,0,0,0,2.54,2.09,7.13,7.13,0,0,0,3.67,0,11.77,11.77,0,0,0,3-1.28A3.19,3.19,0,0,1,262.31,174.27Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 258.067px 174.907px 0px",
          }}
          id="el3uxmuqlfdsn"
          className="animable"
        ></path>
        <g id="eleomxr8df6tr">
          <path
            d="M262.31,174.27a22.49,22.49,0,0,0-3.61-1.5,8.82,8.82,0,0,0-2-.43,4.15,4.15,0,0,0-2,.32,2.11,2.11,0,0,0-1.2,2.5,3.57,3.57,0,0,0,2.54,2.09,7.13,7.13,0,0,0,3.67,0,11.77,11.77,0,0,0,3-1.28A3.19,3.19,0,0,1,262.31,174.27Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 258.067px 174.907px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M259.46,176.76a3.6,3.6,0,0,0-2,2.15,3.4,3.4,0,0,0,1.17,3.23,5.64,5.64,0,0,0,3.92,1.46,3.75,3.75,0,0,0,2.68-1.15,3.46,3.46,0,0,0,.79-2.3,10.91,10.91,0,0,0-.32-2.36,1.35,1.35,0,0,0-.34-.75,2.38,2.38,0,0,0-.74-.44c-.79-.33-1.72-.93-2.5-.74A13,13,0,0,0,259.46,176.76Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 261.713px 179.713px 0px",
          }}
          id="elmr3q4pz3tx"
          className="animable"
        ></path>
        <g id="elbef5nj0etkq">
          <path
            d="M259.46,176.76a3.6,3.6,0,0,0-2,2.15,3.4,3.4,0,0,0,1.17,3.23,5.64,5.64,0,0,0,3.92,1.46,3.75,3.75,0,0,0,2.68-1.15,3.46,3.46,0,0,0,.79-2.3,10.91,10.91,0,0,0-.32-2.36,1.35,1.35,0,0,0-.34-.75,2.38,2.38,0,0,0-.74-.44c-.79-.33-1.72-.93-2.5-.74A13,13,0,0,0,259.46,176.76Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 261.713px 179.713px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M263.22,173.18c-.53-1.53-.42-3.26-1.18-4.69a3.87,3.87,0,0,0-2.44-1.91,3.22,3.22,0,0,0-3,.83,2.75,2.75,0,0,0-.54,3,5,5,0,0,0,2,1.92l3.76,2.42C262.3,174.26,262.8,173.62,263.22,173.18Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 259.526px 170.621px 0px",
          }}
          id="eljutm6fbm1gt"
          className="animable"
        ></path>
        <g id="eloyfg7ecvkq">
          <path
            d="M263.22,173.18c-.53-1.53-.42-3.26-1.18-4.69a3.87,3.87,0,0,0-2.44-1.91,3.22,3.22,0,0,0-3,.83,2.75,2.75,0,0,0-.54,3,5,5,0,0,0,2,1.92l3.76,2.42C262.3,174.26,262.8,173.62,263.22,173.18Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 259.526px 170.621px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M266.72,174.64c1.46-.69,2.62-2,4.17-2.45a3.8,3.8,0,0,1,3.07.39,3.19,3.19,0,0,1,1.48,2.68,2.76,2.76,0,0,1-1.72,2.47,5,5,0,0,1-2.78-.09l-4.36-1C266.59,176.06,266.71,175.26,266.72,174.64Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 271.01px 174.956px 0px",
          }}
          id="elnhq93iejfkc"
          className="animable"
        ></path>
        <g id="elrztlvmyei1p">
          <path
            d="M266.72,174.64c1.46-.69,2.62-2,4.17-2.45a3.8,3.8,0,0,1,3.07.39,3.19,3.19,0,0,1,1.48,2.68,2.76,2.76,0,0,1-1.72,2.47,5,5,0,0,1-2.78-.09l-4.36-1C266.59,176.06,266.71,175.26,266.72,174.64Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 271.01px 174.956px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M266.59,176.06a21.63,21.63,0,0,1,3.6,1.51,9.26,9.26,0,0,1,1.71,1.11,4.1,4.1,0,0,1,1.21,1.69,2.09,2.09,0,0,1-.93,2.6,3.59,3.59,0,0,1-3.28-.33,7.17,7.17,0,0,1-2.57-2.62,12.09,12.09,0,0,1-1.2-3A3.12,3.12,0,0,0,266.59,176.06Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 269.194px 179.641px 0px",
          }}
          id="elbgj03xpu04p"
          className="animable"
        ></path>
        <path
          d="M262.37,170.71a4.85,4.85,0,0,1,.67-3.21,3.73,3.73,0,0,1,3-1.59,3.85,3.85,0,0,1,3,1.45,3.9,3.9,0,0,1,.82,2.67,5.13,5.13,0,0,1-1,2.58,15.49,15.49,0,0,1-1.91,2.06,1.2,1.2,0,0,1-1.62.33c-.77-.31-1.84-.47-2.15-1.31A13.31,13.31,0,0,1,262.37,170.71Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 266.096px 170.546px 0px",
          }}
          id="elvansoqjpugc"
          className="animable"
        ></path>
        <g id="el192rxggzr5a">
          <path
            d="M266.59,176.06a21.63,21.63,0,0,1,3.6,1.51,9.26,9.26,0,0,1,1.71,1.11,4.1,4.1,0,0,1,1.21,1.69,2.09,2.09,0,0,1-.93,2.6,3.59,3.59,0,0,1-3.28-.33,7.17,7.17,0,0,1-2.57-2.62,12.09,12.09,0,0,1-1.2-3A3.12,3.12,0,0,0,266.59,176.06Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 269.194px 179.641px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el84izp8216h5">
          <path
            d="M262.37,170.71a4.85,4.85,0,0,1,.67-3.21,3.73,3.73,0,0,1,3-1.59,3.85,3.85,0,0,1,3,1.45,3.9,3.9,0,0,1,.82,2.67,5.13,5.13,0,0,1-1,2.58,15.49,15.49,0,0,1-1.91,2.06,1.2,1.2,0,0,1-1.62.33c-.77-.31-1.84-.47-2.15-1.31A13.31,13.31,0,0,1,262.37,170.71Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 266.096px 170.546px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M267.62,177.07c-.6,1.42-2.59,1.94-4.45,1.16s-2.9-2.56-2.3-4,2.58-1.94,4.45-1.16S268.21,175.65,267.62,177.07Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 264.244px 175.648px 0px",
          }}
          id="elzu6xxxbrtij"
          className="animable"
        ></path>
        <path
          d="M247,147.65a22.89,22.89,0,0,0-3.6-1.49,8.79,8.79,0,0,0-2-.43,3.91,3.91,0,0,0-2,.32,2.11,2.11,0,0,0-1.21,2.49,3.6,3.6,0,0,0,2.55,2.1,7.13,7.13,0,0,0,3.67,0,11.71,11.71,0,0,0,3-1.27A3.25,3.25,0,0,1,247,147.65Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 242.763px 148.295px 0px",
          }}
          id="el9gidp7wxks"
          className="animable"
        ></path>
        <path
          d="M244.18,150.15a3.57,3.57,0,0,0-2,2.15,3.39,3.39,0,0,0,1.17,3.23,5.63,5.63,0,0,0,3.92,1.45,3.76,3.76,0,0,0,2.68-1.14,3.53,3.53,0,0,0,.79-2.3,11.09,11.09,0,0,0-.32-2.37,1.46,1.46,0,0,0-.34-.75,2.41,2.41,0,0,0-.75-.43c-.78-.34-1.71-.93-2.5-.75A12.56,12.56,0,0,0,244.18,150.15Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 246.432px 153.094px 0px",
          }}
          id="elnzy92hjc7u"
          className="animable"
        ></path>
        <g id="elkb2lxqmq1or">
          <path
            d="M244.18,150.15a3.57,3.57,0,0,0-2,2.15,3.39,3.39,0,0,0,1.17,3.23,5.63,5.63,0,0,0,3.92,1.45,3.76,3.76,0,0,0,2.68-1.14,3.53,3.53,0,0,0,.79-2.3,11.09,11.09,0,0,0-.32-2.37,1.46,1.46,0,0,0-.34-.75,2.41,2.41,0,0,0-.75-.43c-.78-.34-1.71-.93-2.5-.75A12.56,12.56,0,0,0,244.18,150.15Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 246.432px 153.094px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M247.94,146.56c-.54-1.52-.42-3.26-1.19-4.68a3.76,3.76,0,0,0-2.44-1.91,3.16,3.16,0,0,0-2.94.83,2.75,2.75,0,0,0-.55,3,5.12,5.12,0,0,0,2,1.92l3.75,2.42C247,147.65,247.51,147,247.94,146.56Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 244.268px 144.014px 0px",
          }}
          id="el01odip1ynrry"
          className="animable"
        ></path>
        <g id="elwyhshnulcre">
          <path
            d="M247.94,146.56c-.54-1.52-.42-3.26-1.19-4.68a3.76,3.76,0,0,0-2.44-1.91,3.16,3.16,0,0,0-2.94.83,2.75,2.75,0,0,0-.55,3,5.12,5.12,0,0,0,2,1.92l3.75,2.42C247,147.65,247.51,147,247.94,146.56Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 244.268px 144.014px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M251.44,148c1.46-.69,2.61-2,4.17-2.44a3.8,3.8,0,0,1,3.07.39,3.18,3.18,0,0,1,1.48,2.67,2.74,2.74,0,0,1-1.72,2.47,5.07,5.07,0,0,1-2.78-.08l-4.36-1C251.31,149.44,251.42,148.64,251.44,148Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 255.73px 148.322px 0px",
          }}
          id="elr1jb08hj2d"
          className="animable"
        ></path>
        <g id="eljc6odmo19ws">
          <path
            d="M251.44,148c1.46-.69,2.61-2,4.17-2.44a3.8,3.8,0,0,1,3.07.39,3.18,3.18,0,0,1,1.48,2.67,2.74,2.74,0,0,1-1.72,2.47,5.07,5.07,0,0,1-2.78-.08l-4.36-1C251.31,149.44,251.42,148.64,251.44,148Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 255.73px 148.322px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M251.31,149.44A22,22,0,0,1,254.9,151a9.57,9.57,0,0,1,1.72,1.12,4.14,4.14,0,0,1,1.21,1.68,2.13,2.13,0,0,1-.93,2.61,3.58,3.58,0,0,1-3.28-.33,7.12,7.12,0,0,1-2.57-2.63,11.66,11.66,0,0,1-1.2-3A3.11,3.11,0,0,0,251.31,149.44Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 253.911px 153.051px 0px",
          }}
          id="elu0h8q1h2zwh"
          className="animable"
        ></path>
        <path
          d="M247.09,144.1a4.78,4.78,0,0,1,.67-3.21,3.7,3.7,0,0,1,3-1.59,3.82,3.82,0,0,1,3.85,4.12,5.15,5.15,0,0,1-1,2.58,14.31,14.31,0,0,1-1.92,2.05,1.2,1.2,0,0,1-1.62.33c-.76-.3-1.83-.47-2.14-1.31A12.71,12.71,0,0,1,247.09,144.1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 250.831px 143.931px 0px",
          }}
          id="elikevt6ku42l"
          className="animable"
        ></path>
        <path
          d="M252.33,150.45c-.59,1.42-2.58,1.94-4.45,1.17s-2.89-2.56-2.29-4,2.58-1.94,4.44-1.16S252.93,149,252.33,150.45Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 248.959px 149.035px 0px",
          }}
          id="elggatq61za2k"
          className="animable"
        ></path>
        <path
          d="M305.47,143.69a22.77,22.77,0,0,0-3.78,1,8.63,8.63,0,0,0-1.86.84,4.11,4.11,0,0,0-1.45,1.48,2.11,2.11,0,0,0,.52,2.72,3.63,3.63,0,0,0,3.3.17,7.24,7.24,0,0,0,2.93-2.21,11.94,11.94,0,0,0,1.64-2.81A3.18,3.18,0,0,1,305.47,143.69Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 302.432px 146.954px 0px",
          }}
          id="el1kcop09sz5a"
          className="animable"
        ></path>
        <g id="elqpcvb1m2trl">
          <path
            d="M305.47,143.69a22.77,22.77,0,0,0-3.78,1,8.63,8.63,0,0,0-1.86.84,4.11,4.11,0,0,0-1.45,1.48,2.11,2.11,0,0,0,.52,2.72,3.63,3.63,0,0,0,3.3.17,7.24,7.24,0,0,0,2.93-2.21,11.94,11.94,0,0,0,1.64-2.81A3.18,3.18,0,0,1,305.47,143.69Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 302.432px 146.954px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M304.68,147.39a3.58,3.58,0,0,0-.31,2.91,3.43,3.43,0,0,0,2.88,1.89,5.66,5.66,0,0,0,4-1.18,3.74,3.74,0,0,0,1.46-2.52,3.5,3.5,0,0,0-.74-2.31,10.81,10.81,0,0,0-1.67-1.71,1.37,1.37,0,0,0-.72-.39,2.3,2.3,0,0,0-.86.09c-.83.2-1.93.28-2.45.9A13,13,0,0,0,304.68,147.39Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 308.454px 148.142px 0px",
          }}
          id="elli15d4b8nxd"
          className="animable"
        ></path>
        <path
          d="M305.55,142.27c-1.34-.9-2.28-2.36-3.75-3.05a3.85,3.85,0,0,0-3.1-.07,3.19,3.19,0,0,0-1.86,2.43,2.73,2.73,0,0,0,1.33,2.69,5,5,0,0,0,2.76.34l4.46-.3C305.46,143.69,305.47,142.88,305.55,142.27Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 301.185px 141.766px 0px",
          }}
          id="ela5bt64hd21e"
          className="animable"
        ></path>
        <path
          d="M309.23,141.35c.76-1.43.9-3.16,1.88-4.45a3.76,3.76,0,0,1,2.69-1.52,3.17,3.17,0,0,1,2.79,1.26,2.75,2.75,0,0,1,.1,3,5,5,0,0,1-2.28,1.6l-4.08,1.83C310,142.56,309.59,141.86,309.23,141.35Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 313.158px 139.22px 0px",
          }}
          id="eld0d6i39arl"
          className="animable"
        ></path>
        <path
          d="M310,142.56a22.8,22.8,0,0,1,3.79-.93,9.22,9.22,0,0,1,2-.13,4,4,0,0,1,2,.62,2.11,2.11,0,0,1,.82,2.65,3.6,3.6,0,0,1-2.83,1.7,7.33,7.33,0,0,1-3.63-.57,12.24,12.24,0,0,1-2.77-1.71A3.09,3.09,0,0,0,310,142.56Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 314.086px 143.998px 0px",
          }}
          id="ela5yh2adf7nw"
          className="animable"
        ></path>
        <path
          d="M303.4,140.81a4.81,4.81,0,0,1-1.38-3,3.7,3.7,0,0,1,1.41-3,3.82,3.82,0,0,1,3.3-.65,3.87,3.87,0,0,1,2.25,1.65,5.13,5.13,0,0,1,.71,2.69,14.61,14.61,0,0,1-.3,2.79,1.6,1.6,0,0,1-.35.88,1.58,1.58,0,0,1-.75.35c-.8.21-1.76.72-2.51.23A13,13,0,0,1,303.4,140.81Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 305.855px 138.493px 0px",
          }}
          id="elb7d196nfcrg"
          className="animable"
        ></path>
        <g id="el8ty4iz1p53s">
          <path
            d="M310,142.56a22.8,22.8,0,0,1,3.79-.93,9.22,9.22,0,0,1,2-.13,4,4,0,0,1,2,.62,2.11,2.11,0,0,1,.82,2.65,3.6,3.6,0,0,1-2.83,1.7,7.33,7.33,0,0,1-3.63-.57,12.24,12.24,0,0,1-2.77-1.71A3.09,3.09,0,0,0,310,142.56Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 314.086px 143.998px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el6chik55gr9e">
          <path
            d="M303.4,140.81a4.81,4.81,0,0,1-1.38-3,3.7,3.7,0,0,1,1.41-3,3.82,3.82,0,0,1,3.3-.65,3.87,3.87,0,0,1,2.25,1.65,5.13,5.13,0,0,1,.71,2.69,14.61,14.61,0,0,1-.3,2.79,1.6,1.6,0,0,1-.35.88,1.58,1.58,0,0,1-.75.35c-.8.21-1.76.72-2.51.23A13,13,0,0,1,303.4,140.81Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 305.855px 138.493px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M311.4,142.76c.37,1.5-.91,3.1-2.87,3.59s-3.85-.32-4.23-1.81.92-3.1,2.87-3.59S311,141.27,311.4,142.76Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 307.849px 143.65px 0px",
          }}
          id="elthbd6a7ltxb"
          className="animable"
        ></path>
        <path
          d="M287.63,187a22,22,0,0,0-3.78,1,8.67,8.67,0,0,0-1.86.85,4,4,0,0,0-1.45,1.48,2.1,2.1,0,0,0,.53,2.72,3.58,3.58,0,0,0,3.29.16,7.09,7.09,0,0,0,2.93-2.21,11.94,11.94,0,0,0,1.64-2.81A3.09,3.09,0,0,1,287.63,187Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 284.592px 190.268px 0px",
          }}
          id="elrv9hfbd3j0g"
          className="animable"
        ></path>
        <path
          d="M286.84,190.67a3.56,3.56,0,0,0-.3,2.92,3.42,3.42,0,0,0,2.87,1.89,5.66,5.66,0,0,0,4-1.18,3.74,3.74,0,0,0,1.46-2.52,3.52,3.52,0,0,0-.74-2.32,11.19,11.19,0,0,0-1.67-1.7,1.38,1.38,0,0,0-.72-.4,2.35,2.35,0,0,0-.86.1c-.83.19-1.93.28-2.45.89A13,13,0,0,0,286.84,190.67Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 290.615px 191.429px 0px",
          }}
          id="el1ztqi5ems87"
          className="animable"
        ></path>
        <g id="elnqcs4k6v0c">
          <path
            d="M286.84,190.67a3.56,3.56,0,0,0-.3,2.92,3.42,3.42,0,0,0,2.87,1.89,5.66,5.66,0,0,0,4-1.18,3.74,3.74,0,0,0,1.46-2.52,3.52,3.52,0,0,0-.74-2.32,11.19,11.19,0,0,0-1.67-1.7,1.38,1.38,0,0,0-.72-.4,2.35,2.35,0,0,0-.86.1c-.83.19-1.93.28-2.45.89A13,13,0,0,0,286.84,190.67Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 290.615px 191.429px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M287.71,185.56c-1.34-.91-2.28-2.37-3.75-3.05a3.77,3.77,0,0,0-3.1-.07,3.18,3.18,0,0,0-1.86,2.42,2.74,2.74,0,0,0,1.33,2.7,5,5,0,0,0,2.76.33l4.46-.3C287.63,187,287.64,186.17,287.71,185.56Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 283.344px 185.048px 0px",
          }}
          id="eladi6iiq49v8"
          className="animable"
        ></path>
        <g id="el7se116lnvfv">
          <path
            d="M287.71,185.56c-1.34-.91-2.28-2.37-3.75-3.05a3.77,3.77,0,0,0-3.1-.07,3.18,3.18,0,0,0-1.86,2.42,2.74,2.74,0,0,0,1.33,2.7,5,5,0,0,0,2.76.33l4.46-.3C287.63,187,287.64,186.17,287.71,185.56Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 283.344px 185.048px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M291.39,184.64c.76-1.43.91-3.17,1.88-4.46a3.79,3.79,0,0,1,2.7-1.52,3.16,3.16,0,0,1,2.78,1.26,2.74,2.74,0,0,1,.1,3,5,5,0,0,1-2.28,1.59l-4.08,1.83C292.14,185.85,291.75,185.14,291.39,184.64Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 295.319px 182.495px 0px",
          }}
          id="el61rn2ov111o"
          className="animable"
        ></path>
        <g id="elca59fje3jw">
          <path
            d="M291.39,184.64c.76-1.43.91-3.17,1.88-4.46a3.79,3.79,0,0,1,2.7-1.52,3.16,3.16,0,0,1,2.78,1.26,2.74,2.74,0,0,1,.1,3,5,5,0,0,1-2.28,1.59l-4.08,1.83C292.14,185.85,291.75,185.14,291.39,184.64Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 295.319px 182.495px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M292.13,185.85a22.82,22.82,0,0,1,3.79-.94,9.22,9.22,0,0,1,2-.13,4.21,4.21,0,0,1,2,.63,2.12,2.12,0,0,1,.81,2.65,3.59,3.59,0,0,1-2.83,1.69,7.12,7.12,0,0,1-3.63-.57,11.62,11.62,0,0,1-2.76-1.71A3.16,3.16,0,0,0,292.13,185.85Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 296.21px 187.28px 0px",
          }}
          id="ely6s3f3p526c"
          className="animable"
        ></path>
        <path
          d="M285.56,184.09a4.81,4.81,0,0,1-1.38-3,3.72,3.72,0,0,1,1.42-3,3.84,3.84,0,0,1,3.3-.65,3.89,3.89,0,0,1,2.24,1.65,5.17,5.17,0,0,1,.72,2.69,15.38,15.38,0,0,1-.31,2.79,1.57,1.57,0,0,1-.35.88,1.64,1.64,0,0,1-.75.36c-.8.21-1.76.72-2.51.23A13.4,13.4,0,0,1,285.56,184.09Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 288.02px 181.779px 0px",
          }}
          id="el0mgrwowblwkm"
          className="animable"
        ></path>
        <path
          d="M293.56,186.05c.37,1.49-.91,3.1-2.87,3.59s-3.85-.32-4.23-1.82.92-3.1,2.88-3.59S293.19,184.55,293.56,186.05Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 290.009px 186.935px 0px",
          }}
          id="el8y7t8lsxth8"
          className="animable"
        ></path>
        <path
          d="M307.71,168.43a28.86,28.86,0,0,0-4.76,1.2,11.2,11.2,0,0,0-2.34,1.07,5.14,5.14,0,0,0-1.82,1.86,2.66,2.66,0,0,0,.66,3.42,4.53,4.53,0,0,0,4.15.21,9,9,0,0,0,3.69-2.78,14.79,14.79,0,0,0,2.06-3.54A4,4,0,0,1,307.71,168.43Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 303.892px 172.512px 0px",
          }}
          id="eldvsvubzzz5"
          className="animable"
        ></path>
        <g id="elw8gpe018oje">
          <path
            d="M307.71,168.43a28.86,28.86,0,0,0-4.76,1.2,11.2,11.2,0,0,0-2.34,1.07,5.14,5.14,0,0,0-1.82,1.86,2.66,2.66,0,0,0,.66,3.42,4.53,4.53,0,0,0,4.15.21,9,9,0,0,0,3.69-2.78,14.79,14.79,0,0,0,2.06-3.54A4,4,0,0,1,307.71,168.43Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 303.892px 172.512px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M306.72,173.08a4.51,4.51,0,0,0-.38,3.67,4.28,4.28,0,0,0,3.61,2.38,7.11,7.11,0,0,0,5.05-1.49,4.71,4.71,0,0,0,1.84-3.17,4.37,4.37,0,0,0-.94-2.91,13.71,13.71,0,0,0-2.09-2.15,1.84,1.84,0,0,0-.91-.5,3.1,3.1,0,0,0-1.08.12c-1,.25-2.43.36-3.08,1.13A16.37,16.37,0,0,0,306.72,173.08Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 311.479px 174.032px 0px",
          }}
          id="elv1eccq9xy0b"
          className="animable"
        ></path>
        <g id="el6kxo1awz6gk">
          <path
            d="M306.72,173.08a4.51,4.51,0,0,0-.38,3.67,4.28,4.28,0,0,0,3.61,2.38,7.11,7.11,0,0,0,5.05-1.49,4.71,4.71,0,0,0,1.84-3.17,4.37,4.37,0,0,0-.94-2.91,13.71,13.71,0,0,0-2.09-2.15,1.84,1.84,0,0,0-.91-.5,3.1,3.1,0,0,0-1.08.12c-1,.25-2.43.36-3.08,1.13A16.37,16.37,0,0,0,306.72,173.08Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 311.479px 174.032px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M307.82,166.64c-1.69-1.13-2.88-3-4.72-3.83a4.74,4.74,0,0,0-3.9-.09,4,4,0,0,0-2.34,3.05,3.42,3.42,0,0,0,1.67,3.39,6.26,6.26,0,0,0,3.47.42l5.61-.38C307.71,168.43,307.72,167.41,307.82,166.64Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 302.326px 166.003px 0px",
          }}
          id="elgrm5j5hymqf"
          className="animable"
        ></path>
        <g id="elrrrm6tclpr">
          <path
            d="M307.82,166.64c-1.69-1.13-2.88-3-4.72-3.83a4.74,4.74,0,0,0-3.9-.09,4,4,0,0,0-2.34,3.05,3.42,3.42,0,0,0,1.67,3.39,6.26,6.26,0,0,0,3.47.42l5.61-.38C307.71,168.43,307.72,167.41,307.82,166.64Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 302.326px 166.003px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M312.45,165.48c.95-1.79,1.13-4,2.36-5.6a4.79,4.79,0,0,1,3.4-1.92,4,4,0,0,1,3.5,1.59,3.46,3.46,0,0,1,.12,3.79,6.26,6.26,0,0,1-2.87,2l-5.13,2.31C313.39,167,312.89,166.12,312.45,165.48Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 317.394px 162.799px 0px",
          }}
          id="elcoilfzjgkid"
          className="animable"
        ></path>
        <g id="ell2ox4onf4u">
          <path
            d="M312.45,165.48c.95-1.79,1.13-4,2.36-5.6a4.79,4.79,0,0,1,3.4-1.92,4,4,0,0,1,3.5,1.59,3.46,3.46,0,0,1,.12,3.79,6.26,6.26,0,0,1-2.87,2l-5.13,2.31C313.39,167,312.89,166.12,312.45,165.48Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 317.394px 162.799px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M313.38,167a28.16,28.16,0,0,1,4.77-1.17,10.89,10.89,0,0,1,2.56-.17,5.19,5.19,0,0,1,2.49.79,2.66,2.66,0,0,1,1,3.33,4.52,4.52,0,0,1-3.56,2.13,9.1,9.1,0,0,1-4.57-.71,14.77,14.77,0,0,1-3.48-2.16A4,4,0,0,0,313.38,167Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 318.511px 168.802px 0px",
          }}
          id="elhq5shdt9us"
          className="animable"
        ></path>
        <path
          d="M305.1,164.8a6.06,6.06,0,0,1-1.73-3.75,4.65,4.65,0,0,1,1.78-3.82,4.84,4.84,0,0,1,4.16-.83,5,5,0,0,1,2.83,2.09,6.41,6.41,0,0,1,.89,3.38,18.85,18.85,0,0,1-.38,3.51,2.06,2.06,0,0,1-.44,1.11,2,2,0,0,1-.95.44c-1,.27-2.21.91-3.15.3A16.78,16.78,0,0,1,305.1,164.8Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 308.199px 161.863px 0px",
          }}
          id="el9yuvxc1jk8"
          className="animable"
        ></path>
        <g id="ele7c46d7jc9">
          <path
            d="M313.38,167a28.16,28.16,0,0,1,4.77-1.17,10.89,10.89,0,0,1,2.56-.17,5.19,5.19,0,0,1,2.49.79,2.66,2.66,0,0,1,1,3.33,4.52,4.52,0,0,1-3.56,2.13,9.1,9.1,0,0,1-4.57-.71,14.77,14.77,0,0,1-3.48-2.16A4,4,0,0,0,313.38,167Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 318.511px 168.802px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elyym4aor110d">
          <path
            d="M305.1,164.8a6.06,6.06,0,0,1-1.73-3.75,4.65,4.65,0,0,1,1.78-3.82,4.84,4.84,0,0,1,4.16-.83,5,5,0,0,1,2.83,2.09,6.41,6.41,0,0,1,.89,3.38,18.85,18.85,0,0,1-.38,3.51,2.06,2.06,0,0,1-.44,1.11,2,2,0,0,1-.95.44c-1,.27-2.21.91-3.15.3A16.78,16.78,0,0,1,305.1,164.8Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 308.199px 161.863px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M315.18,167.26c.47,1.88-1.15,3.9-3.62,4.52s-4.84-.41-5.31-2.29,1.14-3.9,3.61-4.51S314.71,165.38,315.18,167.26Z"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 310.715px 168.381px 0px",
          }}
          id="ely2bvfdw7cc"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--flowers-5--inject-18"
        style={{ transformOrigin: " 366.106px 215.906px 0px" }}
        className="animable"
      >
        <path
          d="M402,214.72l-33.95,1-33.95-1c-.33,5.13-.36,27.57-.14,32.62.77,17.45,4.54,33.51,9.33,42.36h0a15.48,15.48,0,0,0,6.72,6.84c10,5.78,26.2,5.78,36.16,0,3.45-2,5.67-4.45,6.71-7,4.75-8.89,8.47-24.84,9.23-42.19C402.35,242.29,402.32,219.85,402,214.72Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 368.044px 257.798px 0px",
          }}
          id="eldux63i43e5"
          className="animable"
        ></path>
        <g id="ellyu85z48cpr">
          <path
            d="M402,214.72l-33.95,1-33.95-1c-.33,5.13-.36,27.57-.14,32.62.77,17.45,4.54,33.51,9.33,42.36h0a15.48,15.48,0,0,0,6.72,6.84c10,5.78,26.2,5.78,36.16,0,3.45-2,5.67-4.45,6.71-7,4.75-8.89,8.47-24.84,9.23-42.19C402.35,242.29,402.32,219.85,402,214.72Z"
            style={{
              opacity: "0.4",
              transformOrigin: " 368.044px 257.798px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M392,200.81c13.31,7.68,13.38,20.13.16,27.81s-34.71,7.68-48,0-13.37-20.13-.15-27.81S378.67,193.13,392,200.81Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 368.086px 214.715px 0px",
          }}
          id="el7w73oyc9y3f"
          className="animable"
        ></path>
        <g id="elp0yz2b7q9gd">
          <g
            style={{
              opacity: "0.2",
              transformOrigin: " 368.086px 214.715px 0px",
            }}
            className="animable"
          >
            <path
              d="M392,200.81c13.31,7.68,13.38,20.13.16,27.81s-34.71,7.68-48,0-13.37-20.13-.15-27.81S378.67,193.13,392,200.81Z"
              id="el3vv382rbrxn"
              style={{ transformOrigin: " 368.086px 214.715px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M388.14,203c11.18,6.45,11.23,16.9.14,23.35s-29.16,6.45-40.33,0-11.23-16.9-.13-23.35S377,196.59,388.14,203Z"
          style={{
            fill: " rgb(55, 71, 79)",
            transformOrigin: " 368.048px 214.683px 0px",
          }}
          id="elqdded5kuwl"
          className="animable"
        ></path>
        <path
          d="M354.52,209.38c-.68.35-2,1-3.34,1.63a14,14,0,0,1-4.17,1.2,8.52,8.52,0,0,1-4.13-.63,14.14,14.14,0,0,1-3.78-2.66c-1.37-1.23-3-2.8-4.11-3.8s-1.8-1.44-1.89-1.75.37-.45,2-.8,4.39-.87,6.59-1.2a17.3,17.3,0,0,1,5.27-.19,10.35,10.35,0,0,1,3.65,1.38,6,6,0,0,1,2.07,1.93c.56.84,1.09,2,1.55,2.8a10.81,10.81,0,0,0,1,1.5c.17.23.14.24.09.24s-.12,0-.81.35Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 344.224px 206.656px 0px",
          }}
          id="elptyiy7wg2vf"
          className="animable"
        ></path>
        <path
          d="M354.52,209.38c-.68.35-2,1-3.34,1.63a14,14,0,0,1-4.17,1.2,8.52,8.52,0,0,1-4.13-.63,14.14,14.14,0,0,1-3.78-2.66c-1.37-1.23-3-2.8-4.11-3.8a15.48,15.48,0,0,1-1.85-1.66,11.12,11.12,0,0,1,2.59.47c1.48.48,2.86,1.36,4.42,2a21.5,21.5,0,0,0,5,1.2c1.75.22,3.53.33,5.28.63a32.54,32.54,0,0,1,4.58,1.15l.33.11s0,0,0,0-.12,0-.81.35Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 344.24px 207.855px 0px",
          }}
          id="ela0igisqa9mv"
          className="animable"
        ></path>
        <g id="eljk7cpflnsjf">
          <path
            d="M342.11,206.73a2,2,0,0,0-1.15.16,4.69,4.69,0,0,0-1.26.84c-.23.2-.2.18.06,0a7.92,7.92,0,0,1,1.24-.61,6.44,6.44,0,0,0,1.11-.43Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 340.827px 207.281px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="eli98c0iluh1">
          <path
            d="M345.86,207.7a2,2,0,0,0-1.14.25,4.3,4.3,0,0,0-1.18.94c-.22.21-.18.18,0,0a9.91,9.91,0,0,1,1.19-.7,6.17,6.17,0,0,0,1.08-.51Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 344.625px 208.358px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el7v2jtf0taas">
          <path
            d="M349.74,208.41a1.93,1.93,0,0,0-1.14.24,4.54,4.54,0,0,0-1.19.94c-.2.22-.18.19.06,0a9.84,9.84,0,0,1,1.19-.69,7.09,7.09,0,0,0,1.08-.51Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 348.507px 209.067px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elawo91e9moi8">
          <path
            d="M342.26,205.87c0,.06-.57-.22-1-.66a4.54,4.54,0,0,1-.74-1.32c-.11-.28-.1-.24.06,0a10.39,10.39,0,0,0,.84,1.11c.38.41.83.81.8.87Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 341.354px 204.786px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elxjjdahxg8m">
          <path
            d="M346.33,206.66c0,.06-.57-.22-1-.66a4.54,4.54,0,0,1-.74-1.32c-.11-.28-.1-.24.07,0a8.94,8.94,0,0,0,.83,1.1,6.82,6.82,0,0,1,.8.88Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 345.424px 205.576px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elem6lslq8y4r">
          <path
            d="M349.72,207.13c0,.06-.56-.22-1-.66a4.8,4.8,0,0,1-.74-1.32c-.11-.28-.09-.24.06,0a9.53,9.53,0,0,0,.84,1.1c.38.42.84.82.79.88Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 348.815px 206.046px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elhh1i2ovygcw">
          <path
            d="M355.37,209h0a1.67,1.67,0,0,0-.13-.21,10.81,10.81,0,0,1-1-1.5c-.46-.81-1-2-1.55-2.8a6,6,0,0,0-2.07-1.93,10.35,10.35,0,0,0-3.65-1.38,17.3,17.3,0,0,0-5.27.19c-2.2.33-5,.86-6.59,1.2s-2.09.51-2,.8a.36.36,0,0,0,0,.09h0v0l0,.05.07.08.06.07.08.08.1.09.07.06c.32.28.79.66,1.42,1.21,1.13,1,2.74,2.57,4.11,3.8a14.14,14.14,0,0,0,3.78,2.66,8.52,8.52,0,0,0,4.13.63,14,14,0,0,0,4.17-1.2c1.35-.59,2.66-1.28,3.34-1.63s.76-.35.81-.35h0S355.37,209,355.37,209Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.3",
              transformOrigin: " 344.235px 206.646px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M355.32,205.62c.24-.73.68-2.14,1.21-3.52a14.4,14.4,0,0,1,2.1-3.79,8.51,8.51,0,0,1,3.37-2.47,14.1,14.1,0,0,1,4.55-.8c1.84-.1,4.09-.13,5.6-.22a10,10,0,0,1,2.57-.1c.28.14.06.59-.84,2s-2.49,3.72-3.81,5.5a17.19,17.19,0,0,1-3.59,3.87,10.6,10.6,0,0,1-3.56,1.6,6.05,6.05,0,0,1-2.83.1c-1-.2-2.18-.63-3.08-.88a11.52,11.52,0,0,0-1.77-.35c-.29,0-.28-.06-.24-.1s.09-.08.32-.82Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 364.907px 201.296px 0px",
          }}
          id="eltm36gsumbig"
          className="animable"
        ></path>
        <path
          d="M355.32,205.62c.24-.73.68-2.14,1.21-3.52a14.4,14.4,0,0,1,2.1-3.79,8.51,8.51,0,0,1,3.37-2.47,14.1,14.1,0,0,1,4.55-.8c1.84-.1,4.09-.13,5.6-.22a18.39,18.39,0,0,1,2.48-.14,10.54,10.54,0,0,1-2.16,1.5c-1.39.72-3,1.07-4.53,1.73a21.14,21.14,0,0,0-4.4,2.71c-1.4,1.08-2.73,2.27-4.18,3.29a33.58,33.58,0,0,1-4.06,2.43l-.31.15s0,0,0-.05.09-.08.32-.82Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 364.81px 200.584px 0px",
          }}
          id="el9sxc6nui0tf"
          className="animable"
        ></path>
        <g id="el8ujwornqzni">
          <path
            d="M366,198.71c.06,0,.47-.39.71-.92a4.68,4.68,0,0,0,.29-1.48c0-.31,0-.27-.06,0a11.5,11.5,0,0,1-.45,1.31,7.28,7.28,0,0,0-.49,1.08Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 366.5px 197.401px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elgru21i6fc9">
          <path
            d="M362.64,200.68a1.93,1.93,0,0,0,.63-1,4.41,4.41,0,0,0,.17-1.5c0-.3,0-.26-.06,0a8.9,8.9,0,0,1-.35,1.33,6.33,6.33,0,0,0-.39,1.12Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 363.044px 199.325px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elywbbt1okg7">
          <path
            d="M359.39,202.93c.07,0,.45-.43.64-1a4.7,4.7,0,0,0,.17-1.5c0-.3,0-.26-.05,0a11.24,11.24,0,0,1-.35,1.33,7.31,7.31,0,0,0-.41,1.13Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 359.798px 201.575px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elg0nlv47l30h">
          <path
            d="M366.48,199.43a1.84,1.84,0,0,1,1.14-.21,4.71,4.71,0,0,1,1.46.41c.27.12.24.1-.05,0a12.52,12.52,0,0,0-1.37-.19,5.66,5.66,0,0,1-1.18,0Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 367.873px 199.458px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elb00pb11vlw5">
          <path
            d="M363,201.75a2,2,0,0,1,1.15-.21,4.72,4.72,0,0,1,1.45.41c.28.12.24.1,0,.05a9.16,9.16,0,0,0-1.37-.19,6.18,6.18,0,0,1-1.19-.06Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 364.398px 201.783px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el3um0lis4na9">
          <path
            d="M360.31,203.82a1.84,1.84,0,0,1,1.14-.21,4.79,4.79,0,0,1,1.46.41c.27.12.23.11-.05,0a9,9,0,0,0-1.37-.19,6,6,0,0,1-1.18-.06Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 361.701px 203.849px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="ely7bcww8beg">
          <path
            d="M355,206.48h0a1,1,0,0,0,.25,0,11.52,11.52,0,0,1,1.77.35c.9.25,2.1.68,3.08.88a6.05,6.05,0,0,0,2.83-.1,10.6,10.6,0,0,0,3.56-1.6,17.19,17.19,0,0,0,3.59-3.87c1.32-1.78,2.91-4.12,3.81-5.5s1.12-1.84.84-2a.29.29,0,0,0-.1,0H374c-.43,0-1,.1-1.86.15-1.51.09-3.76.12-5.6.22a14.1,14.1,0,0,0-4.55.8,8.51,8.51,0,0,0-3.37,2.47,14.4,14.4,0,0,0-2.1,3.79c-.53,1.38-1,2.79-1.21,3.52s-.28.79-.32.82l0,0h0Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.3",
              transformOrigin: " 364.917px 201.234px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M374.59,168.18c.28-.87.79-2.53,1.42-4.14a16.26,16.26,0,0,1,2.47-4.46,10,10,0,0,1,4-2.91,16.61,16.61,0,0,1,5.35-.93c2.16-.12,4.81-.16,6.58-.26s2.69-.29,3-.12.07.69-1,2.32-2.92,4.38-4.48,6.47a20.22,20.22,0,0,1-4.22,4.55,12.56,12.56,0,0,1-4.18,1.88,7.11,7.11,0,0,1-3.33.12c-1.15-.23-2.56-.75-3.61-1a12.8,12.8,0,0,0-2.1-.4c-.34,0-.31-.08-.27-.12s.1-.1.38-1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 385.866px 163.067px 0px",
          }}
          id="elp44lvq6djoj"
          className="animable"
        ></path>
        <path
          d="M374.59,168.18c.28-.87.79-2.53,1.42-4.14a16.26,16.26,0,0,1,2.47-4.46,10,10,0,0,1,4-2.91,16.61,16.61,0,0,1,5.35-.93c2.16-.12,4.81-.16,6.58-.26a19.27,19.27,0,0,1,2.91-.16,12.63,12.63,0,0,1-2.54,1.76c-1.63.84-3.51,1.25-5.32,2a24.71,24.71,0,0,0-5.18,3.19c-1.64,1.27-3.2,2.66-4.91,3.87a39.43,39.43,0,0,1-4.77,2.84l-.36.18s0,0,0-.05.1-.1.38-1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 385.78px 162.238px 0px",
          }}
          id="el2ztcrepulyo"
          className="animable"
        ></path>
        <g id="elwwheyy0yaa">
          <path
            d="M387.11,160.05c.06,0,.55-.45.82-1.09a5.15,5.15,0,0,0,.35-1.74c0-.35,0-.31-.08,0a10.65,10.65,0,0,1-.52,1.54,7,7,0,0,0-.57,1.27Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 387.695px 158.511px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="eloy1sdnmyya">
          <path
            d="M383.19,162.37a2.32,2.32,0,0,0,.74-1.15,5.39,5.39,0,0,0,.2-1.77c0-.35,0-.3-.07,0a10.54,10.54,0,0,1-.41,1.57,6.93,6.93,0,0,0-.46,1.32Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 383.664px 160.788px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el0l6hywjdtvy">
          <path
            d="M379.37,165c.08,0,.52-.51.75-1.16a5.31,5.31,0,0,0,.2-1.76c0-.35,0-.31-.06,0a12.38,12.38,0,0,1-.41,1.57,8.54,8.54,0,0,0-.48,1.32Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 379.849px 163.416px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elyazz9r48nxi">
          <path
            d="M387.7,160.9a2.08,2.08,0,0,1,1.34-.25,5.22,5.22,0,0,1,1.71.48c.33.14.29.12-.05.05a12.78,12.78,0,0,0-1.61-.22,8.44,8.44,0,0,1-1.39-.06Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 389.339px 160.93px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elxgl3ejs8zuq">
          <path
            d="M383.66,163.63a2.2,2.2,0,0,1,1.35-.25,5.37,5.37,0,0,1,1.71.48c.33.14.28.12-.05.06a11.3,11.3,0,0,0-1.61-.23,10,10,0,0,1-1.4-.06Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 385.302px 163.663px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el5qkm7qdffns">
          <path
            d="M380.45,166.05a2.33,2.33,0,0,1,1.34-.24,5.56,5.56,0,0,1,1.71.48c.33.15.28.13-.05.06a11.3,11.3,0,0,0-1.61-.23,6.09,6.09,0,0,1-1.39-.07Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 382.087px 166.098px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="eld2uvip9e99r">
          <path
            d="M374.2,169.19h0a.89.89,0,0,0,.28.07,12.8,12.8,0,0,1,2.1.4c1.05.29,2.46.81,3.61,1a7.11,7.11,0,0,0,3.33-.12,12.56,12.56,0,0,0,4.18-1.88,20.22,20.22,0,0,0,4.22-4.55c1.56-2.09,3.42-4.84,4.48-6.47s1.32-2.15,1-2.32l-.11,0h-.73c-.5,0-1.21.12-2.18.18-1.77.1-4.42.14-6.58.26a16.61,16.61,0,0,0-5.35.93,10,10,0,0,0-4,2.91A16.26,16.26,0,0,0,376,164c-.63,1.61-1.14,3.27-1.42,4.14s-.34.91-.38,1l0,0h0S374.19,169.18,374.2,169.19Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.3",
              transformOrigin: " 385.862px 163.061px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M373.17,165.83c-.4-.52-1.16-1.53-2-2.49a11.92,11.92,0,0,0-2.77-2.46,7.4,7.4,0,0,0-3.43-1,11.88,11.88,0,0,0-3.9.66c-1.51.44-3.33,1.05-4.57,1.42a9.16,9.16,0,0,0-2.11.64c-.18.2.13.5,1.25,1.36s3.07,2.29,4.64,3.35a14.81,14.81,0,0,0,4,2.1,9,9,0,0,0,3.33.27,5.14,5.14,0,0,0,2.31-.72c.74-.44,1.58-1.14,2.23-1.59a9.72,9.72,0,0,1,1.33-.79c.23-.11.2-.13.17-.15s-.1,0-.5-.57Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 364.006px 164.805px 0px",
          }}
          id="elg26rghy7wwe"
          className="animable"
        ></path>
        <path
          d="M373.17,165.83c-.4-.52-1.16-1.53-2-2.49a11.92,11.92,0,0,0-2.77-2.46,7.4,7.4,0,0,0-3.43-1,11.88,11.88,0,0,0-3.9.66c-1.51.44-3.33,1.05-4.57,1.42a14,14,0,0,0-2,.59,9.43,9.43,0,0,0,2.17.6c1.32.17,2.71,0,4.14.1a17.66,17.66,0,0,1,4.33.93c1.44.47,2.85,1,4.31,1.46a27.69,27.69,0,0,0,4,.79l.3,0s0,0,0,0-.1,0-.5-.57Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 364.125px 163.155px 0px",
          }}
          id="elthol6j4hyg"
          className="animable"
        ></path>
        <g id="elyvbjciiur2p">
          <path
            d="M362.61,163.3s-.49-.18-.83-.55a3.8,3.8,0,0,1-.66-1.11c-.1-.23-.09-.2.06,0a7.77,7.77,0,0,0,.73.93c.33.35.73.68.7.73Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 361.833px 162.389px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elmto8jc6zvh9">
          <path
            d="M365.86,163.94a1.69,1.69,0,0,1-.78-.61,3.79,3.79,0,0,1-.57-1.16c-.09-.25-.07-.21.05,0a8.37,8.37,0,0,0,.66,1c.3.37.68.74.64.79Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 365.158px 162.979px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="ell74cuztddo">
          <path
            d="M369.12,164.82c0,.05-.48-.22-.79-.61a3.81,3.81,0,0,1-.57-1.16c-.08-.24-.07-.21.05,0a7.61,7.61,0,0,0,.66,1,5.82,5.82,0,0,1,.65.79Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 368.414px 163.861px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elu4yb8excq4s">
          <path
            d="M362.41,164a1.59,1.59,0,0,0-1,.16,3.82,3.82,0,0,0-1.06.75c-.19.17-.17.15.05,0a9.27,9.27,0,0,1,1.05-.55,5.68,5.68,0,0,0,.94-.38Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 361.315px 164.504px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elbhp9lemvv3e">
          <path
            d="M365.84,164.92a1.66,1.66,0,0,0-1,.15,4.07,4.07,0,0,0-1.05.75c-.19.17-.16.15.05,0a7.36,7.36,0,0,1,1-.55,7,7,0,0,0,.94-.38Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 364.752px 165.415px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elb5sdfez1e94">
          <path
            d="M368.64,165.8a1.68,1.68,0,0,0-1,.16,4.23,4.23,0,0,0-1.06.74c-.19.18-.16.16,0,0a8.06,8.06,0,0,1,1.05-.54,5.4,5.4,0,0,0,.94-.39Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 367.544px 166.299px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elm5quasmyv0o">
          <path
            d="M373.69,166.43h0l-.19.11a9.72,9.72,0,0,0-1.33.79c-.65.45-1.49,1.15-2.23,1.59a5.14,5.14,0,0,1-2.31.72,9,9,0,0,1-3.33-.27,14.81,14.81,0,0,1-4-2.1c-1.57-1.06-3.52-2.49-4.64-3.35s-1.43-1.16-1.25-1.36l.07,0h0l.05,0,.07,0,.08,0,.09,0,.12,0,.07,0,1.54-.41c1.24-.37,3.06-1,4.57-1.42a11.88,11.88,0,0,1,3.9-.66,7.4,7.4,0,0,1,3.43,1,11.92,11.92,0,0,1,2.77,2.46c.82,1,1.58,2,2,2.49s.46.55.5.57l0,0h0Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.3",
              transformOrigin: " 364.026px 164.88px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M380.35,206.21c.46-.52,1.34-1.52,2.29-2.44a11.24,11.24,0,0,1,3.12-2.27,7.58,7.58,0,0,1,3.85-.62,17,17,0,0,1,4.76,1.45c2,.84,4.6,2,6.46,2.81a19.67,19.67,0,0,1,3.36,1.46c.32.34-.12.68-1.78,1.61s-4.47,2.39-6.71,3.42a15,15,0,0,1-5.49,1.65,10.33,10.33,0,0,1-4.2-.76,6.87,6.87,0,0,1-2.61-1.7c-.77-.78-1.6-1.88-2.23-2.6a11.78,11.78,0,0,0-1.25-1.26c-.21-.18-.18-.2-.14-.21s.1,0,.57-.54Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 392.019px 207.063px 0px",
          }}
          id="elgu3jz97muur"
          className="animable"
        ></path>
        <path
          d="M380.35,206.21c.46-.52,1.34-1.52,2.29-2.44a11.24,11.24,0,0,1,3.12-2.27,7.58,7.58,0,0,1,3.85-.62,17,17,0,0,1,4.76,1.45c2,.84,4.6,2,6.46,2.81a31.14,31.14,0,0,1,3.24,1.37,14.34,14.34,0,0,1-3.31.25c-1.95-.11-4-.7-5.91-.93a21.13,21.13,0,0,0-5.52.16c-1.73.25-3.39.63-5.05.79a25,25,0,0,1-4.23,0l-.3,0s0,0,0,0,.1,0,.57-.54Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 391.91px 203.856px 0px",
          }}
          id="elwosgy2m20hs"
          className="animable"
        ></path>
        <g id="elkzno2rovhpd">
          <path
            d="M392.46,205.51c0,.07.63-.12,1.07-.51a3.67,3.67,0,0,0,.83-1.27c.13-.27.11-.24-.07,0a8.13,8.13,0,0,1-.93,1c-.43.37-.94.71-.9.78Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 393.451px 204.531px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elodsxkz8bb1s">
          <path
            d="M388.45,205.56c0,.06.58-.16,1-.58a3.75,3.75,0,0,0,.71-1.29c.11-.28.09-.24-.06,0a7.74,7.74,0,0,1-.82,1c-.37.4-.83.76-.79.83Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 389.34px 204.532px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elnxa2z71ikjq">
          <path
            d="M384.69,205.91c0,.06.54-.16.92-.56a4.15,4.15,0,0,0,.71-1.26c.11-.27.1-.23-.05,0a8.59,8.59,0,0,1-.81,1c-.36.39-.8.74-.77.81Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 385.541px 204.911px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elum216ir7t6o">
          <path
            d="M392.73,206.49a2.28,2.28,0,0,1,1.29.45,6.88,6.88,0,0,1,1.47,1.31c.28.29.24.25-.06,0s-.85-.65-1.45-1a10.12,10.12,0,0,1-1.25-.74Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 394.205px 207.471px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el9jiqzl859bt">
          <path
            d="M388.43,206.79c0-.08.63.08,1.19.44a6.55,6.55,0,0,1,1.3,1.26c.25.29.21.25-.06,0a12.08,12.08,0,0,0-1.3-1,9.7,9.7,0,0,1-1.13-.73Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 389.758px 207.726px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="els27kal7egjb">
          <path
            d="M385.14,207.21a1.9,1.9,0,0,1,1.1.44,6.72,6.72,0,0,1,1.2,1.23c.21.29.18.25-.06,0a12.08,12.08,0,0,0-1.2-1,7.14,7.14,0,0,1-1-.72Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 386.36px 208.121px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elqyu2jqd7mjj">
          <path
            d="M379.75,206.78h0a1.15,1.15,0,0,0,.17.17,11.78,11.78,0,0,1,1.25,1.26c.63.72,1.46,1.82,2.23,2.6a6.87,6.87,0,0,0,2.61,1.7,10.33,10.33,0,0,0,4.2.76,15,15,0,0,0,5.49-1.65c2.24-1,5.06-2.5,6.71-3.42s2.1-1.27,1.78-1.61l-.12-.09h0l0,0-.08-.05-.13-.08-.12-.05-.15-.07-.19-.09-.12,0c-.57-.24-1.36-.53-2.42-1-1.86-.78-4.45-2-6.46-2.81a17,17,0,0,0-4.76-1.45,7.58,7.58,0,0,0-3.85.62,11.24,11.24,0,0,0-3.12,2.27c-.95.92-1.83,1.92-2.29,2.44s-.53.53-.57.54h0Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.3",
              transformOrigin: " 392.018px 207.068px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M356.56,219.68a1.12,1.12,0,0,1-1.11-1.09,69.43,69.43,0,0,0-11.39-36.76,1.11,1.11,0,0,1,.32-1.53,1.1,1.1,0,0,1,1.53.31,71.77,71.77,0,0,1,11.76,37.94,1.11,1.11,0,0,1-1.09,1.13Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 350.776px 199.897px 0px",
          }}
          id="el93rxopum5q"
          className="animable"
        ></path>
        <g id="elrd29e2ztn3f">
          <g
            style={{
              opacity: "0.2",
              transformOrigin: " 350.776px 199.897px 0px",
            }}
            className="animable"
          >
            <path
              d="M356.56,219.68a1.12,1.12,0,0,1-1.11-1.09,69.43,69.43,0,0,0-11.39-36.76,1.11,1.11,0,0,1,.32-1.53,1.1,1.1,0,0,1,1.53.31,71.77,71.77,0,0,1,11.76,37.94,1.11,1.11,0,0,1-1.09,1.13Z"
              id="el7i9r5650isn"
              style={{ transformOrigin: " 350.776px 199.897px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M344.21,180.59c-1.5-.17-2.95-1.08-4.66-2.36a23.49,23.49,0,0,1-4.89-4.58,7.09,7.09,0,0,1-1.47-4.91,7.93,7.93,0,0,1,1.91-4.27,9.93,9.93,0,0,1,4-2.84,12.32,12.32,0,0,1,5.52-.76,10.41,10.41,0,0,1,4.82,1.74,4.4,4.4,0,0,1,1.91,3.54,26.63,26.63,0,0,1-.41,6.38,34.12,34.12,0,0,1-1.3,5.09,2.91,2.91,0,0,1-1.51,2.06,7.2,7.2,0,0,1-4,.91Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 342.28px 170.712px 0px",
          }}
          id="elxbcaud9rbb"
          className="animable"
        ></path>
        <g id="el6lnbzd7cyi9">
          <path
            d="M344.21,180.59c-1.5-.17-2.95-1.08-4.66-2.36a23.49,23.49,0,0,1-4.89-4.58,9.24,9.24,0,0,1-.9-1.55c1,.21,2.05.47,3,.75a26.6,26.6,0,0,1,4.13,1.63c1,.48,1.62.83,1.64.28a10,10,0,0,0-1.1-3.1c-.52-1.09-1-1.84-.67-1.58a28.57,28.57,0,0,1,2.29,2.45c.83,1,1.36,1.65,1.68,1.24a8.31,8.31,0,0,0,.48-3.32c0-1.44,0-2.81.22-2.82s.63,1.32,1,2.76.79,3,1.27,2.74,1.07-2.25,1.47-4.51c.33-1.91.53-4,.88-5.55a4.52,4.52,0,0,1,1.34,3.08,26.63,26.63,0,0,1-.41,6.38,34.12,34.12,0,0,1-1.3,5.09,2.91,2.91,0,0,1-1.51,2.06,7.2,7.2,0,0,1-4,.91Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 342.596px 171.838px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M351.3,165.07a4.41,4.41,0,0,1,1.5-2.16,6.43,6.43,0,0,1,4.23-.85,8.91,8.91,0,0,1,5.22,2.47,9.39,9.39,0,0,1,2.51,5.5,6.48,6.48,0,0,1-1.48,4.7,14.1,14.1,0,0,1-4.47,3.45,40.18,40.18,0,0,1-6,2.63c-1.56.5-2.2.45-2.82.17a2,2,0,0,1-1.25-1.84,30.68,30.68,0,0,1,.81-4.83c.4-2.2.73-5,1-6.61a8.59,8.59,0,0,1,.79-2.63Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 356.762px 171.591px 0px",
          }}
          id="elzbk27e2j5k"
          className="animable"
        ></path>
        <g id="eltuzlblxw789">
          <path
            d="M364.15,167.52a8.83,8.83,0,0,1,.61,2.51,6.38,6.38,0,0,1,0,1.24,17.45,17.45,0,0,1-2.86,3.19,42.66,42.66,0,0,1-8.4,5.33c-1.12.58-2.09,1.05-2.88,1.38A2.4,2.4,0,0,1,350,181a2,2,0,0,1-1.25-1.84,30.68,30.68,0,0,1,.81-4.83c.25-1.39.48-3,.67-4.44.15-.61.3-1.19.43-1.67.62-2.21,1-2.57,1.12-1.72a31,31,0,0,1-.42,4.45c-.21,1.55-.35,2.59-.15,2.58a10.06,10.06,0,0,0,1.48-2.37,16.66,16.66,0,0,1,2.24-3.32c.59-.55.88-.17.8.49a9.77,9.77,0,0,1-1.06,2.62,7.24,7.24,0,0,0-1,2.3c.12.18.94-.56,2-1.41a32.94,32.94,0,0,1,3.5-2.58,12.16,12.16,0,0,1,3.77-1.53,8.72,8.72,0,0,1,1.23-.19Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 356.77px 173.623px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M334.2,173a4.2,4.2,0,0,0-2.59-.56,5.92,5.92,0,0,0-3.65,2.08,10.93,10.93,0,0,0-2.11,5,7.37,7.37,0,0,0,.38,4.57,5.15,5.15,0,0,0,3.25,2.52,13.45,13.45,0,0,0,5.25.27,21.74,21.74,0,0,0,5.66-1.46,9.25,9.25,0,0,0,4.06-2.78,2.83,2.83,0,0,0,0-3.05,6.85,6.85,0,0,0-2.65-2.5c-1.41-.88-3.5-2-4.87-2.68s-2-1-2.73-1.36Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 335.273px 179.719px 0px",
          }}
          id="elbw1m2e9i444"
          className="animable"
        ></path>
        <g id="el7qtj1hvrkw5">
          <path
            d="M334.2,173a4.2,4.2,0,0,0-2.59-.56,5.61,5.61,0,0,0-2.68,1.15,41,41,0,0,1,5.79,1.66,19.54,19.54,0,0,1,5.46,3.15c1,.82,1,1.12.23,1s-2.18-.75-3.31-1.09-1.94-.4-1.74-.16a15.17,15.17,0,0,0,2.39,1.28c1,.5,1.79.94,1.8,1.18s-.77.29-2.48.34a30.56,30.56,0,0,0-4.65.29c-.32.18,1.66.49,3.15.7a9.53,9.53,0,0,1,2.81.59c.36.24.09.6-.76,1.06s-2.29,1-3.9,1.66c-1.1.48-2.29,1-3.49,1.51a14.91,14.91,0,0,0,4.5.09,21.74,21.74,0,0,0,5.66-1.46,9.25,9.25,0,0,0,4.06-2.78,2.83,2.83,0,0,0,0-3.05,6.85,6.85,0,0,0-2.65-2.5c-1.41-.88-3.5-2-4.87-2.68s-2-1-2.73-1.36Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 336.913px 179.697px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M342.93,183.91a65.22,65.22,0,0,0-6.56,2.69,25.62,25.62,0,0,0-5.35,3,3.61,3.61,0,0,0-1.46,2.9,5.37,5.37,0,0,0,.86,3.29,7.9,7.9,0,0,0,3.24,2.49,12.67,12.67,0,0,0,4.76,1.14,10.3,10.3,0,0,0,5.12-.95,5.53,5.53,0,0,0,2.59-3.61,24.45,24.45,0,0,0,.73-5.56,30,30,0,0,0-.12-4.34c-.12-.94-.29-1.24-.79-1.39a5.11,5.11,0,0,0-3,.35Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 338.219px 191.465px 0px",
          }}
          id="elsgzvtamvjv"
          className="animable"
        ></path>
        <g id="elsjngcu8hhds">
          <path
            d="M342.93,183.91a65.22,65.22,0,0,0-6.56,2.69,41.13,41.13,0,0,0-3.9,2,33.87,33.87,0,0,1,3.67-.74c1.37-.15,1.05.31.48.83s-1.38,1.09-1.31,1.28,1,0,1.62-.17.83-.26.61.08-.89,1.11-1.57,1.9a8.57,8.57,0,0,0-1.84,2.73,11.58,11.58,0,0,0-.6,3.71l.13.07a13,13,0,0,0,4.17,1.11,1.82,1.82,0,0,0,.23-.15c1.22-.74,2.13-1.51,3.57-4.18a45.93,45.93,0,0,0,4-9.85,5.14,5.14,0,0,0,.13-1.71,6.19,6.19,0,0,0-2.79.42Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 339.126px 191.445px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M360.76,170.48c1.68-1,3.39-1.8,4.9-1.16s2.82,2.69,3.28,5a10.64,10.64,0,0,1-.7,6.33,4.55,4.55,0,0,1-3.39,2.68,18.08,18.08,0,0,1-6-.15c-2.72-.37-6.37-1-8.18-1.89s-1.81-2-.64-3.3a32,32,0,0,1,5.46-4c2-1.3,3.63-2.47,5.3-3.47Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 359.179px 176.301px 0px",
          }}
          id="elqm4cucy5qw"
          className="animable"
        ></path>
        <g id="eldft0ox3p8sm">
          <path
            d="M367.33,182a4.66,4.66,0,0,1-2.48,1.32,18.08,18.08,0,0,1-6-.15c-2.72-.37-6.37-1-8.18-1.89-1.34-.64-1.68-1.43-1.31-2.31a8.27,8.27,0,0,1,.82-1.06c.25-.28.55-.57.86-.87,1.24-1,2.94-2.07,4.45-3.05l.27-.18a.3.3,0,0,1-.06.24c-.22.41-1,1.1-1,1.44s.55.33,1.78,0,3.05-1.07,3.71-1.23.17.23-1,.85-2.93,1.48-3.6,1.89-.2.41,1.19.2,3.71-.61,5.15-.75,2,0,1.6.18-1.73.39-3,.73-2.52.8-2.64,1.13.88.57,2.14.68a33.75,33.75,0,0,1,4,.39,5.46,5.46,0,0,1,2.54,1.3,3.66,3.66,0,0,1,.83,1.16Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 358.31px 178.656px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M347.72,184.3c1.17,2,3.11,6,4.23,8.48s1.41,3.46,1.4,4.36a3.48,3.48,0,0,1-1.43,2.75,12.28,12.28,0,0,1-5,2.62,11.25,11.25,0,0,1-5.79-.33,14.93,14.93,0,0,1-4.56-2.15,2.45,2.45,0,0,1-1.19-2.4c.08-1,.47-2.32,2.05-4.88s4.3-6.35,5.87-8.34,2-2.18,2.43-2.22.82.07,2,2.11Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 344.357px 192.463px 0px",
          }}
          id="elh5vsli7b9sh"
          className="animable"
        ></path>
        <g id="elm4qphkkueon">
          <path
            d="M347.72,184.3c1.17,2,3.11,6,4.23,8.48s1.41,3.46,1.4,4.36a3,3,0,0,1-.26,1.27,4,4,0,0,1-.78,0,5.53,5.53,0,0,1-2.83-.81,4.9,4.9,0,0,1-1.66-2.73c-.47-1.4-1-3.4-1.14-3.83s0,.73-.06,2.07a8.79,8.79,0,0,1-.57,3.14c-.23.24-.41-.84-.61-1.89s-.4-2.07-.78-1.89-.89,1.57-1.39,2.43-.95,1.2-1,.65a20.16,20.16,0,0,1,.33-3c.13-1,.09-1.65-.7-1.36a22.1,22.1,0,0,0-3.41,2.31c-1.07.79-1.69,1.15-1.72.56a.48.48,0,0,1,0-.17c.2-.37.43-.76.7-1.2,1.56-2.55,4.3-6.35,5.87-8.34s2-2.18,2.43-2.22.82.07,2,2.11Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 345.056px 190.277px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M350.2,181.14c1.18-.23,2.61-.3,4.51-.57s4.25-.8,5.9-.92,2.56.15,3.16,1.19a8.77,8.77,0,0,1,.75,4.59,8.67,8.67,0,0,1-1.8,4.84,16,16,0,0,1-4.54,3.78,11.32,11.32,0,0,1-4.67,1.66,6.3,6.3,0,0,1-4.05-.8c-1-.68-1.36-1.76-1.7-3.73s-.62-4.82-.72-6.48,0-2.12.51-2.54a6.18,6.18,0,0,1,2.65-1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 355.787px 187.697px 0px",
          }}
          id="el8c7lr8o3bho"
          className="animable"
        ></path>
        <g id="ely40tb1ybrio">
          <path
            d="M350.2,181.14c1.18-.23,2.61-.3,4.51-.57l2.28-.39-.37.15c-1,.36-1.67.33-2.05.69a.88.88,0,0,0,.4,1.5,18,18,0,0,0,4,.43c1.3.09,2.07.29,1.55.48a27.88,27.88,0,0,1-3.81.54c-1.47.16-2.58.29-2.57.8s1.13,1.45,2.11,2.38,1.8,1.86,1.71,2.07-1.09-.33-2.2-1.09a15.85,15.85,0,0,0-2.8-1.82c-.51-.09-.31.71,0,1.71a11.61,11.61,0,0,1,.71,2.67c0,.48-.56.23-1.45-.4s-2.17-1.64-2.74-1.63-.45,1-.48,2.25a18.52,18.52,0,0,1-.35,3.19,7.76,7.76,0,0,1-.92-2.92c-.33-2-.62-4.82-.72-6.48s0-2.12.51-2.54a6.18,6.18,0,0,1,2.65-1Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 353.83px 187.14px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M346.34,178.37a4.73,4.73,0,0,0-1.35.37,5.51,5.51,0,0,0-1.57,1.48,4,4,0,0,0-.86,2,2.6,2.6,0,0,0,.74,1.85,3.46,3.46,0,0,0,1.85,1,4.47,4.47,0,0,0,2.17-.21,6,6,0,0,0,2.28-1.17,4.51,4.51,0,0,0,1.31-2.14,3,3,0,0,0-.1-1.88,2.35,2.35,0,0,0-1.07-1.26,3.68,3.68,0,0,0-1.86-.45,9.08,9.08,0,0,0-1.54.39Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 346.788px 181.539px 0px",
          }}
          id="eluurl7u3obss"
          className="animable"
        ></path>
        <g id="eldy94wd3o5yn">
          <path
            d="M346.34,178.37a4.73,4.73,0,0,0-1.35.37,5.51,5.51,0,0,0-1.57,1.48,4,4,0,0,0-.86,2,2.6,2.6,0,0,0,.74,1.85,3.46,3.46,0,0,0,1.85,1,4.47,4.47,0,0,0,2.17-.21,6,6,0,0,0,2.28-1.17,4.51,4.51,0,0,0,1.31-2.14,3,3,0,0,0-.1-1.88,2.35,2.35,0,0,0-1.07-1.26,3.68,3.68,0,0,0-1.86-.45,9.08,9.08,0,0,0-1.54.39Z"
            style={{
              fill: " rgb(255, 255, 255)",
              fillRule: "evenodd",
              opacity: "0.5",
              transformOrigin: " 346.788px 181.539px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M347,184.72a.37.37,0,1,0,.37.37A.37.37,0,0,0,347,184.72Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 347px 185.09px 0px",
          }}
          id="eldoe668j04gu"
          className="animable"
        ></path>
        <path
          d="M344.75,184.77a.39.39,0,0,0-.21.08.38.38,0,0,0-.35-.26l-.09,0a.43.43,0,0,0,0-.11.2.2,0,0,0,.11,0,.35.35,0,0,0,.2-.07.36.36,0,0,0,.36.31.4.4,0,0,0,.26-.1.36.36,0,0,0,.36.32.37.37,0,0,0,.36-.37.37.37,0,0,0-.62-.27.37.37,0,0,0-.36-.31.34.34,0,0,0-.2.06.37.37,0,0,0-.36-.32.37.37,0,0,0-.28.13.3.3,0,0,0,0-.1.38.38,0,0,0-.36-.38l-.08,0a.35.35,0,0,0,.14-.28.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37v0a.34.34,0,0,0-.12-.12.38.38,0,0,0,.19-.32.36.36,0,0,1-.16-.61.33.33,0,0,0-.1-.24l.16,0a.36.36,0,0,0,.24.29.35.35,0,0,0-.13.27.38.38,0,1,0,.75,0,.36.36,0,0,0-.26-.34.36.36,0,0,0-.24-.64.29.29,0,0,0-.16,0,.37.37,0,0,0-.73,0,.37.37,0,0,0,.1.24.36.36,0,0,0-.37.37.37.37,0,0,0,.27.35.33.33,0,0,0-.11.26.37.37,0,0,0,.18.32.34.34,0,0,0-.18.31.36.36,0,0,0,.33.36.37.37,0,0,0,.27.62.38.38,0,0,0,.38-.37.36.36,0,0,1-.24-.61v0a.37.37,0,0,0,.31.18l.08,0a.37.37,0,0,0,.23.66.34.34,0,0,0,.27-.13.36.36,0,0,0,0,.11.47.47,0,0,0,0,.16.23.23,0,0,0-.11,0,.37.37,0,0,0-.37.37.36.36,0,0,0,.37.37l.08,0a.37.37,0,0,0,.36.33.32.32,0,0,0,.21-.08.37.37,0,1,0,.35-.49Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 343.905px 183.27px 0px",
          }}
          id="el1gum2s6mgxa"
          className="animable"
        ></path>
        <path
          d="M350.65,180.84a.39.39,0,0,0-.35-.23.38.38,0,0,0,0,.75.38.38,0,0,0,.3-.15.36.36,0,0,0,.34.23.38.38,0,0,0,0-.75A.36.36,0,0,0,350.65,180.84Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 350.62px 181.025px 0px",
          }}
          id="elsh0063bcqz"
          className="animable"
        ></path>
        <path
          d="M348.91,183.89a.36.36,0,0,0-.25.1.36.36,0,0,0,0-.11.37.37,0,0,0-.74,0h0a.34.34,0,0,0-.24-.09.37.37,0,0,1-.69.12.37.37,0,0,0-.37.37.36.36,0,0,0,.37.37.38.38,0,0,0,.37-.33.36.36,0,0,0,.32.2.38.38,0,0,0,.38-.37h0a.33.33,0,0,0,.23.1.14.14,0,1,1,.23,0v0l-.1,0a.38.38,0,0,0-.37.37.37.37,0,0,0,.37.37.36.36,0,0,0,.37-.37v0l.09,0a.37.37,0,1,0,0-.73Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 347.965px 184.251px 0px",
          }}
          id="elbvdiax6tvim"
          className="animable"
        ></path>
        <path
          d="M351.2,181.39a.37.37,0,0,1-.71,0,.38.38,0,0,0-.37.37.38.38,0,0,0,.37.38h0a.38.38,0,0,0-.09.13.37.37,0,0,0-.71.16.31.31,0,0,0,0,.13h-.05a.38.38,0,0,0-.36.38.36.36,0,0,0,.34.36.37.37,0,0,0,.21.67.37.37,0,0,0,.3-.57.29.29,0,0,0,.16,0,.37.37,0,1,0,0-.73h0a.38.38,0,0,0,.09-.13.4.4,0,0,0,.34.22.38.38,0,0,0,0-.75,0,0,0,0,0,0,0,.4.4,0,0,0,.1-.18.37.37,0,0,0,.72-.08A.37.37,0,0,0,351.2,181.39ZM350,183.24a.33.33,0,0,0-.14,0l.09-.09A.5.5,0,0,0,350,183.24Zm0-.42s0,0,0-.06h.07Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 350.41px 182.68px 0px",
          }}
          id="el0wvsdc2uk48d"
          className="animable"
        ></path>
        <path
          d="M350.43,179.49a.29.29,0,0,0,0,.16.37.37,0,0,0-.23-.1.39.39,0,0,0,.06-.19.37.37,0,1,0-.74,0,.37.37,0,0,0,.35.37.31.31,0,0,0-.06.19.37.37,0,0,0,.36.37.43.43,0,0,0,.2-.06.24.24,0,0,0,0,.09.37.37,0,0,0,.37.37.38.38,0,0,0,.37-.37.37.37,0,0,0-.37-.37.34.34,0,0,0-.2.06.29.29,0,0,0,0-.09.33.33,0,0,0,0-.17.36.36,0,0,0,.25.11.37.37,0,1,0-.36-.37Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 350.345px 179.839px 0px",
          }}
          id="elncis559f9ws"
          className="animable"
        ></path>
        <path
          d="M350.48,179.18a.38.38,0,0,0,0-.75.38.38,0,0,0,0,.75Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 350.48px 178.805px 0px",
          }}
          id="el3mk6bso0vfh"
          className="animable"
        ></path>
        <path
          d="M345.29,178.65a.37.37,0,1,0,.58.3s0,0,0,0a.38.38,0,0,0,.3.17.37.37,0,0,0,.37-.38.36.36,0,0,0,0-.1h0a.37.37,0,0,0,.38-.37.37.37,0,0,0-.38-.37.36.36,0,0,0-.36.37.36.36,0,0,0,0,.1h0a.38.38,0,0,0-.37.37s0,0,0,0a.39.39,0,0,0-.17-.14.34.34,0,0,0,.16-.29.37.37,0,1,0-.73,0A.37.37,0,0,0,345.29,178.65Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 345.992px 178.602px 0px",
          }}
          id="el2yi02zc7qi"
          className="animable"
        ></path>
        <path
          d="M344.56,179a.42.42,0,0,0-.09.25.36.36,0,0,0,.38.36,1.56,1.56,0,0,1,.12-1,.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37A.36.36,0,0,0,344.56,179Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 344.599px 178.925px 0px",
          }}
          id="elvb3y54wt03s"
          className="animable"
        ></path>
        <path
          d="M344,179.81a.37.37,0,1,0-.37-.37A.36.36,0,0,0,344,179.81Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 344px 179.44px 0px",
          }}
          id="elqcfrkum7wyp"
          className="animable"
        ></path>
        <path
          d="M343.36,180.46a.38.38,0,0,0,.34-.22.36.36,0,0,0,.72,0,.37.37,0,0,0-.7-.16.36.36,0,0,0-.36-.32.37.37,0,0,0,0,.74Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 343.705px 180.18px 0px",
          }}
          id="elt7tn3xo1yfk"
          className="animable"
        ></path>
        <path
          d="M342.74,181.07a.38.38,0,0,0,0-.75.38.38,0,0,0,0,.75Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 342.74px 180.695px 0px",
          }}
          id="el3dzl60c1msl"
          className="animable"
        ></path>
        <path
          d="M346.25,184.92a.37.37,0,0,0,.33-.36.38.38,0,0,0-.38-.36.37.37,0,0,0,0,.73.34.34,0,0,0-.29.21.38.38,0,0,0-.27-.12.37.37,0,0,0-.37.37.36.36,0,0,0,.37.37.38.38,0,0,0,.34-.22.34.34,0,0,0,.27.12.36.36,0,0,0,.36-.37A.37.37,0,0,0,346.25,184.92Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 345.94px 184.98px 0px",
          }}
          id="eldsytpwj0ik6"
          className="animable"
        ></path>
        <circle
          cx="347.66"
          cy="184.9"
          r="0.37"
          style={{
            fill: " rgb(255, 255, 255)",
            transformOrigin: " 347.66px 184.9px 0px",
          }}
          id="el1f6adyimzvn"
          className="animable"
        ></circle>
        <path
          d="M349.09,183a.37.37,0,1,0,0,.74.37.37,0,0,0,0-.74Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 349.09px 183.37px 0px",
          }}
          id="elcaju4y9ss4"
          className="animable"
        ></path>
        <path
          d="M349.29,178.59a.36.36,0,0,0,.37.37.37.37,0,0,0,.37-.37.38.38,0,0,0-.37-.37A.37.37,0,0,0,349.29,178.59Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 349.66px 178.59px 0px",
          }}
          id="elxm72ow2g80e"
          className="animable"
        ></path>
        <path
          d="M347.35,178.83a.37.37,0,0,0,.36-.37.15.15,0,0,0,0-.07.42.42,0,0,0,.16,0,.38.38,0,0,0,.37-.37s0,0,0,0a.34.34,0,0,0,.12.06.37.37,0,1,0,.68.2.43.43,0,0,1,0-.05.28.28,0,0,0,.13,0,.37.37,0,0,0,.37-.37.38.38,0,0,0-.37-.37.36.36,0,0,0-.33.22h0a.38.38,0,0,0-.37-.37.37.37,0,0,0-.37.37s0,0,0,0a.37.37,0,0,0-.22-.08.36.36,0,0,0-.37.37s0,0,0,.06a.42.42,0,0,0-.15,0,.38.38,0,0,0,0,.75Zm1.43-.89h0l0,0h0S348.78,177.92,348.78,177.94Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 348.291px 178.085px 0px",
          }}
          id="elct16ieh41t"
          className="animable"
        ></path>
        <path
          d="M343.46,180.54a.37.37,0,1,0,.37.36A.37.37,0,0,0,343.46,180.54Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 343.46px 180.91px 0px",
          }}
          id="ellyab3j7525r"
          className="animable"
        ></path>
        <path
          d="M376.2,211a1,1,0,0,1-.69-1.13c1.7-12.49.35-29.68-5.9-55.67-.39-1.62-.05-2.51.73-2a7,7,0,0,1,2,3.69c5.53,25.13,6.6,41.94,4.85,54.22a.91.91,0,0,1-.94.86Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 373.704px 181.528px 0px",
          }}
          id="el84ccn2mqigq"
          className="animable"
        ></path>
        <g id="el25brb4ozadq">
          <g
            style={{
              opacity: "0.2",
              transformOrigin: " 373.704px 181.528px 0px",
            }}
            className="animable"
          >
            <path
              d="M376.2,211a1,1,0,0,1-.69-1.13c1.7-12.49.35-29.68-5.9-55.67-.39-1.62-.05-2.51.73-2a7,7,0,0,1,2,3.69c5.53,25.13,6.6,41.94,4.85,54.22a.91.91,0,0,1-.94.86Z"
              id="ele131rw3eue"
              style={{ transformOrigin: " 373.704px 181.528px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M368,146.79a8.21,8.21,0,0,1-3.39-2.44,18.94,18.94,0,0,1-3.31-4.23,5.7,5.7,0,0,1-.56-4.07,6.38,6.38,0,0,1,2-3.14,7.91,7.91,0,0,1,3.55-1.75,9.62,9.62,0,0,1,4.46.08,8.54,8.54,0,0,1,3.61,2,3.56,3.56,0,0,1,1.07,3.05,20.72,20.72,0,0,1-1.12,5,26.27,26.27,0,0,1-1.65,3.87c-.44.85-.68,1.16-1.45,1.44a5.72,5.72,0,0,1-3.25.24Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 368.025px 138.954px 0px",
          }}
          id="elq5didwa4muo"
          className="animable"
        ></path>
        <g id="el8ac3neruyj">
          <path
            d="M368,146.79a8.21,8.21,0,0,1-3.39-2.44,18.94,18.94,0,0,1-3.31-4.23,7.24,7.24,0,0,1-.52-1.34c.79.3,1.57.62,2.26,1a22.16,22.16,0,0,1,3.07,1.8c.73.5,1.18.86,1.26.42a8.37,8.37,0,0,0-.48-2.59c-.29-.93-.57-1.57-.35-1.33a21.3,21.3,0,0,1,1.51,2.22c.55.87.88,1.48,1.19,1.19a6.94,6.94,0,0,0,.78-2.57c.21-1.13.36-2.22.52-2.2A6.25,6.25,0,0,1,371,139c.15,1.19.26,2.45.67,2.33s1.12-1.65,1.71-3.39c.5-1.48.92-3.1,1.39-4.29a3.68,3.68,0,0,1,.68,2.61,20.72,20.72,0,0,1-1.12,5,26.27,26.27,0,0,1-1.65,3.87c-.44.85-.68,1.16-1.45,1.44a5.72,5.72,0,0,1-3.25.24Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 368.128px 140.296px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M375.53,135.38a3.43,3.43,0,0,1,1.46-1.52,5,5,0,0,1,3.44-.15,7.08,7.08,0,0,1,3.83,2.59,7.48,7.48,0,0,1,1.31,4.66,5.2,5.2,0,0,1-1.75,3.54,11.42,11.42,0,0,1-4,2.18,33.13,33.13,0,0,1-5.09,1.34c-1.3.2-1.8.08-2.26-.22a1.58,1.58,0,0,1-.76-1.6,23.09,23.09,0,0,1,1.24-3.73c.58-1.69,1.19-3.87,1.6-5.11a6.87,6.87,0,0,1,.95-2Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 378.637px 140.797px 0px",
          }}
          id="elqtm998awicj"
          className="animable"
        ></path>
        <g id="elpbhbe21uun">
          <path
            d="M385.4,138.9a7,7,0,0,1,.17,2.06,5.12,5.12,0,0,1-.16,1,14.07,14.07,0,0,1-2.66,2.16,34.06,34.06,0,0,1-7.3,3.19c-1,.32-1.78.58-2.45.73a1.75,1.75,0,0,1-.5-.23,1.58,1.58,0,0,1-.76-1.6,23.09,23.09,0,0,1,1.24-3.73c.36-1.07.74-2.33,1.07-3.43.2-.47.38-.9.55-1.27.76-1.67,1.14-1.9,1.09-1.23a24.56,24.56,0,0,1-.87,3.48c-.36,1.2-.6,2-.44,2a8.23,8.23,0,0,0,1.46-1.69A13.61,13.61,0,0,1,378,138c.54-.36.72,0,.58.49a8,8,0,0,1-1.17,1.93c-.53.74-1.12,1.55-1,1.71s.82-.33,1.75-.88a25.71,25.71,0,0,1,3.09-1.6,9.6,9.6,0,0,1,3.17-.75,6.68,6.68,0,0,1,1,0Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 378.653px 142.12px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M361,139.56a3.31,3.31,0,0,0-2-.76,4.71,4.71,0,0,0-3.14,1.2,8.76,8.76,0,0,0-2.28,3.65,5.93,5.93,0,0,0-.26,3.67,4.14,4.14,0,0,0,2.26,2.4,10.78,10.78,0,0,0,4.12.85,17.4,17.4,0,0,0,4.66-.45,7.54,7.54,0,0,0,3.56-1.7,2.26,2.26,0,0,0,.37-2.41,5.4,5.4,0,0,0-1.78-2.31c-1-.88-2.53-2-3.53-2.72s-1.47-1.06-2-1.42Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 360.814px 144.692px 0px",
          }}
          id="el4fa2bl6xhtw"
          className="animable"
        ></path>
        <g id="el5lpebn04ycy">
          <path
            d="M361,139.56a3.31,3.31,0,0,0-2-.76,4.57,4.57,0,0,0-2.26.58,33.16,33.16,0,0,1,4.38,2,15.88,15.88,0,0,1,3.94,3.16c.65.77.62,1,.05.81s-1.63-.86-2.48-1.27-1.49-.56-1.36-.34a12.58,12.58,0,0,0,1.74,1.3c.73.52,1.3,1,1.28,1.16s-.65.13-2,0a24.44,24.44,0,0,0-3.71-.34c-.28.1,1.25.59,2.4.94a7.88,7.88,0,0,1,2.16.82c.25.23,0,.48-.74.74s-1.93.49-3.29.83c-.93.25-1.94.54-2.95.77a11.76,11.76,0,0,0,3.55.62,17.4,17.4,0,0,0,4.66-.45,7.54,7.54,0,0,0,3.56-1.7,2.26,2.26,0,0,0,.37-2.41,5.4,5.4,0,0,0-1.78-2.31c-1-.88-2.53-2-3.53-2.72s-1.47-1.06-2-1.42Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 362.327px 144.696px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M366.59,149.26a52.92,52.92,0,0,0-5.53,1.32,20.89,20.89,0,0,0-4.6,1.7,2.92,2.92,0,0,0-1.52,2.12,4.44,4.44,0,0,0,.28,2.71,6.26,6.26,0,0,0,2.26,2.37,10.16,10.16,0,0,0,3.63,1.49,8.3,8.3,0,0,0,4.16-.12,4.39,4.39,0,0,0,2.49-2.54A19.77,19.77,0,0,0,369,154a23.1,23.1,0,0,0,.44-3.45c0-.76-.08-1-.45-1.2a4.15,4.15,0,0,0-2.43-.09Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 362.142px 155.149px 0px",
          }}
          id="elhe04jkk7ch4"
          className="animable"
        ></path>
        <g id="elxgw2bxfm8">
          <path
            d="M366.59,149.26a52.92,52.92,0,0,0-5.53,1.32c-1.26.36-2.41.71-3.33,1.08a29.24,29.24,0,0,1,3-.13c1.1.05.79.38.28.72s-1.23.69-1.2.85.81.12,1.3.07.69-.11.48.13-.84.77-1.48,1.32a6.81,6.81,0,0,0-1.79,1.93,9.34,9.34,0,0,0-.94,2.86l.1.07a10.07,10.07,0,0,0,3.17,1.39l.19-.08c1.06-.44,1.87-.94,3.34-2.88a36.77,36.77,0,0,0,4.35-7.3,3.87,3.87,0,0,0,.31-1.34,4.9,4.9,0,0,0-2.25,0Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 363.11px 155.005px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M382.35,140.83c1.45-.58,2.9-1,4-.32s1.9,2.48,2,4.32a8.57,8.57,0,0,1-1.34,4.93,3.65,3.65,0,0,1-3,1.7,14.4,14.4,0,0,1-4.75-.86,27,27,0,0,1-6.25-2.5c-1.33-.92-1.18-1.83-.1-2.7a26.08,26.08,0,0,1,4.81-2.48c1.74-.78,3.19-1.51,4.63-2.09Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 380.206px 145.81px 0px",
          }}
          id="elz19ig6ezlkf"
          className="animable"
        ></path>
        <g id="elb5khxafsn9h">
          <path
            d="M386.14,150.72a3.68,3.68,0,0,1-2.13.74,14.4,14.4,0,0,1-4.75-.86,27,27,0,0,1-6.25-2.5c-1-.68-1.15-1.34-.75-2a6.28,6.28,0,0,1,.78-.74c.24-.19.5-.39.79-.59,1.1-.64,2.58-1.27,3.89-1.86l.25-.11a.35.35,0,0,1-.09.19c-.22.29-.89.74-1,1s.39.34,1.4.21,2.55-.47,3.09-.52.11.2-.88.56-2.5.8-3.08,1.05-.21.3.91.3,3,0,4.17.05,1.58.25,1.25.34-1.42.09-2.47.2a4.45,4.45,0,0,0-2.23.57c-.14.26.62.56,1.61.8a26.5,26.5,0,0,1,3.1.8,4.35,4.35,0,0,1,1.85,1.34,2.89,2.89,0,0,1,.52,1Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 379.097px 147.13px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M370.33,150.16c.67,1.76,1.72,5.14,2.3,7.23s.69,2.91.57,3.62a2.77,2.77,0,0,1-1.47,2,9.72,9.72,0,0,1-4.28,1.46,9.08,9.08,0,0,1-4.54-1,12.08,12.08,0,0,1-3.35-2.27,2,2,0,0,1-.64-2,8.93,8.93,0,0,1,2.22-3.61c1.55-1.83,4.19-4.5,5.68-5.88s1.86-1.48,2.19-1.46.64.16,1.32,1.92Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 366.052px 156.363px 0px",
          }}
          id="elgpsapla3ozk"
          className="animable"
        ></path>
        <g id="elhv8wu8gdepg">
          <path
            d="M370.33,150.16c.67,1.76,1.72,5.14,2.3,7.23s.69,2.91.57,3.62a2.49,2.49,0,0,1-.36,1,2.73,2.73,0,0,1-.62-.09,4.38,4.38,0,0,1-2.14-1,3.94,3.94,0,0,1-1-2.37c-.2-1.17-.36-2.81-.43-3.17s-.09.57-.31,1.63a6.7,6.7,0,0,1-.83,2.41c-.21.16-.22-.71-.25-1.56s-.06-1.69-.38-1.59-.9,1.12-1.4,1.74-.91.83-.91.39a14.74,14.74,0,0,1,.63-2.3c.23-.79.27-1.3-.39-1.16a18.09,18.09,0,0,0-3,1.4c-1,.49-1.48.71-1.43.23a.3.3,0,0,1,0-.13c.2-.27.44-.55.7-.86,1.55-1.83,4.19-4.5,5.68-5.88s1.86-1.48,2.19-1.46.64.16,1.32,1.92Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 366.808px 155.124px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M372.68,148c1,0,2.1.09,3.64.1s3.46-.1,4.78,0,2,.43,2.35,1.33a7.67,7.67,0,0,1-2,7.33,12.87,12.87,0,0,1-4.06,2.43,9,9,0,0,1-3.89.74,5.07,5.07,0,0,1-3.11-1.13c-.69-.66-.86-1.56-.89-3.17s.11-3.89.23-5.21.26-1.68.71-1.95a5,5,0,0,1,2.23-.48Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 376.594px 153.962px 0px",
          }}
          id="elohr4937j5lo"
          className="animable"
        ></path>
        <g id="eldfi89zgocgf">
          <path
            d="M372.68,148c1,0,2.1.09,3.64.1l1.85,0-.31.07c-.82.17-1.36.06-1.71.3a.7.7,0,0,0,.14,1.23,13.46,13.46,0,0,0,3.13.83c1,.24,1.6.49,1.16.58a23.34,23.34,0,0,1-3.07,0c-1.18-.06-2.08-.09-2.14.32s.72,1.28,1.38,2.14,1.2,1.7,1.1,1.84-.82-.39-1.61-1.12a12,12,0,0,0-2-1.79c-.39-.14-.34.52-.21,1.35a9.32,9.32,0,0,1,.23,2.2c-.09.37-.47.11-1.1-.5s-1.51-1.56-2-1.62-.47.75-.65,1.72a14.91,14.91,0,0,1-.67,2.49,6.24,6.24,0,0,1-.37-2.44c0-1.59.11-3.89.23-5.21s.26-1.68.71-1.95a5,5,0,0,1,2.23-.48Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 375.095px 153.07px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M370,145.3a3.46,3.46,0,0,0-1.12.12,4.54,4.54,0,0,0-1.42,1,3.14,3.14,0,0,0-.93,1.47,2.08,2.08,0,0,0,.36,1.55,2.89,2.89,0,0,0,1.34,1.05,3.54,3.54,0,0,0,1.73.1,4.79,4.79,0,0,0,2-.65,3.59,3.59,0,0,0,1.29-1.53,2.37,2.37,0,0,0,.16-1.5,1.93,1.93,0,0,0-.69-1.13,2.81,2.81,0,0,0-1.42-.58,5.92,5.92,0,0,0-1.26.12Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 369.984px 147.926px 0px",
          }}
          id="ellmu6c69twp9"
          className="animable"
        ></path>
        <g id="elkx8vqypd6dm">
          <path
            d="M370,145.3a3.46,3.46,0,0,0-1.12.12,4.54,4.54,0,0,0-1.42,1,3.14,3.14,0,0,0-.93,1.47,2.08,2.08,0,0,0,.36,1.55,2.89,2.89,0,0,0,1.34,1.05,3.54,3.54,0,0,0,1.73.1,4.79,4.79,0,0,0,2-.65,3.59,3.59,0,0,0,1.29-1.53,2.37,2.37,0,0,0,.16-1.5,1.93,1.93,0,0,0-.69-1.13,2.81,2.81,0,0,0-1.42-.58,5.92,5.92,0,0,0-1.26.12Z"
            style={{
              fill: " rgb(255, 255, 255)",
              fillRule: "evenodd",
              opacity: "0.5",
              transformOrigin: " 369.984px 147.926px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M369.67,150.4a.3.3,0,0,0-.35.24.31.31,0,0,0,.26.34.29.29,0,0,0,.09-.58Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 369.618px 150.689px 0px",
          }}
          id="elnyu6e85br1"
          className="animable"
        ></path>
        <path
          d="M367.92,150.17a.27.27,0,0,0-.18,0,.29.29,0,0,0-.24-.24.16.16,0,0,0-.07,0,.28.28,0,0,0,0-.09.19.19,0,0,0,.08,0,.25.25,0,0,0,.17,0,.3.3,0,0,0,.25.3.26.26,0,0,0,.21-.06.29.29,0,0,0,.25.3.31.31,0,0,0,.34-.25.29.29,0,0,0-.25-.33.25.25,0,0,0-.22,0,.3.3,0,0,0-.24-.3.32.32,0,0,0-.17,0,.29.29,0,0,0-.24-.3.33.33,0,0,0-.24.07.19.19,0,0,0,0-.08.29.29,0,0,0-.25-.34h-.05a.27.27,0,0,0,.14-.2.3.3,0,0,0-.25-.34.31.31,0,0,0-.34.25v0a.28.28,0,0,0-.08-.11.32.32,0,0,0,.19-.23.3.3,0,0,0-.17-.31.31.31,0,0,0,.12-.19.3.3,0,0,0-.05-.21.28.28,0,0,0,.13,0,.26.26,0,0,1,0,.46.3.3,0,0,0,.25.35.31.31,0,0,0,.34-.25.3.3,0,0,0-.16-.31.26.26,0,0,0,.13-.2.29.29,0,0,0-.24-.34.34.34,0,0,0-.14,0,.29.29,0,0,0-.24-.31.32.32,0,0,0-.34.26.29.29,0,0,0,.05.2.31.31,0,0,0-.34.25.28.28,0,0,0,.17.3.32.32,0,0,0-.12.2.27.27,0,0,0,.11.27.3.3,0,0,0-.19.23.31.31,0,0,0,.22.33.33.33,0,0,0-.11.18.31.31,0,0,0,.25.34.3.3,0,0,0,.34-.25.3.3,0,0,0-.22-.33.28.28,0,0,0,.11-.18v0a.29.29,0,0,0,.22.18H367a.31.31,0,0,0-.14.21.29.29,0,0,0,.24.34.33.33,0,0,0,.24-.07s0,.05,0,.08a.28.28,0,0,0,0,.13l-.09,0a.3.3,0,1,0-.09.59h.07a.31.31,0,0,0,.24.31.27.27,0,0,0,.18,0,.3.3,0,1,0,.34-.34Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 367.386px 148.823px 0px",
          }}
          id="eloaduxigddxo"
          className="animable"
        ></path>
        <path
          d="M373.07,147.78a.29.29,0,0,0-.24-.22.3.3,0,0,0-.1.59.28.28,0,0,0,.25-.09.3.3,0,0,0,.25.23.29.29,0,0,0,.33-.25.29.29,0,0,0-.24-.34A.29.29,0,0,0,373.07,147.78Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 373.033px 147.926px 0px",
          }}
          id="elahnzaddsnr"
          className="animable"
        ></path>
        <path
          d="M371.32,150a.29.29,0,0,0-.22.05.36.36,0,0,0,0-.09.3.3,0,1,0-.59-.09h0a.27.27,0,0,0-.18-.1.28.28,0,0,0-.32.21.29.29,0,0,0-.23-.2.31.31,0,0,0-.35.25.3.3,0,0,0,.58.12.29.29,0,0,0,.57,0h0a.32.32,0,0,0,.18.1.26.26,0,0,0,.21-.05l0,.08v0a.09.09,0,0,0-.07,0,.29.29,0,0,0-.34.24.3.3,0,0,0,.25.34.29.29,0,0,0,.34-.24v0a.15.15,0,0,0,.07,0,.3.3,0,0,0,.34-.25A.29.29,0,0,0,371.32,150Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 370.501px 150.225px 0px",
          }}
          id="eln74spmskr5k"
          className="animable"
        ></path>
        <path
          d="M373.44,148.28a.29.29,0,0,1-.56-.1.31.31,0,0,0-.34.25.3.3,0,0,0,.25.34h0a.24.24,0,0,0-.08.09.32.32,0,0,0-.25-.21.28.28,0,0,0-.33.24.24.24,0,0,0,0,.12l0,0a.31.31,0,0,0-.34.26.3.3,0,0,0,.23.33.28.28,0,0,0-.17.21.3.3,0,0,0,.25.34.29.29,0,0,0,.34-.25.51.51,0,0,0,0-.17.23.23,0,0,0,.12.06.29.29,0,1,0,.09-.58h0a.26.26,0,0,0,.09-.09.32.32,0,0,0,.25.21.28.28,0,0,0,.33-.25.29.29,0,0,0-.24-.34h0a.32.32,0,0,0,.11-.12.28.28,0,0,0,.24.26.29.29,0,0,0,.34-.24A.3.3,0,0,0,373.44,148.28Zm-1.14,1.32-.11,0,.08-.05A.19.19,0,0,0,372.3,149.6Zm.05-.32v-.06h0Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 372.782px 149.166px 0px",
          }}
          id="elkh6cm8f2m2"
          className="animable"
        ></path>
        <path
          d="M373.06,146.68a.33.33,0,0,0,0,.14.28.28,0,0,0-.17-.11.21.21,0,0,0,.07-.14.3.3,0,0,0-.24-.35,1.36,1.36,0,0,1-.18.73.29.29,0,0,0,.25.34.08.08,0,1,1,.13,0,.29.29,0,0,0,.24.34.28.28,0,0,0,.34-.25.28.28,0,0,0-.24-.33.29.29,0,0,0-.16,0,.14.14,0,0,0,0-.07.28.28,0,0,0,0-.13.27.27,0,0,0,.19.11.29.29,0,0,0,.33-.25.28.28,0,0,0-.24-.33A.29.29,0,0,0,373.06,146.68Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 373.08px 146.928px 0px",
          }}
          id="el1fmda7syp53"
          className="animable"
        ></path>
        <path
          d="M373.14,146.44a.3.3,0,0,0,.34-.25.3.3,0,1,0-.59-.09A.3.3,0,0,0,373.14,146.44Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 373.188px 146.129px 0px",
          }}
          id="el64oyvtk4e7t"
          className="animable"
        ></path>
        <path
          d="M369.1,145.39a.27.27,0,0,0-.16.21.29.29,0,0,0,.24.34.3.3,0,0,0,.34-.25v0a.28.28,0,0,0,.22.17.29.29,0,0,0,.33-.25.27.27,0,0,0,0-.09h0a.3.3,0,0,0,.35-.24.31.31,0,0,0-.25-.34.3.3,0,0,0-.34.25.21.21,0,0,0,0,.08h0a.31.31,0,0,0-.34.25v0a.28.28,0,0,0-.11-.13.27.27,0,0,0,.16-.21.29.29,0,0,0-.25-.34.28.28,0,0,0-.33.25A.3.3,0,0,0,369.1,145.39Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 369.679px 145.389px 0px",
          }}
          id="el8xug74p3333"
          className="animable"
        ></path>
        <path
          d="M368.47,145.61a.27.27,0,0,0-.1.18.31.31,0,0,0,.25.34.3.3,0,0,0,.34-.25.28.28,0,0,0-.22-.33.32.32,0,0,0,.1-.18.3.3,0,0,0-.25-.34.3.3,0,0,0-.12.58Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 368.621px 145.581px 0px",
          }}
          id="el4p600ub9avl"
          className="animable"
        ></path>
        <path
          d="M367.9,146.14a.3.3,0,0,0,.35-.25.31.31,0,0,0-.26-.34.29.29,0,0,0-.33.25A.28.28,0,0,0,367.9,146.14Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 367.952px 145.846px 0px",
          }}
          id="elda5tw2db875"
          className="animable"
        ></path>
        <path
          d="M367.35,146.58a.29.29,0,0,1,.54.17.29.29,0,0,0,.33-.25.29.29,0,0,0-.24-.34.29.29,0,0,1-.54-.16.29.29,0,0,0-.34.24A.3.3,0,0,0,367.35,146.58Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 367.661px 146.374px 0px",
          }}
          id="elhe6nkm73fn6"
          className="animable"
        ></path>
        <path
          d="M366.78,147a.31.31,0,0,0,.34-.26.3.3,0,0,0-.59-.09A.31.31,0,0,0,366.78,147Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 366.824px 146.714px 0px",
          }}
          id="elcrmnjmmszg"
          className="animable"
        ></path>
        <path
          d="M369.08,150.47a.3.3,0,0,0,.31-.24.3.3,0,0,0-.25-.34.29.29,0,0,0-.34.24.29.29,0,0,0,.22.33.29.29,0,0,0-.25.14.3.3,0,0,0-.21-.13.29.29,0,0,0-.09.58.28.28,0,0,0,.3-.13.26.26,0,0,0,.2.13.29.29,0,0,0,.34-.25A.3.3,0,0,0,369.08,150.47Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 368.807px 150.471px 0px",
          }}
          id="el6y59bt454sv"
          className="animable"
        ></path>
        <path
          d="M370.25,150.34a.29.29,0,0,0-.34.24.3.3,0,0,0,.59.09A.29.29,0,0,0,370.25,150.34Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 370.206px 150.615px 0px",
          }}
          id="eldhmplpe5l4a"
          className="animable"
        ></path>
        <path
          d="M371.57,149.31a.3.3,0,1,0,.25.34A.31.31,0,0,0,371.57,149.31Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 371.523px 149.606px 0px",
          }}
          id="elsgdtb1ra8ub"
          className="animable"
        ></path>
        <path
          d="M372.27,145.83a.3.3,0,0,0,.25.34.29.29,0,0,0,.09-.58A.29.29,0,0,0,372.27,145.83Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 372.563px 145.879px 0px",
          }}
          id="el52urqmyhsa2"
          className="animable"
        ></path>
        <path
          d="M370.7,145.78a.3.3,0,0,0,.34-.25v-.05a.33.33,0,0,0,.12.05.31.31,0,0,0,.34-.25s0,0,0,0a.16.16,0,0,0,.08.06.31.31,0,0,0-.08.15.31.31,0,0,0,.26.34.28.28,0,0,0,.33-.24s0,0,0,0l.1,0a.29.29,0,0,0,.34-.24.31.31,0,0,0-.25-.35.3.3,0,0,0-.29.14h0a.3.3,0,1,0-.59-.09v0a.28.28,0,0,0-.16-.09.31.31,0,0,0-.34.25v.05a.22.22,0,0,0-.11-.05.3.3,0,0,0-.1.59Zm1.25-.52,0,0,0,0h0S372,145.24,372,145.26Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 371.497px 145.3px 0px",
          }}
          id="elx32033qfh8"
          className="animable"
        ></path>
        <path
          d="M367.42,146.65a.3.3,0,1,0,.25.34A.31.31,0,0,0,367.42,146.65Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 367.373px 146.946px 0px",
          }}
          id="elkbrxe235pqp"
          className="animable"
        ></path>
        <path
          d="M378.28,217.3a1,1,0,0,0,1-.87,59.13,59.13,0,0,1,11.57-30.73.95.95,0,0,0-1.51-1.14,61.16,61.16,0,0,0-11.94,31.72,1,1,0,0,0,.87,1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 384.196px 200.775px 0px",
          }}
          id="el3qvkic9pgyi"
          className="animable"
        ></path>
        <g id="elp2ded6j87a">
          <g
            style={{
              opacity: "0.2",
              transformOrigin: " 384.196px 200.775px 0px",
            }}
            className="animable"
          >
            <path
              d="M378.28,217.3a1,1,0,0,0,1-.87,59.13,59.13,0,0,1,11.57-30.73.95.95,0,0,0-1.51-1.14,61.16,61.16,0,0,0-11.94,31.72,1,1,0,0,0,.87,1Z"
              id="elp2yjeipairo"
              style={{ transformOrigin: " 384.196px 200.775px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M390.79,184.63a8.62,8.62,0,0,0,4.08-1.77,20.42,20.42,0,0,0,4.41-3.66,6.08,6.08,0,0,0,1.5-4.1,6.76,6.76,0,0,0-1.42-3.73,8.47,8.47,0,0,0-3.29-2.63,10.46,10.46,0,0,0-4.67-.92,8.81,8.81,0,0,0-4.19,1.23,3.74,3.74,0,0,0-1.8,2.92,22.09,22.09,0,0,0,0,5.45,29.52,29.52,0,0,0,.85,4.41,2.48,2.48,0,0,0,1.18,1.82,6,6,0,0,0,3.33,1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 393.011px 176.232px 0px",
          }}
          id="elsm90y5fkcq"
          className="animable"
        ></path>
        <g id="elfee5lckcea">
          <path
            d="M390.79,184.63a8.62,8.62,0,0,0,4.08-1.77,20.42,20.42,0,0,0,4.41-3.66,7,7,0,0,0,.84-1.27c-.89.13-1.77.3-2.57.49a22.6,22.6,0,0,0-3.6,1.18c-.87.36-1.42.62-1.41.15a8.86,8.86,0,0,1,1.09-2.58c.5-.91.95-1.52.66-1.32a25.75,25.75,0,0,0-2.08,2c-.76.78-1.24,1.33-1.5,1a7.37,7.37,0,0,1-.23-2.86,7.67,7.67,0,0,0,0-2.41c-.18,0-.61,1.1-1,2.3s-.82,2.5-1.22,2.27-.79-2-1-3.91c-.18-1.65-.25-3.43-.47-4.78a3.87,3.87,0,0,0-1.29,2.56,22.09,22.09,0,0,0,0,5.45,29.52,29.52,0,0,0,.85,4.41,2.48,2.48,0,0,0,1.18,1.82,6,6,0,0,0,3.33,1Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 392.726px 177.08px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M385.54,171.05a3.73,3.73,0,0,0-1.18-1.91,5.41,5.41,0,0,0-3.55-.94,7.56,7.56,0,0,0-4.57,1.84,8,8,0,0,0-2.42,4.55,5.54,5.54,0,0,0,1,4.08,12.09,12.09,0,0,0,3.64,3.17,34.89,34.89,0,0,0,5,2.55c1.31.5,1.86.49,2.4.28a1.71,1.71,0,0,0,1.16-1.5,25.71,25.71,0,0,0-.45-4.16c-.23-1.89-.36-4.3-.51-5.68a7.66,7.66,0,0,0-.54-2.28Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 380.39px 176.493px 0px",
          }}
          id="elnmvjz1fpeo"
          className="animable"
        ></path>
        <g id="elbc1xvjln29s">
          <path
            d="M374.47,172.48a7.63,7.63,0,0,0-.65,2.11,4.82,4.82,0,0,0-.05,1.06,14.7,14.7,0,0,0,2.27,2.86,36.88,36.88,0,0,0,6.88,5c.93.55,1.73,1,2.38,1.32a1.82,1.82,0,0,0,.58-.13,1.71,1.71,0,0,0,1.16-1.5,25.71,25.71,0,0,0-.45-4.16c-.14-1.19-.25-2.59-.35-3.81-.09-.53-.19-1-.28-1.45-.41-1.91-.75-2.23-.86-1.52a25.31,25.31,0,0,0,.13,3.81c.1,1.33.17,2.23,0,2.21a8.64,8.64,0,0,1-1.13-2.1,14.43,14.43,0,0,0-1.74-2.93c-.48-.5-.75-.2-.71.37a8.44,8.44,0,0,0,.77,2.28,6.24,6.24,0,0,1,.71,2c-.12.15-.78-.52-1.63-1.3a26.53,26.53,0,0,0-2.85-2.37,10.39,10.39,0,0,0-3.13-1.5,10.25,10.25,0,0,0-1-.23Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 380.4px 178.372px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M399.7,178.69a3.6,3.6,0,0,1,2.23-.35,5.08,5.08,0,0,1,3,2,9.42,9.42,0,0,1,1.54,4.32,6.31,6.31,0,0,1-.56,3.87,4.35,4.35,0,0,1-2.9,2,11.28,11.28,0,0,1-4.48,0,18.35,18.35,0,0,1-4.74-1.52,7.92,7.92,0,0,1-3.32-2.58,2.43,2.43,0,0,1,.15-2.59,5.79,5.79,0,0,1,2.39-2c1.25-.68,3.08-1.51,4.28-2s1.77-.77,2.4-1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 398.364px 184.523px 0px",
          }}
          id="eloh4ff7lyc8"
          className="animable"
        ></path>
        <g id="elfp8dy8b5rqm">
          <path
            d="M399.7,178.69a3.6,3.6,0,0,1,2.23-.35,5,5,0,0,1,2.23,1.12,36.51,36.51,0,0,0-5,1.12,16.78,16.78,0,0,0-4.81,2.41c-.86.65-.88.9-.25.82s1.89-.52,2.87-.76,1.68-.24,1.5-.05a12.56,12.56,0,0,1-2.1,1c-.88.37-1.58.71-1.6.92s.65.28,2.1.41a27.83,27.83,0,0,1,3.95.48c.26.17-1.45.33-2.72.44a8.52,8.52,0,0,0-2.43.36c-.31.19-.11.51.6.94s1.9.95,3.23,1.61c.92.47,1.91,1,2.9,1.47a12.63,12.63,0,0,1-3.84-.16,18.35,18.35,0,0,1-4.74-1.52,7.92,7.92,0,0,1-3.32-2.58,2.43,2.43,0,0,1,.15-2.59,5.79,5.79,0,0,1,2.39-2c1.25-.68,3.08-1.51,4.28-2s1.77-.77,2.4-1Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 397.178px 184.5px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M391.71,187.52a56.65,56.65,0,0,1,5.45,2.63,21.89,21.89,0,0,1,4.4,2.81,3.08,3.08,0,0,1,1.1,2.55,4.71,4.71,0,0,1-.9,2.76,6.76,6.76,0,0,1-2.89,2,11.11,11.11,0,0,1-4.11.73,9,9,0,0,1-4.31-1.07,4.71,4.71,0,0,1-2-3.21,20.76,20.76,0,0,1-.34-4.77,25.25,25.25,0,0,1,.32-3.69c.15-.8.31-1,.74-1.15a4.44,4.44,0,0,1,2.56.45Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 395.378px 194.039px 0px",
          }}
          id="el29xtp7gz5hi"
          className="animable"
        ></path>
        <g id="elywde0r56vch">
          <path
            d="M391.71,187.52a56.65,56.65,0,0,1,5.45,2.63,35.59,35.59,0,0,1,3.22,1.88,29,29,0,0,0-3.09-.81c-1.16-.2-.91.21-.45.68s1.12,1,1.05,1.15-.87-.05-1.37-.22-.69-.27-.52,0,.7,1,1.24,1.71a7.55,7.55,0,0,1,1.43,2.41,10,10,0,0,1,.32,3.19l-.12.06a11.24,11.24,0,0,1-3.61.73l-.18-.14c-1-.69-1.74-1.39-2.83-3.74a39.23,39.23,0,0,1-2.87-8.59,4.27,4.27,0,0,1,0-1.46,5.36,5.36,0,0,1,2.36.49Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 394.849px 193.964px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M377.2,175.18c-1.38-.92-2.79-1.7-4.11-1.24s-2.53,2.15-3,4.05a9.18,9.18,0,0,0,.28,5.43,3.9,3.9,0,0,0,2.75,2.46,15.31,15.31,0,0,0,5.14.17,28.18,28.18,0,0,0,7.07-1.19c1.59-.66,1.64-1.63.71-2.78a27.6,27.6,0,0,0-4.44-3.68c-1.63-1.2-3-2.29-4.35-3.22Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 378.229px 179.997px 0px",
          }}
          id="ela65jlwp7007"
          className="animable"
        ></path>
        <g id="el0nk689t3c56m">
          <path
            d="M371,184.62a4,4,0,0,0,2,1.26,15.31,15.31,0,0,0,5.14.17,28.18,28.18,0,0,0,7.07-1.19c1.17-.48,1.5-1.13,1.23-1.9a7.55,7.55,0,0,0-.64-1q-.31-.37-.69-.78c-1-.93-2.4-1.91-3.63-2.83l-.23-.17a.32.32,0,0,0,0,.22c.17.36.77,1,.8,1.27s-.48.26-1.51-.1-2.54-1.07-3.1-1.24-.15.19.8.78,2.42,1.4,3,1.79.15.36-1,.11-3.13-.71-4.35-.9-1.7-.09-1.37.07,1.46.42,2.53.77,2.1.81,2.19,1.1-.78.44-1.86.47a27.32,27.32,0,0,0-3.41.13,4.59,4.59,0,0,0-2.23,1,2.9,2.9,0,0,0-.76.94Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 378.754px 182.185px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M387.61,187.61c-1.1,1.68-3,5-4,7s-1.37,2.87-1.41,3.64a3,3,0,0,0,1.08,2.42,10.42,10.42,0,0,0,4.12,2.48,9.66,9.66,0,0,0,4.95,0,12.82,12.82,0,0,0,4-1.6,2.1,2.1,0,0,0,1.13-2c0-.84-.28-2-1.49-4.26s-3.34-5.62-4.58-7.4-1.61-2-2-2-.7,0-1.8,1.69Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 389.841px 194.681px 0px",
          }}
          id="elnng6anbeum"
          className="animable"
        ></path>
        <g id="ell7yu1bwi9zo">
          <path
            d="M387.61,187.61c-1.1,1.68-3,5-4,7s-1.37,2.87-1.41,3.64a2.65,2.65,0,0,0,.16,1.1,3.53,3.53,0,0,0,.66,0,4.82,4.82,0,0,0,2.45-.54,4.25,4.25,0,0,0,1.56-2.24c.47-1.17,1-2.85,1.16-3.2s0,.61,0,1.76a7.53,7.53,0,0,0,.32,2.7c.19.22.4-.69.62-1.57s.44-1.75.75-1.57.69,1.38,1.07,2.13.75,1.07.85.61a15.41,15.41,0,0,0-.13-2.54c-.06-.87,0-1.41.66-1.12A19,19,0,0,1,395,196c.88.73,1.39,1.07,1.44.57a.76.76,0,0,0,0-.15c-.15-.33-.33-.67-.53-1.06-1.21-2.25-3.34-5.62-4.58-7.4s-1.61-2-2-2-.7,0-1.8,1.69Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 389.319px 192.663px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M385.66,184.79c-1-.25-2.21-.38-3.81-.71s-3.59-.89-5-1.08-2.19,0-2.75.85a8.15,8.15,0,0,0,.41,8.09,13.71,13.71,0,0,0,3.67,3.45,9.79,9.79,0,0,0,3.9,1.65,5.4,5.4,0,0,0,3.49-.48c.86-.53,1.25-1.43,1.64-3.09s.77-4.08.93-5.48.12-1.8-.3-2.19a5.31,5.31,0,0,0-2.2-1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 380.723px 190.038px 0px",
          }}
          id="elgh8szgf0yag"
          className="animable"
        ></path>
        <g id="el7v6flje0z4s">
          <path
            d="M385.66,184.79c-1-.25-2.21-.38-3.81-.71-.61-.13-1.27-.29-1.93-.45a2.2,2.2,0,0,0,.31.15c.82.36,1.4.37,1.71.7a.74.74,0,0,1-.42,1.25,14.92,14.92,0,0,1-3.45.16c-1.12,0-1.77.14-1.34.33a23.25,23.25,0,0,0,3.21.65c1.24.21,2.19.38,2.15.82s-1,1.17-1.92,1.92-1.63,1.49-1.56,1.67.95-.22,1.93-.81a12.93,12.93,0,0,1,2.48-1.41c.44-.05.23.62-.09,1.45a10,10,0,0,0-.74,2.25c0,.4.46.22,1.26-.28s1.93-1.28,2.42-1.24.32.89.29,1.94a15.83,15.83,0,0,0,.13,2.74,6.61,6.61,0,0,0,.94-2.45c.38-1.66.77-4.08.93-5.48s.12-1.8-.3-2.19a5.31,5.31,0,0,0-2.2-1Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 382.422px 189.775px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M389.08,182.64a4,4,0,0,1,1.14.38,4.83,4.83,0,0,1,1.26,1.34,3.36,3.36,0,0,1,.63,1.74,2.18,2.18,0,0,1-.73,1.53,3,3,0,0,1-1.63.79,3.78,3.78,0,0,1-1.83-.29A5.26,5.26,0,0,1,386,187a3.93,3.93,0,0,1-1-1.88,2.55,2.55,0,0,1,.18-1.6,2,2,0,0,1,1-1,3.07,3.07,0,0,1,1.6-.29,7,7,0,0,1,1.29.42Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 388.527px 185.327px 0px",
          }}
          id="elnbxjipmzr8q"
          className="animable"
        ></path>
        <g id="elrt9tluhbjv9">
          <path
            d="M389.08,182.64a4,4,0,0,1,1.14.38,4.83,4.83,0,0,1,1.26,1.34,3.36,3.36,0,0,1,.63,1.74,2.18,2.18,0,0,1-.73,1.53,3,3,0,0,1-1.63.79,3.78,3.78,0,0,1-1.83-.29A5.26,5.26,0,0,1,386,187a3.93,3.93,0,0,1-1-1.88,2.55,2.55,0,0,1,.18-1.6,2,2,0,0,1,1-1,3.07,3.07,0,0,1,1.6-.29,7,7,0,0,1,1.29.42Z"
            style={{
              fill: " rgb(255, 255, 255)",
              fillRule: "evenodd",
              opacity: "0.5",
              transformOrigin: " 388.527px 185.327px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M388.24,188a.32.32,0,1,1,0,.63.32.32,0,0,1,0-.63Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 388.296px 188.315px 0px",
          }}
          id="elpjj4p5afrs"
          className="animable"
        ></path>
        <path
          d="M390.12,188.17a.28.28,0,0,1,.17.07.33.33,0,0,1,.31-.2l.07,0,0-.09-.1,0a.39.39,0,0,1-.16-.07.31.31,0,0,1-.32.25.33.33,0,0,1-.22-.11.3.3,0,0,1-.32.26.32.32,0,0,1-.3-.34.32.32,0,0,1,.34-.29.28.28,0,0,1,.21.1.31.31,0,0,1,.32-.25.26.26,0,0,1,.17.07.3.3,0,0,1,.32-.26.32.32,0,0,1,.23.13.28.28,0,0,1,0-.09.32.32,0,0,1,.33-.3h.06a.27.27,0,0,1-.1-.24.32.32,0,0,1,.34-.3.32.32,0,0,1,.29.34v0a.36.36,0,0,1,.11-.1.3.3,0,0,1-.14-.28.3.3,0,0,1,.24-.28.36.36,0,0,1-.08-.23.34.34,0,0,1,.09-.2.33.33,0,0,1-.13,0,.31.31,0,0,1-.22.24.29.29,0,0,1,.1.23.32.32,0,0,1-.34.31.33.33,0,0,1-.3-.34.31.31,0,0,1,.24-.28.37.37,0,0,1-.1-.24.32.32,0,0,1,.34-.3.28.28,0,0,1,.13,0,.33.33,0,0,1,.32-.26.32.32,0,0,1,.3.34.34.34,0,0,1-.09.2.32.32,0,0,1,.29.34.31.31,0,0,1-.25.28.27.27,0,0,1,.08.23.29.29,0,0,1-.17.26.3.3,0,0,1,.14.28.31.31,0,0,1-.3.29.28.28,0,0,1,.07.22.31.31,0,0,1-.33.29.32.32,0,0,1-.3-.33.31.31,0,0,1,.31-.29.35.35,0,0,1-.08-.22s0,0,0,0a.31.31,0,0,1-.27.13l-.07,0a.36.36,0,0,1,.11.26.32.32,0,0,1-.34.29.29.29,0,0,1-.23-.13.44.44,0,0,1,0,.1.29.29,0,0,1-.05.13h.1a.32.32,0,0,1,0,.63l-.08,0a.3.3,0,0,1-.32.26.3.3,0,0,1-.17-.08.33.33,0,0,1-.31.2.32.32,0,1,1,0-.63Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 390.885px 186.963px 0px",
          }}
          id="elrqozn9i2iq"
          className="animable"
        ></path>
        <path
          d="M385.29,184.52a.33.33,0,0,1,.3-.18.32.32,0,0,1,.3.34.31.31,0,0,1-.33.29.29.29,0,0,1-.24-.14.32.32,0,0,1-.6-.16.31.31,0,0,1,.33-.29A.29.29,0,0,1,385.29,184.52Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 385.305px 184.668px 0px",
          }}
          id="el0u51ft44ghz"
          className="animable"
        ></path>
        <path
          d="M386.61,187.2a.35.35,0,0,1,.22.1.29.29,0,0,1,0-.09.32.32,0,0,1,.34-.3.31.31,0,0,1,.29.33h0a.31.31,0,0,1,.5.23.34.34,0,0,1,.29-.16.32.32,0,0,1,.3.34.32.32,0,0,1-.34.3.31.31,0,0,1-.29-.3.3.3,0,0,1-.29.15.32.32,0,0,1-.3-.33h0a.32.32,0,0,1-.2.07.31.31,0,0,1-.21-.11s0,.06,0,.09a0,0,0,0,1,0,0l.09,0a.32.32,0,0,1,.29.34.31.31,0,0,1-.33.29.32.32,0,0,1-.3-.33s0,0,0,0h-.08a.32.32,0,0,1,0-.63Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 387.439px 187.53px 0px",
          }}
          id="elevyvngkjcyq"
          className="animable"
        ></path>
        <path
          d="M384.46,185.25a.31.31,0,0,0,.29.33.31.31,0,0,0,.32-.22.28.28,0,0,0,.08.15h0a.32.32,0,1,0,.26.47.44.44,0,0,0,.08.11h0a.32.32,0,0,0-.34.29.32.32,0,0,0,.3.34.4.4,0,0,0,.15,0,.26.26,0,0,0-.07.17.31.31,0,1,0,.62,0,.3.3,0,0,0-.12-.26.31.31,0,0,0,.31-.29A.32.32,0,0,0,386,186h0a.27.27,0,0,0,0-.12.32.32,0,0,0-.59-.17.44.44,0,0,0-.08-.11h0a.32.32,0,0,0,.33-.3.31.31,0,0,0-.29-.33.32.32,0,0,1-.61,0A.31.31,0,0,0,384.46,185.25Zm1.28,1.24a.23.23,0,0,0,.07.07.28.28,0,0,0-.13,0A.21.21,0,0,0,385.74,186.49Zm-.08-.31h.06s0,0,0,.06Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 385.4px 186.086px 0px",
          }}
          id="elba4068w586"
          className="animable"
        ></path>
        <path
          d="M385.55,183.38a.27.27,0,0,1-.05.14.32.32,0,0,1,.21-.08.3.3,0,0,1,0-.16A.33.33,0,0,1,386,183a.32.32,0,0,1,0,.64.29.29,0,0,1,0,.16.31.31,0,0,1-.33.3.28.28,0,0,1-.16-.06s0,.05,0,.08a.32.32,0,0,1-.63,0,.32.32,0,0,1,.33-.3.38.38,0,0,1,.16.06s0-.05,0-.07a.34.34,0,0,1,.05-.14.29.29,0,0,1-.22.07.31.31,0,0,1-.3-.33.31.31,0,0,1,.33-.29A.31.31,0,0,1,385.55,183.38Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 385.6px 183.692px 0px",
          }}
          id="elyqsgtsidtf"
          className="animable"
        ></path>
        <path
          d="M385.52,183.11a.32.32,0,0,1-.3-.34.32.32,0,0,1,.34-.29.31.31,0,0,1,.29.33A.32.32,0,0,1,385.52,183.11Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 385.535px 182.795px 0px",
          }}
          id="elw2x3l5a1c99"
          className="animable"
        ></path>
        <path
          d="M390,182.92a.35.35,0,0,1,.13.27.32.32,0,0,1-.34.29.31.31,0,0,1-.29-.33v0a.27.27,0,0,1-.26.13.32.32,0,0,1-.3-.33l0-.09h0a.32.32,0,1,1,.33-.29.29.29,0,0,1,0,.09h0a.31.31,0,0,1,.29.33v0a.28.28,0,0,1,.15-.11.33.33,0,0,1-.13-.26.32.32,0,0,1,.34-.3.31.31,0,0,1,.29.33A.3.3,0,0,1,390,182.92Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 389.421px 182.85px 0px",
          }}
          id="eldfk302twx8"
          className="animable"
        ></path>
        <path
          d="M390.57,183.3a.31.31,0,0,1,.06.21.32.32,0,0,1-.34.29.32.32,0,0,1,0-.63.35.35,0,0,1-.07-.2.33.33,0,0,1,.34-.3.32.32,0,0,1,.3.34A.31.31,0,0,1,390.57,183.3Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 390.444px 183.235px 0px",
          }}
          id="elfucjtbhf54c"
          className="animable"
        ></path>
        <path
          d="M391,184a.32.32,0,1,1,0-.63.32.32,0,1,1,0,.63Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 391px 183.685px 0px",
          }}
          id="el76on5jk8rcw"
          className="animable"
        ></path>
        <path
          d="M391.52,184.56a.32.32,0,0,1-.28-.2.3.3,0,0,1-.32.26.32.32,0,0,1-.3-.33A.32.32,0,0,1,391,184a.33.33,0,0,1,.27.21.31.31,0,0,1,.32-.25.31.31,0,1,1,0,.62Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 391.261px 184.29px 0px",
          }}
          id="el4nuho50h8l5"
          className="animable"
        ></path>
        <path
          d="M392,185.12a.32.32,0,1,1,.33-.31A.32.32,0,0,1,392,185.12Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 392.01px 184.8px 0px",
          }}
          id="el16v5p59ylya"
          className="animable"
        ></path>
        <path
          d="M388.83,188.22a.29.29,0,1,1,.07,0,.28.28,0,0,1,.23.19.35.35,0,0,1,.24-.08.31.31,0,0,1,.3.33.31.31,0,0,1-.61.09.32.32,0,0,1-.24.09.32.32,0,0,1,0-.63Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 389.114px 188.313px 0px",
          }}
          id="el8bhmgd2htad"
          className="animable"
        ></path>
        <path
          d="M387.65,187.82a.31.31,0,1,1,0,.62.32.32,0,0,1-.3-.33A.32.32,0,0,1,387.65,187.82Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 387.656px 188.13px 0px",
          }}
          id="eliwlny9mivua"
          className="animable"
        ></path>
        <path
          d="M386.5,186.45a.32.32,0,0,1,.3.34.32.32,0,0,1-.63,0A.32.32,0,0,1,386.5,186.45Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 386.485px 186.752px 0px",
          }}
          id="elt6akon6w23p"
          className="animable"
        ></path>
        <path
          d="M386.56,182.67a.31.31,0,0,1-.33.3.32.32,0,0,1-.3-.33.32.32,0,0,1,.34-.3A.31.31,0,0,1,386.56,182.67Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 386.245px 182.655px 0px",
          }}
          id="elsue1nx2r2u8"
          className="animable"
        ></path>
        <path
          d="M388.54,182.67a.31.31,0,0,0-.3-.33.2.2,0,0,0-.13,0s0,0,0-.05a.31.31,0,0,0-.29-.33.3.3,0,0,0-.19.05,0,0,0,0,1,0,0,.33.33,0,0,0-.3-.34.32.32,0,0,0-.33.31h0a.34.34,0,0,0-.27-.21.32.32,0,0,0-.34.31.31.31,0,0,0,.3.33l.11,0s0,0,0,0a.32.32,0,0,0,.3.34.32.32,0,0,0,.33-.3.25.25,0,0,0,0-.17l.1,0a0,0,0,0,1,0,0,.32.32,0,0,0,.3.33.23.23,0,0,0,.14,0,.14.14,0,0,0,0,.06.32.32,0,0,0,.63,0Zm-1.5-.57h0l0,0h0S387,182.12,387,182.1Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 387.495px 182.302px 0px",
          }}
          id="elfz7wfrta99f"
          className="animable"
        ></path>
        <path
          d="M391.43,184.62a.32.32,0,0,1,.29.34.31.31,0,0,1-.62,0A.32.32,0,0,1,391.43,184.62Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 391.41px 184.944px 0px",
          }}
          id="elnr10luwaxsf"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--flowers-6--inject-18"
        style={{ transformOrigin: " 390.433px 319.67px 0px" }}
        className="animable"
      >
        <path
          d="M415.91,337.89l-33.36,1-33.36-1c-1.44,22.53,3,45.49,9,56.71h0a15.15,15.15,0,0,0,6.6,6.72c9.84,5.69,25.75,5.69,35.53,0,3.39-2,5.57-4.37,6.6-6.89C413,383.14,417.34,360.31,415.91,337.89Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 382.551px 371.739px 0px",
          }}
          id="elcgjvz2xvxz"
          className="animable"
        ></path>
        <g id="elr96qz48kw4q">
          <path
            d="M415.91,337.89l-33.36,1-33.36-1c-1.44,22.53,3,45.49,9,56.71h0a15.15,15.15,0,0,0,6.6,6.72c9.84,5.69,25.75,5.69,35.53,0,3.39-2,5.57-4.37,6.6-6.89C413,383.14,417.34,360.31,415.91,337.89Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.5",
              transformOrigin: " 382.551px 371.739px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M406.06,324.23c13.07,7.55,13.14,19.78.15,27.33s-34.1,7.54-47.17,0-13.14-19.78-.16-27.33S393,316.68,406.06,324.23Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 382.549px 337.893px 0px",
          }}
          id="elcfg3orsrz49"
          className="animable"
        ></path>
        <g id="elcxbikn2iuj">
          <g
            style={{
              opacity: "0.7",
              transformOrigin: " 382.549px 337.893px 0px",
            }}
            className="animable"
          >
            <path
              d="M406.06,324.23c13.07,7.55,13.14,19.78.15,27.33s-34.1,7.54-47.17,0-13.14-19.78-.16-27.33S393,316.68,406.06,324.23Z"
              style={{
                fill: " rgb(255, 255, 255)",
                transformOrigin: " 382.549px 337.893px 0px",
              }}
              id="elyutezajmodd"
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M402.23,326.46c10.94,6.31,11,16.55.13,22.87s-28.55,6.32-39.49,0-11-16.56-.13-22.87S391.29,320.14,402.23,326.46Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 382.55px 337.897px 0px",
          }}
          id="ells96tj2itoa"
          className="animable"
        ></path>
        <path
          d="M386.64,347.36a1.11,1.11,0,0,1-1.11-1.07,63.39,63.39,0,0,1,7.71-32.47,1.1,1.1,0,1,1,1.94,1.05,61.2,61.2,0,0,0-7.44,31.35,1.11,1.11,0,0,1-1.07,1.14Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 390.404px 330.301px 0px",
          }}
          id="eliyu3b7pz5v"
          className="animable"
        ></path>
        <path
          d="M376.74,338.17a.91.91,0,0,1-.36-.06,1.1,1.1,0,0,1-.69-1.4A172.76,172.76,0,0,0,384,261.55a1.11,1.11,0,0,1,1-1.22,1.1,1.1,0,0,1,1.22,1,175.35,175.35,0,0,1-8.41,76.13A1.1,1.1,0,0,1,376.74,338.17Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 381.457px 299.247px 0px",
          }}
          id="el5qw8j6wbz7i"
          className="animable"
        ></path>
        <g id="eljncx1yeuw9">
          <g
            style={{
              opacity: "0.2",
              transformOrigin: " 385.472px 303.841px 0px",
            }}
            className="animable"
          >
            <path
              d="M386.64,347.36a1.11,1.11,0,0,1-1.11-1.07,63.39,63.39,0,0,1,7.71-32.47,1.1,1.1,0,1,1,1.94,1.05,61.2,61.2,0,0,0-7.44,31.35,1.11,1.11,0,0,1-1.07,1.14Z"
              style={{
                fill: " rgb(255, 255, 255)",
                transformOrigin: " 390.404px 330.301px 0px",
              }}
              id="elumpt2nn3ya"
              className="animable"
            ></path>
            <path
              d="M376.74,338.17a.91.91,0,0,1-.36-.06,1.1,1.1,0,0,1-.69-1.4A172.76,172.76,0,0,0,384,261.55a1.11,1.11,0,0,1,1-1.22,1.1,1.1,0,0,1,1.22,1,175.35,175.35,0,0,1-8.41,76.13A1.1,1.1,0,0,1,376.74,338.17Z"
              style={{
                fill: " rgb(255, 255, 255)",
                transformOrigin: " 381.457px 299.247px 0px",
              }}
              id="elmi3k96twpzq"
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M424.63,281.12c.23-.07.66-.21,1.44-.5a17.66,17.66,0,0,0,3-1.39,8.62,8.62,0,0,0,3.18-3.48,49.47,49.47,0,0,0,2.67-6.26c.53-1.44.54-1.46-.45-.68s-3,2.34-4.61,3.78a26,26,0,0,0-3.53,3.9,11.32,11.32,0,0,0-1.49,2.72,10,10,0,0,0-.44,1.74c-.05.32,0,.27.22.17Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 429.83px 274.746px 0px",
          }}
          id="elqy9lkozhq6j"
          className="animable"
        ></path>
        <path
          d="M424.55,292.78c.47-.19,1.36-.5,2.28-.77a7.73,7.73,0,0,0,3-1.52,24.85,24.85,0,0,0,3.43-4.28,50.93,50.93,0,0,0,3.06-5A14.45,14.45,0,0,0,437.7,278c.07-.43-.32,0-1.19.62s-2.23,1.55-3.6,2.34a33.92,33.92,0,0,0-3.92,2.41,13.13,13.13,0,0,0-3,3.49,20.41,20.41,0,0,0-1.81,3.93,6.74,6.74,0,0,0-.35,2.12c0,.31,0,.28.09.2s.13-.17.62-.37Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 430.769px 285.495px 0px",
          }}
          id="el2597bnglcqj"
          className="animable"
        ></path>
        <path
          d="M421.11,305.27a20.73,20.73,0,0,1,2.24.08,16.51,16.51,0,0,0,4.1.06,10.67,10.67,0,0,0,4.92-2,33.28,33.28,0,0,0,4.14-4.19c1.19-1.27,2.19-2.07,2.62-2.48s.3-.38-.64-.36-2.66,0-4.24,0a13.22,13.22,0,0,0-4.61.1,13.72,13.72,0,0,0-4.48,2.38,9.21,9.21,0,0,0-2.49,2.72,32.32,32.32,0,0,0-1.79,3.15c-.33.7-.19.65.23.63Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 430.031px 300.867px 0px",
          }}
          id="eln9qbh5bpwkk"
          className="animable"
        ></path>
        <path
          d="M434.3,312.78c-.63-.07-1.68-.07-2.86-.18s-2.45-.35-3.85-.46a17.59,17.59,0,0,0-4.36.2,8.44,8.44,0,0,0-3.6,1.51,18.25,18.25,0,0,0-3,2.87c-.94,1.07-1.85,2.16-2.36,2.83a10.14,10.14,0,0,0-.71.95c-.07.12-.07.12.33.16s1.16.1,2.34.24,2.76.31,4.12.36a9.3,9.3,0,0,0,4-.56,20,20,0,0,0,4.57-2.76c1.58-1.21,3.15-2.62,4.22-3.45s1.62-1.12,1.8-1.32,0-.33-.63-.39Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 424.266px 316.688px 0px",
          }}
          id="elkbxhjywru8b"
          className="animable"
        ></path>
        <path
          d="M424.72,331.48a20.28,20.28,0,0,1-10.46,5.59,10.49,10.49,0,0,1-5.11-.62c-1.55-.51-3.12-1.13-4-1.48a5.3,5.3,0,0,1-1-.48s0,0,.26-.39a13.29,13.29,0,0,1,1.91-1.89,16.34,16.34,0,0,1,4-2.44,14.19,14.19,0,0,1,4.94-1.1,15.63,15.63,0,0,1,4.63.74c1.5.44,3,1,4,1.2s1.35.2.8.87Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 414.55px 332.912px 0px",
          }}
          id="el7v857xv5vu5"
          className="animable"
        ></path>
        <path
          d="M421.69,285.71a12.6,12.6,0,0,0,.36-4,15.72,15.72,0,0,0-1.41-6.29,14.44,14.44,0,0,0-3.49-4,16.13,16.13,0,0,1-1.68-1.76c-.23-.21-.17,0-.17.53a31.63,31.63,0,0,1-.19,3.28,16.47,16.47,0,0,0,.21,6.14,11.93,11.93,0,0,0,3.28,4.72,12.1,12.1,0,0,0,2.23,1.69c.44.25.64.36.86-.3Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 418.499px 277.897px 0px",
          }}
          id="elaknx6bark4p"
          className="animable"
        ></path>
        <path
          d="M419.44,297.22a27,27,0,0,0,.66-6.71,9.68,9.68,0,0,0-2.79-5.65c-1.51-1.76-3.56-3.63-4.66-4.72s-1.28-1.46-1.32-1.36,0,.68,0,2.18a36.22,36.22,0,0,0-.12,6.24,13.44,13.44,0,0,0,2.43,6.51,23.69,23.69,0,0,0,4.55,4.51c1,.76,1,.57,1.29-1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 415.619px 288.708px 0px",
          }}
          id="elfs62q6xfi28"
          className="animable"
        ></path>
        <path
          d="M413.5,313.36a25,25,0,0,0,.48-6,16,16,0,0,0-2.46-7.34,28.27,28.27,0,0,0-4.86-5.38c-1.16-1-1.32-1.11-1.45-.93a7,7,0,0,0-.39,2.16,25.87,25.87,0,0,0,0,6.44,12.25,12.25,0,0,0,2.56,5.71,54.35,54.35,0,0,0,3.89,4.07,20.28,20.28,0,0,1,1.85,2.32c.25.35.21.19.41-1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 409.31px 304.106px 0px",
          }}
          id="elwoq6gysinbj"
          className="animable"
        ></path>
        <path
          d="M404,329.21a33.24,33.24,0,0,0,1.26-4.67,32.46,32.46,0,0,0,.58-7.58,8.42,8.42,0,0,0-1.74-4.56,36.29,36.29,0,0,1-2.48-3.78,14.63,14.63,0,0,1-.82-2.47c-.11-.34-.26,0-.51.89a34.84,34.84,0,0,0-.95,4.3,28.8,28.8,0,0,0-.35,6.37,14.86,14.86,0,0,0,1.51,5.17c.74,1.58,1.64,3.15,2.19,4.43a18.39,18.39,0,0,1,.86,2.63c.12.36.15.15.45-.73Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 402.406px 318.064px 0px",
          }}
          id="elk77y8ht9m9"
          className="animable"
        ></path>
        <g id="elpkl747az4lr">
          <path
            d="M424.63,281.12c.23-.07.66-.21,1.44-.5a17.66,17.66,0,0,0,3-1.39,8.62,8.62,0,0,0,3.18-3.48,49.47,49.47,0,0,0,2.67-6.26c.53-1.44.54-1.46-.45-.68s-3,2.34-4.61,3.78a26,26,0,0,0-3.53,3.9,11.32,11.32,0,0,0-1.49,2.72,10,10,0,0,0-.44,1.74c-.05.32,0,.27.22.17Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 429.83px 274.746px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elc7faqcxhuf">
          <path
            d="M424.55,292.78c.47-.19,1.36-.5,2.28-.77a7.73,7.73,0,0,0,3-1.52,24.85,24.85,0,0,0,3.43-4.28,50.93,50.93,0,0,0,3.06-5A14.45,14.45,0,0,0,437.7,278c.07-.43-.32,0-1.19.62s-2.23,1.55-3.6,2.34a33.92,33.92,0,0,0-3.92,2.41,13.13,13.13,0,0,0-3,3.49,20.41,20.41,0,0,0-1.81,3.93,6.74,6.74,0,0,0-.35,2.12c0,.31,0,.28.09.2s.13-.17.62-.37Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 430.769px 285.495px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elynji0qgapfm">
          <path
            d="M421.11,305.27a20.73,20.73,0,0,1,2.24.08,16.51,16.51,0,0,0,4.1.06,10.67,10.67,0,0,0,4.92-2,33.28,33.28,0,0,0,4.14-4.19c1.19-1.27,2.19-2.07,2.62-2.48s.3-.38-.64-.36-2.66,0-4.24,0a13.22,13.22,0,0,0-4.61.1,13.72,13.72,0,0,0-4.48,2.38,9.21,9.21,0,0,0-2.49,2.72,32.32,32.32,0,0,0-1.79,3.15c-.33.7-.19.65.23.63Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 430.031px 300.867px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elo6cizd68bip">
          <path
            d="M434.3,312.78c-.63-.07-1.68-.07-2.86-.18s-2.45-.35-3.85-.46a17.59,17.59,0,0,0-4.36.2,8.44,8.44,0,0,0-3.6,1.51,18.25,18.25,0,0,0-3,2.87c-.94,1.07-1.85,2.16-2.36,2.83a10.14,10.14,0,0,0-.71.95c-.07.12-.07.12.33.16s1.16.1,2.34.24,2.76.31,4.12.36a9.3,9.3,0,0,0,4-.56,20,20,0,0,0,4.57-2.76c1.58-1.21,3.15-2.62,4.22-3.45s1.62-1.12,1.8-1.32,0-.33-.63-.39Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 424.266px 316.688px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="eljf22u6z7j8q">
          <path
            d="M424.72,331.48a20.28,20.28,0,0,1-10.46,5.59,10.49,10.49,0,0,1-5.11-.62c-1.55-.51-3.12-1.13-4-1.48a5.3,5.3,0,0,1-1-.48s0,0,.26-.39a13.29,13.29,0,0,1,1.91-1.89,16.34,16.34,0,0,1,4-2.44,14.19,14.19,0,0,1,4.94-1.1,15.63,15.63,0,0,1,4.63.74c1.5.44,3,1,4,1.2s1.35.2.8.87Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 414.55px 332.912px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elz89dfoyglj">
          <path
            d="M421.69,285.71a12.6,12.6,0,0,0,.36-4,15.72,15.72,0,0,0-1.41-6.29,14.44,14.44,0,0,0-3.49-4,16.13,16.13,0,0,1-1.68-1.76c-.23-.21-.17,0-.17.53a31.63,31.63,0,0,1-.19,3.28,16.47,16.47,0,0,0,.21,6.14,11.93,11.93,0,0,0,3.28,4.72,12.1,12.1,0,0,0,2.23,1.69c.44.25.64.36.86-.3Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 418.499px 277.897px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="eleaecmlkos4e">
          <path
            d="M419.44,297.22a27,27,0,0,0,.66-6.71,9.68,9.68,0,0,0-2.79-5.65c-1.51-1.76-3.56-3.63-4.66-4.72s-1.28-1.46-1.32-1.36,0,.68,0,2.18a36.22,36.22,0,0,0-.12,6.24,13.44,13.44,0,0,0,2.43,6.51,23.69,23.69,0,0,0,4.55,4.51c1,.76,1,.57,1.29-1Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 415.619px 288.708px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elk6lwbw94bp">
          <path
            d="M413.5,313.36a25,25,0,0,0,.48-6,16,16,0,0,0-2.46-7.34,28.27,28.27,0,0,0-4.86-5.38c-1.16-1-1.32-1.11-1.45-.93a7,7,0,0,0-.39,2.16,25.87,25.87,0,0,0,0,6.44,12.25,12.25,0,0,0,2.56,5.71,54.35,54.35,0,0,0,3.89,4.07,20.28,20.28,0,0,1,1.85,2.32c.25.35.21.19.41-1Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 409.31px 304.106px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elov089bwnwos">
          <path
            d="M404,329.21a33.24,33.24,0,0,0,1.26-4.67,32.46,32.46,0,0,0,.58-7.58,8.42,8.42,0,0,0-1.74-4.56,36.29,36.29,0,0,1-2.48-3.78,14.63,14.63,0,0,1-.82-2.47c-.11-.34-.26,0-.51.89a34.84,34.84,0,0,0-.95,4.3,28.8,28.8,0,0,0-.35,6.37,14.86,14.86,0,0,0,1.51,5.17c.74,1.58,1.64,3.15,2.19,4.43a18.39,18.39,0,0,1,.86,2.63c.12.36.15.15.45-.73Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 402.406px 318.064px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M392.45,342.63l0,0c2.75-2.78,5.49-5.56,8.21-8.14l.39-.36a.07.07,0,0,1,0,0l.57-.54c.45-.42.92-.86,1.36-1.29a18.55,18.55,0,0,0,.75-4.93,30.63,30.63,0,0,0-.2-3.55c-.13-1.4-.34-2.85-.59-4.21-.46-2.64-1.08-5-1.71-7.36v0a.21.21,0,0,1,.16-.24.22.22,0,0,1,.27.15h0c.62,2.35,1.23,4.72,1.72,7.4.23,1.38.45,2.83.59,4.23a31.32,31.32,0,0,1,.18,3.61,16.79,16.79,0,0,1-.59,4.35,41.66,41.66,0,0,0,5.06-5.75,56.28,56.28,0,0,0,3.76-6.09c.39-.74.77-1.48,1.15-2.24-.12-.79-.24-1.56-.4-2.43s-.37-1.82-.64-2.9-.69-2.49-1.13-3.78c-.38-1.12-.81-2.24-1.25-3.21a24.66,24.66,0,0,0-1.41-2.65c-.5-.77-1-1.46-1.48-2.15a.22.22,0,0,1,.35-.26c.5.7,1,1.41,1.49,2.19a24.59,24.59,0,0,1,1.45,2.7c.43,1,.86,2.1,1.26,3.23.43,1.31.83,2.65,1.14,3.8s.49,2.06.65,2.95c.12.65.23,1.25.32,1.85.7-1.4,1.38-2.85,2.06-4.3a82.89,82.89,0,0,0,3.22-7.82c.13-.32.24-.65.35-1-.14-1.25-.27-2.5-.57-4.61-.14-1.05-.34-2.32-.62-3.6a21.38,21.38,0,0,0-1.14-3.74,20.31,20.31,0,0,0-4.06-5.68v0a.21.21,0,0,1,0-.3.24.24,0,0,1,.31,0,20.55,20.55,0,0,1,4.12,5.79,21,21,0,0,1,1.17,3.82c.29,1.31.47,2.58.63,3.64.21,1.55.35,2.66.46,3.63a50.63,50.63,0,0,0,1.64-7,74.73,74.73,0,0,0,.81-7.78l-.77-1.34c-.31-.52-.62-1.06-1-1.65s-.74-1.32-1.1-2a19.62,19.62,0,0,1-.94-2.22,13.68,13.68,0,0,1-.52-3.33c0-.2,0-.41,0-.63v-.11l-.39-.81a.23.23,0,0,1,.12-.28.22.22,0,0,1,.28.11c.18.38.3.66.47,1,.33.44.13,2.72.5,3.86a15.73,15.73,0,0,0,.9,2.16c.36.72.75,1.41,1.08,2s.67,1.18,1,1.66l.44.76c0-.53.06-1.08.07-1.63v0l0-.55c.13-3.81.12-7.81.11-11.8h.46c0,3.74,0,7.47-.13,11.06a19.45,19.45,0,0,1,1.66-3.4,25.09,25.09,0,0,1,3.45-3.86l3.71-3.6a.22.22,0,0,1,.3.33l-3.69,3.58a22.88,22.88,0,0,0-3.4,3.81,21.48,21.48,0,0,0-2.07,4.51,89,89,0,0,1-.85,9.8,35.32,35.32,0,0,1,2.68-3.63,56.88,56.88,0,0,1,4.18-4.22l5-4.76a.2.2,0,0,1,.3,0,.2.2,0,0,1,0,.31l-5.05,4.76a51,51,0,0,0-4.16,4.18,47,47,0,0,0-3.18,4.36,53.85,53.85,0,0,1-2.23,8.49c-.13.38-.26.76-.41,1.14.33-.26.7-.51,1.1-.79.65-.44,1.45-.95,2.53-1.58s2.44-1.35,3.74-2l3.34-1.74,1.63-.84a.24.24,0,0,1,.3.1.23.23,0,0,1-.1.29l-1.64.84-3.33,1.74c-1.29.69-2.65,1.41-3.72,2s-1.85,1.12-2.5,1.57-1.15.81-1.63,1.17c-.8,2.07-1.68,4-2.57,6-1.14,2.5-2.34,5-3.56,7.21-.22.4-.42.8-.66,1.18.18-.13.37-.29.57-.43a10.31,10.31,0,0,1,2-1.25,15.88,15.88,0,0,1,2.26-.9,27.48,27.48,0,0,1,2.69-.72c.56-.11,1-.17,1.46-.24a14.07,14.07,0,0,0,2.07-.42,30.21,30.21,0,0,0,4-1.84.21.21,0,0,1,.25,0,.24.24,0,0,1,0,.33l0,0a31.73,31.73,0,0,1-4.08,1.86,12.34,12.34,0,0,1-2.13.46l-1.44.23c-.79.17-1.71.4-2.65.69a19.19,19.19,0,0,0-2.21.88,10.86,10.86,0,0,0-1.88,1.2c-.54.42-1,.87-1.52,1.32-.8,1.36-1.62,2.63-2.44,3.77a44.26,44.26,0,0,1-5.64,6.32h0v0h0l-1.4,1.32-.28.26a7.32,7.32,0,0,0,2.45.13c.69-.08,1.54-.24,2.57-.43s2-.39,3.29-.6c2.65-.41,6.08-.77,9.5-1.15h0a.22.22,0,0,1,.24.2.21.21,0,0,1-.2.23h0c-3.42.37-6.85.74-9.5,1.16-1.28.2-2.35.39-3.27.58s-1.9.37-2.6.44a8.72,8.72,0,0,1-2.88-.19l-.32.29c-2.73,2.6-5.48,5.37-8.21,8.14l0,0Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 413.317px 308.085px 0px",
          }}
          id="elzg2wjh1fbo"
          className="animable"
        ></path>
        <g id="elbh3jlbj9bz5">
          <path
            d="M392.45,342.63l0,0c2.75-2.78,5.49-5.56,8.21-8.14l.39-.36a.07.07,0,0,1,0,0l.57-.54c.45-.42.92-.86,1.36-1.29a18.55,18.55,0,0,0,.75-4.93,30.63,30.63,0,0,0-.2-3.55c-.13-1.4-.34-2.85-.59-4.21-.46-2.64-1.08-5-1.71-7.36v0a.21.21,0,0,1,.16-.24.22.22,0,0,1,.27.15h0c.62,2.35,1.23,4.72,1.72,7.4.23,1.38.45,2.83.59,4.23a31.32,31.32,0,0,1,.18,3.61,16.79,16.79,0,0,1-.59,4.35,41.66,41.66,0,0,0,5.06-5.75,56.28,56.28,0,0,0,3.76-6.09c.39-.74.77-1.48,1.15-2.24-.12-.79-.24-1.56-.4-2.43s-.37-1.82-.64-2.9-.69-2.49-1.13-3.78c-.38-1.12-.81-2.24-1.25-3.21a24.66,24.66,0,0,0-1.41-2.65c-.5-.77-1-1.46-1.48-2.15a.22.22,0,0,1,.35-.26c.5.7,1,1.41,1.49,2.19a24.59,24.59,0,0,1,1.45,2.7c.43,1,.86,2.1,1.26,3.23.43,1.31.83,2.65,1.14,3.8s.49,2.06.65,2.95c.12.65.23,1.25.32,1.85.7-1.4,1.38-2.85,2.06-4.3a82.89,82.89,0,0,0,3.22-7.82c.13-.32.24-.65.35-1-.14-1.25-.27-2.5-.57-4.61-.14-1.05-.34-2.32-.62-3.6a21.38,21.38,0,0,0-1.14-3.74,20.31,20.31,0,0,0-4.06-5.68v0a.21.21,0,0,1,0-.3.24.24,0,0,1,.31,0,20.55,20.55,0,0,1,4.12,5.79,21,21,0,0,1,1.17,3.82c.29,1.31.47,2.58.63,3.64.21,1.55.35,2.66.46,3.63a50.63,50.63,0,0,0,1.64-7,74.73,74.73,0,0,0,.81-7.78l-.77-1.34c-.31-.52-.62-1.06-1-1.65s-.74-1.32-1.1-2a19.62,19.62,0,0,1-.94-2.22,13.68,13.68,0,0,1-.52-3.33c0-.2,0-.41,0-.63v-.11l-.39-.81a.23.23,0,0,1,.12-.28.22.22,0,0,1,.28.11c.18.38.3.66.47,1,.33.44.13,2.72.5,3.86a15.73,15.73,0,0,0,.9,2.16c.36.72.75,1.41,1.08,2s.67,1.18,1,1.66l.44.76c0-.53.06-1.08.07-1.63v0l0-.55c.13-3.81.12-7.81.11-11.8h.46c0,3.74,0,7.47-.13,11.06a19.45,19.45,0,0,1,1.66-3.4,25.09,25.09,0,0,1,3.45-3.86l3.71-3.6a.22.22,0,0,1,.3.33l-3.69,3.58a22.88,22.88,0,0,0-3.4,3.81,21.48,21.48,0,0,0-2.07,4.51,89,89,0,0,1-.85,9.8,35.32,35.32,0,0,1,2.68-3.63,56.88,56.88,0,0,1,4.18-4.22l5-4.76a.2.2,0,0,1,.3,0,.2.2,0,0,1,0,.31l-5.05,4.76a51,51,0,0,0-4.16,4.18,47,47,0,0,0-3.18,4.36,53.85,53.85,0,0,1-2.23,8.49c-.13.38-.26.76-.41,1.14.33-.26.7-.51,1.1-.79.65-.44,1.45-.95,2.53-1.58s2.44-1.35,3.74-2l3.34-1.74,1.63-.84a.24.24,0,0,1,.3.1.23.23,0,0,1-.1.29l-1.64.84-3.33,1.74c-1.29.69-2.65,1.41-3.72,2s-1.85,1.12-2.5,1.57-1.15.81-1.63,1.17c-.8,2.07-1.68,4-2.57,6-1.14,2.5-2.34,5-3.56,7.21-.22.4-.42.8-.66,1.18.18-.13.37-.29.57-.43a10.31,10.31,0,0,1,2-1.25,15.88,15.88,0,0,1,2.26-.9,27.48,27.48,0,0,1,2.69-.72c.56-.11,1-.17,1.46-.24a14.07,14.07,0,0,0,2.07-.42,30.21,30.21,0,0,0,4-1.84.21.21,0,0,1,.25,0,.24.24,0,0,1,0,.33l0,0a31.73,31.73,0,0,1-4.08,1.86,12.34,12.34,0,0,1-2.13.46l-1.44.23c-.79.17-1.71.4-2.65.69a19.19,19.19,0,0,0-2.21.88,10.86,10.86,0,0,0-1.88,1.2c-.54.42-1,.87-1.52,1.32-.8,1.36-1.62,2.63-2.44,3.77a44.26,44.26,0,0,1-5.64,6.32h0v0h0l-1.4,1.32-.28.26a7.32,7.32,0,0,0,2.45.13c.69-.08,1.54-.24,2.57-.43s2-.39,3.29-.6c2.65-.41,6.08-.77,9.5-1.15h0a.22.22,0,0,1,.24.2.21.21,0,0,1-.2.23h0c-3.42.37-6.85.74-9.5,1.16-1.28.2-2.35.39-3.27.58s-1.9.37-2.6.44a8.72,8.72,0,0,1-2.88-.19l-.32.29c-2.73,2.6-5.48,5.37-8.21,8.14l0,0Z"
            style={{
              opacity: "0.4",
              transformOrigin: " 413.317px 308.085px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M362,273.7c-.2-.12-.56-.34-1.21-.78a16.24,16.24,0,0,1-2.38-1.9,6.49,6.49,0,0,1-1.81-3.61,35.09,35.09,0,0,1-.38-5.67c0-1.28,0-1.29.65-.44s2,2.59,3,4.14a18.42,18.42,0,0,1,2,4,8,8,0,0,1,.5,2.6,7.32,7.32,0,0,1-.17,1.55c-.07.27-.09.22-.27.08Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 359.293px 267.248px 0px",
          }}
          id="elk0040j4q5sf"
          className="animable"
        ></path>
        <path
          d="M358.09,283.28c-.38-.28-1.12-.78-1.89-1.26a6.83,6.83,0,0,1-2.26-2,18.13,18.13,0,0,1-1.75-4.38,39.39,39.39,0,0,1-1.13-4.8,10.68,10.68,0,0,1-.24-2.88c.09-.36.3.06.89.79a33.05,33.05,0,0,0,2.53,2.77,28.23,28.23,0,0,1,2.85,3,10.05,10.05,0,0,1,1.64,3.63,15.32,15.32,0,0,1,.38,3.72,5.13,5.13,0,0,1-.4,1.83c-.11.26-.13.23-.16.14s-.06-.18-.46-.48Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 354.959px 275.867px 0px",
          }}
          id="eli1ewt4jbpvb"
          className="animable"
        ></path>
        <path
          d="M357.07,294.58c-.41-.14-1.1-.36-2.16-.61a17.8,17.8,0,0,1-3.88-1.18,10.06,10.06,0,0,1-3.86-3.1,27.46,27.46,0,0,1-2.36-4.54,29.74,29.74,0,0,0-1.52-2.7c-.25-.43-.14-.38.69-.11s2.4.75,3.87,1.11a14,14,0,0,1,4.22,1.36,12.47,12.47,0,0,1,3.39,3.22,7.63,7.63,0,0,1,1.43,3,25.48,25.48,0,0,1,.62,3.14c.08.68,0,.6-.44.45Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 350.355px 288.427px 0px",
          }}
          id="el44oiuvqyhzh"
          className="animable"
        ></path>
        <path
          d="M342.23,296.72c.59.14,1.55.45,2.66.72s2.37.46,3.71.81a19.63,19.63,0,0,1,4,1.51,8.49,8.49,0,0,1,2.9,2.4,15.81,15.81,0,0,1,1.87,3.36c.54,1.21,1,2.42,1.31,3.16a9.77,9.77,0,0,1,.35,1c0,.13,0,.13-.37,0s-1.17-.3-2.36-.59-2.76-.67-4.08-1.09a9.89,9.89,0,0,1-3.54-1.76,18.33,18.33,0,0,1-3.29-3.73c-1-1.48-2-3.11-2.69-4.12s-1.09-1.39-1.18-1.6.12-.27.7-.13Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 350.265px 303.181px 0px",
          }}
          id="elwa1lray8hze"
          className="animable"
        ></path>
        <path
          d="M344.62,315.05a17.84,17.84,0,0,0,2.71,4,20.46,20.46,0,0,0,5.22,4.34,12.38,12.38,0,0,0,5.2,1.37c1.72.15,3.5.21,4.46.22a5.08,5.08,0,0,0,1.17,0c.06,0,.06,0-.12-.43a13.89,13.89,0,0,0-1.24-2.34,16.79,16.79,0,0,0-3.09-3.53,15.73,15.73,0,0,0-4.43-2.7,17.79,17.79,0,0,0-4.68-1c-1.57-.16-3.18-.25-4.16-.39s-1.32-.29-1,.45Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 353.98px 319.744px 0px",
          }}
          id="elg3vv6o7wm5o"
          className="animable"
        ></path>
        <path
          d="M363.27,278.25a10.09,10.09,0,0,1,1-3.42,14.16,14.16,0,0,1,3.55-4.82,16.57,16.57,0,0,1,4.83-2.41,19.47,19.47,0,0,0,2.29-1.05c.3-.12.18,0,0,.49a26.52,26.52,0,0,0-1,2.78,13.23,13.23,0,0,1-2.35,5.08,12.93,12.93,0,0,1-4.89,3,14.26,14.26,0,0,1-2.75.79c-.52.1-.75.12-.74-.48Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 369.166px 272.625px 0px",
          }}
          id="elazc49y6urie"
          className="animable"
        ></path>
        <path
          d="M361.47,288.41a20.55,20.55,0,0,1,1.69-5.74,9.68,9.68,0,0,1,4.68-3.93c2.12-1.05,4.82-2.05,6.3-2.67s1.81-.89,1.82-.78-.28.56-.73,1.84a28.57,28.57,0,0,1-2.08,5.29,12.66,12.66,0,0,1-4.71,4.77,26.35,26.35,0,0,1-6.07,2.43c-1.26.33-1.16.18-.9-1.21Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 368.634px 282.517px 0px",
          }}
          id="elluge8ngpge"
          className="animable"
        ></path>
        <path
          d="M361.64,303.74a19.35,19.35,0,0,1,1.63-5.21,14.72,14.72,0,0,1,5-5.42,32.35,32.35,0,0,1,6.82-3.07c1.56-.54,1.75-.54,1.82-.35a5.6,5.6,0,0,1-.38,2,20.56,20.56,0,0,1-2.26,5.52,12,12,0,0,1-4.64,4.05c-1.85.94-3.9,1.59-5.34,2.17a18.81,18.81,0,0,0-2.64,1.35c-.38.21-.28.09,0-1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 369.156px 297.22px 0px",
          }}
          id="elaiu7p4dfwws"
          className="animable"
        ></path>
        <path
          d="M365.43,320.52a26.68,26.68,0,0,1,.41-4.47,26.1,26.1,0,0,1,2.11-6.7,7.82,7.82,0,0,1,3.41-3.31,36.76,36.76,0,0,0,3.9-2.4,13.17,13.17,0,0,0,1.74-1.87c.24-.25.28.09.21,1a26.19,26.19,0,0,1-.57,4,22.76,22.76,0,0,1-1.93,5.65,13.22,13.22,0,0,1-3.42,3.93c-1.33,1.1-2.83,2.13-3.85,3a16.17,16.17,0,0,0-1.81,1.95c-.26.27-.21.07-.2-.79Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 371.33px 311.551px 0px",
          }}
          id="elef38yst078l"
          className="animable"
        ></path>
        <g id="elaqtnn8gm8n9">
          <path
            d="M362,273.7c-.2-.12-.56-.34-1.21-.78a16.24,16.24,0,0,1-2.38-1.9,6.49,6.49,0,0,1-1.81-3.61,35.09,35.09,0,0,1-.38-5.67c0-1.28,0-1.29.65-.44s2,2.59,3,4.14a18.42,18.42,0,0,1,2,4,8,8,0,0,1,.5,2.6,7.32,7.32,0,0,1-.17,1.55c-.07.27-.09.22-.27.08Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 359.293px 267.248px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elvhxw29q1vd">
          <path
            d="M358.09,283.28c-.38-.28-1.12-.78-1.89-1.26a6.83,6.83,0,0,1-2.26-2,18.13,18.13,0,0,1-1.75-4.38,39.39,39.39,0,0,1-1.13-4.8,10.68,10.68,0,0,1-.24-2.88c.09-.36.3.06.89.79a33.05,33.05,0,0,0,2.53,2.77,28.23,28.23,0,0,1,2.85,3,10.05,10.05,0,0,1,1.64,3.63,15.32,15.32,0,0,1,.38,3.72,5.13,5.13,0,0,1-.4,1.83c-.11.26-.13.23-.16.14s-.06-.18-.46-.48Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 354.959px 275.867px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="eli0wr9i68enc">
          <path
            d="M357.07,294.58c-.41-.14-1.1-.36-2.16-.61a17.8,17.8,0,0,1-3.88-1.18,10.06,10.06,0,0,1-3.86-3.1,27.46,27.46,0,0,1-2.36-4.54,29.74,29.74,0,0,0-1.52-2.7c-.25-.43-.14-.38.69-.11s2.4.75,3.87,1.11a14,14,0,0,1,4.22,1.36,12.47,12.47,0,0,1,3.39,3.22,7.63,7.63,0,0,1,1.43,3,25.48,25.48,0,0,1,.62,3.14c.08.68,0,.6-.44.45Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 350.355px 288.427px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elvsqnqesi5sj">
          <path
            d="M342.23,296.72c.59.14,1.55.45,2.66.72s2.37.46,3.71.81a19.63,19.63,0,0,1,4,1.51,8.49,8.49,0,0,1,2.9,2.4,15.81,15.81,0,0,1,1.87,3.36c.54,1.21,1,2.42,1.31,3.16a9.77,9.77,0,0,1,.35,1c0,.13,0,.13-.37,0s-1.17-.3-2.36-.59-2.76-.67-4.08-1.09a9.89,9.89,0,0,1-3.54-1.76,18.33,18.33,0,0,1-3.29-3.73c-1-1.48-2-3.11-2.69-4.12s-1.09-1.39-1.18-1.6.12-.27.7-.13Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 350.265px 303.181px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elpr0bwogmzja">
          <path
            d="M344.62,315.05a17.84,17.84,0,0,0,2.71,4,20.46,20.46,0,0,0,5.22,4.34,12.38,12.38,0,0,0,5.2,1.37c1.72.15,3.5.21,4.46.22a5.08,5.08,0,0,0,1.17,0c.06,0,.06,0-.12-.43a13.89,13.89,0,0,0-1.24-2.34,16.79,16.79,0,0,0-3.09-3.53,15.73,15.73,0,0,0-4.43-2.7,17.79,17.79,0,0,0-4.68-1c-1.57-.16-3.18-.25-4.16-.39s-1.32-.29-1,.45Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 353.98px 319.744px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el0crlnn9ydzv6">
          <path
            d="M363.27,278.25a10.09,10.09,0,0,1,1-3.42,14.16,14.16,0,0,1,3.55-4.82,16.57,16.57,0,0,1,4.83-2.41,19.47,19.47,0,0,0,2.29-1.05c.3-.12.18,0,0,.49a26.52,26.52,0,0,0-1,2.78,13.23,13.23,0,0,1-2.35,5.08,12.93,12.93,0,0,1-4.89,3,14.26,14.26,0,0,1-2.75.79c-.52.1-.75.12-.74-.48Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 369.166px 272.625px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elxqzjn9u911e">
          <path
            d="M361.47,288.41a20.55,20.55,0,0,1,1.69-5.74,9.68,9.68,0,0,1,4.68-3.93c2.12-1.05,4.82-2.05,6.3-2.67s1.81-.89,1.82-.78-.28.56-.73,1.84a28.57,28.57,0,0,1-2.08,5.29,12.66,12.66,0,0,1-4.71,4.77,26.35,26.35,0,0,1-6.07,2.43c-1.26.33-1.16.18-.9-1.21Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 368.634px 282.517px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="ely4pmrk05m2">
          <path
            d="M361.64,303.74a19.35,19.35,0,0,1,1.63-5.21,14.72,14.72,0,0,1,5-5.42,32.35,32.35,0,0,1,6.82-3.07c1.56-.54,1.75-.54,1.82-.35a5.6,5.6,0,0,1-.38,2,20.56,20.56,0,0,1-2.26,5.52,12,12,0,0,1-4.64,4.05c-1.85.94-3.9,1.59-5.34,2.17a18.81,18.81,0,0,0-2.64,1.35c-.38.21-.28.09,0-1Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 369.156px 297.22px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="ella9f1clu5ns">
          <path
            d="M365.43,320.52a26.68,26.68,0,0,1,.41-4.47,26.1,26.1,0,0,1,2.11-6.7,7.82,7.82,0,0,1,3.41-3.31,36.76,36.76,0,0,0,3.9-2.4,13.17,13.17,0,0,0,1.74-1.87c.24-.25.28.09.21,1a26.19,26.19,0,0,1-.57,4,22.76,22.76,0,0,1-1.93,5.65,13.22,13.22,0,0,1-3.42,3.93c-1.33,1.1-2.83,2.13-3.85,3a16.17,16.17,0,0,0-1.81,1.95c-.26.27-.21.07-.2-.79Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 371.33px 311.551px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M372.51,336.74v0c-1.87-3.57-3.69-7.1-5.55-10.4l-.27-.46a.07.07,0,0,0,0,0l-.38-.68c-.32-.54-.63-1.09-.92-1.62a15.13,15.13,0,0,1,1-4.53,28.29,28.29,0,0,1,1.48-3c.64-1.16,1.37-2.33,2.11-3.41a68.75,68.75,0,0,1,4.41-5.74v0a.18.18,0,0,0-.08-.27.26.26,0,0,0-.33,0h0c-1.49,1.81-3,3.64-4.42,5.77-.74,1.1-1.48,2.27-2.13,3.42a28.85,28.85,0,0,0-1.48,3,13.82,13.82,0,0,0-1,4,38.23,38.23,0,0,1-3-6.77,48.1,48.1,0,0,1-1.56-6.48c-.13-.75-.24-1.5-.35-2.27.4-.63.79-1.24,1.25-1.92s1-1.41,1.66-2.23,1.56-1.87,2.45-2.82a32.07,32.07,0,0,1,2.38-2.31,23.31,23.31,0,0,1,2.35-1.79c.78-.51,1.53-.94,2.27-1.37a.18.18,0,0,0,0-.28.26.26,0,0,0-.31-.05c-.77.43-1.51.88-2.29,1.39a24.41,24.41,0,0,0-2.41,1.83c-.78.69-1.6,1.5-2.4,2.33s-1.75,2-2.46,2.83-1.21,1.57-1.68,2.27c-.34.5-.66,1-1,1.44-.2-1.41-.35-2.84-.5-4.28a64,64,0,0,1-.41-7.53c0-.31,0-.61,0-.92.57-1,1.13-2,2.15-3.66.5-.83,1.14-1.83,1.86-2.8a18,18,0,0,1,2.42-2.79,21.92,21.92,0,0,1,6-3.6l0,0a.16.16,0,0,0,.07-.26.31.31,0,0,0-.33-.05,22.58,22.58,0,0,0-6.1,3.67,19.73,19.73,0,0,0-2.47,2.84c-.73,1-1.35,2-1.87,2.84-.74,1.22-1.26,2.1-1.71,2.88a38,38,0,0,1,.85-6.28,58,58,0,0,1,1.9-6.65l1.21-.9,1.5-1.09c.56-.43,1.18-.9,1.77-1.4A16.31,16.31,0,0,0,368,275a11.24,11.24,0,0,0,1.67-2.62,4.9,4.9,0,0,1,.24-.52l.06-.09.66-.57a.18.18,0,0,0,0-.27.29.29,0,0,0-.32,0c-.31.27-.52.47-.83.75-.47.28-1.06,2.23-1.83,3.07a14.28,14.28,0,0,1-1.63,1.55c-.6.5-1.21,1-1.75,1.38s-1.06.79-1.5,1.11l-.69.5c.16-.44.32-.9.5-1.36h0l.16-.46c1.19-3.18,2.57-6.46,3.95-9.75l-.44-.11c-1.27,3.07-2.56,6.13-3.68,9.12a14.1,14.1,0,0,0-.43-3.23,18.37,18.37,0,0,0-2-4l-2.27-3.83a.25.25,0,0,0-.29-.06.19.19,0,0,0-.11.26l2.27,3.8a17.71,17.71,0,0,1,1.93,4,15.51,15.51,0,0,1,.45,4.26,66.08,66.08,0,0,0-2.56,8.31,28.89,28.89,0,0,0-1.32-3.75,45.48,45.48,0,0,0-2.51-4.58l-3.09-5.16a.22.22,0,0,0-.29-.06.17.17,0,0,0-.1.25l3.09,5.16a41.13,41.13,0,0,1,2.5,4.54,34.46,34.46,0,0,1,1.53,4.49,41.66,41.66,0,0,0-.79,7.69c0,.36,0,.72,0,1.07-.23-.32-.49-.63-.78-1-.47-.57-1.07-1.24-1.88-2.08s-1.84-1.83-2.84-2.77l-2.52-2.38-1.23-1.15a.25.25,0,0,0-.3,0,.18.18,0,0,0,0,.26l1.23,1.15c.62.57,1.55,1.46,2.52,2.38s2,1.94,2.81,2.76,1.38,1.49,1.85,2.05.83,1,1.16,1.48c0,2,.22,3.88.41,5.77.23,2.47.54,4.94.95,7.24.07.42.13.82.23,1.23-.13-.18-.26-.37-.41-.56a10.3,10.3,0,0,0-1.48-1.72,16.23,16.23,0,0,0-1.87-1.52c-.81-.57-1.63-1.08-2.33-1.48-.5-.27-.91-.48-1.31-.68a12.48,12.48,0,0,1-1.81-1,26.8,26.8,0,0,1-3.12-2.79.23.23,0,0,0-.25,0,.19.19,0,0,0-.09.27l0,0a31.67,31.67,0,0,0,3.18,2.82,11.62,11.62,0,0,0,1.85,1.07c.4.21.81.41,1.29.67a27.19,27.19,0,0,1,2.3,1.45,18.58,18.58,0,0,1,1.84,1.48,11.9,11.9,0,0,1,1.41,1.64c.38.55.7,1.1,1,1.64.32,1.43.67,2.79,1.09,4.06a41.49,41.49,0,0,0,3.38,7.48h0v0h0c.31.55.63,1.1.94,1.67l.2.34a9.67,9.67,0,0,1-2.53-.83c-.67-.33-1.46-.79-2.42-1.34s-1.88-1.09-3.05-1.73c-2.44-1.32-5.63-2.86-8.75-4.39l0,0a.22.22,0,0,0-.29.08.19.19,0,0,0,.1.27h0c3.13,1.52,6.31,3.08,8.75,4.4,1.19.64,2.18,1.21,3,1.72s1.77,1,2.44,1.35a10.88,10.88,0,0,0,3,.94l.22.37c1.85,3.32,3.7,6.84,5.54,10.39v0Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 360.959px 301.244px 0px",
          }}
          id="elpvjosruaiy"
          className="animable"
        ></path>
        <g id="el7h4ixo1dagk">
          <path
            d="M372.51,336.74v0c-1.87-3.57-3.69-7.1-5.55-10.4l-.27-.46a.07.07,0,0,0,0,0l-.38-.68c-.32-.54-.63-1.09-.92-1.62a15.13,15.13,0,0,1,1-4.53,28.29,28.29,0,0,1,1.48-3c.64-1.16,1.37-2.33,2.11-3.41a68.75,68.75,0,0,1,4.41-5.74v0a.18.18,0,0,0-.08-.27.26.26,0,0,0-.33,0h0c-1.49,1.81-3,3.64-4.42,5.77-.74,1.1-1.48,2.27-2.13,3.42a28.85,28.85,0,0,0-1.48,3,13.82,13.82,0,0,0-1,4,38.23,38.23,0,0,1-3-6.77,48.1,48.1,0,0,1-1.56-6.48c-.13-.75-.24-1.5-.35-2.27.4-.63.79-1.24,1.25-1.92s1-1.41,1.66-2.23,1.56-1.87,2.45-2.82a32.07,32.07,0,0,1,2.38-2.31,23.31,23.31,0,0,1,2.35-1.79c.78-.51,1.53-.94,2.27-1.37a.18.18,0,0,0,0-.28.26.26,0,0,0-.31-.05c-.77.43-1.51.88-2.29,1.39a24.41,24.41,0,0,0-2.41,1.83c-.78.69-1.6,1.5-2.4,2.33s-1.75,2-2.46,2.83-1.21,1.57-1.68,2.27c-.34.5-.66,1-1,1.44-.2-1.41-.35-2.84-.5-4.28a64,64,0,0,1-.41-7.53c0-.31,0-.61,0-.92.57-1,1.13-2,2.15-3.66.5-.83,1.14-1.83,1.86-2.8a18,18,0,0,1,2.42-2.79,21.92,21.92,0,0,1,6-3.6l0,0a.16.16,0,0,0,.07-.26.31.31,0,0,0-.33-.05,22.58,22.58,0,0,0-6.1,3.67,19.73,19.73,0,0,0-2.47,2.84c-.73,1-1.35,2-1.87,2.84-.74,1.22-1.26,2.1-1.71,2.88a38,38,0,0,1,.85-6.28,58,58,0,0,1,1.9-6.65l1.21-.9,1.5-1.09c.56-.43,1.18-.9,1.77-1.4A16.31,16.31,0,0,0,368,275a11.24,11.24,0,0,0,1.67-2.62,4.9,4.9,0,0,1,.24-.52l.06-.09.66-.57a.18.18,0,0,0,0-.27.29.29,0,0,0-.32,0c-.31.27-.52.47-.83.75-.47.28-1.06,2.23-1.83,3.07a14.28,14.28,0,0,1-1.63,1.55c-.6.5-1.21,1-1.75,1.38s-1.06.79-1.5,1.11l-.69.5c.16-.44.32-.9.5-1.36h0l.16-.46c1.19-3.18,2.57-6.46,3.95-9.75l-.44-.11c-1.27,3.07-2.56,6.13-3.68,9.12a14.1,14.1,0,0,0-.43-3.23,18.37,18.37,0,0,0-2-4l-2.27-3.83a.25.25,0,0,0-.29-.06.19.19,0,0,0-.11.26l2.27,3.8a17.71,17.71,0,0,1,1.93,4,15.51,15.51,0,0,1,.45,4.26,66.08,66.08,0,0,0-2.56,8.31,28.89,28.89,0,0,0-1.32-3.75,45.48,45.48,0,0,0-2.51-4.58l-3.09-5.16a.22.22,0,0,0-.29-.06.17.17,0,0,0-.1.25l3.09,5.16a41.13,41.13,0,0,1,2.5,4.54,34.46,34.46,0,0,1,1.53,4.49,41.66,41.66,0,0,0-.79,7.69c0,.36,0,.72,0,1.07-.23-.32-.49-.63-.78-1-.47-.57-1.07-1.24-1.88-2.08s-1.84-1.83-2.84-2.77l-2.52-2.38-1.23-1.15a.25.25,0,0,0-.3,0,.18.18,0,0,0,0,.26l1.23,1.15c.62.57,1.55,1.46,2.52,2.38s2,1.94,2.81,2.76,1.38,1.49,1.85,2.05.83,1,1.16,1.48c0,2,.22,3.88.41,5.77.23,2.47.54,4.94.95,7.24.07.42.13.82.23,1.23-.13-.18-.26-.37-.41-.56a10.3,10.3,0,0,0-1.48-1.72,16.23,16.23,0,0,0-1.87-1.52c-.81-.57-1.63-1.08-2.33-1.48-.5-.27-.91-.48-1.31-.68a12.48,12.48,0,0,1-1.81-1,26.8,26.8,0,0,1-3.12-2.79.23.23,0,0,0-.25,0,.19.19,0,0,0-.09.27l0,0a31.67,31.67,0,0,0,3.18,2.82,11.62,11.62,0,0,0,1.85,1.07c.4.21.81.41,1.29.67a27.19,27.19,0,0,1,2.3,1.45,18.58,18.58,0,0,1,1.84,1.48,11.9,11.9,0,0,1,1.41,1.64c.38.55.7,1.1,1,1.64.32,1.43.67,2.79,1.09,4.06a41.49,41.49,0,0,0,3.38,7.48h0v0h0c.31.55.63,1.1.94,1.67l.2.34a9.67,9.67,0,0,1-2.53-.83c-.67-.33-1.46-.79-2.42-1.34s-1.88-1.09-3.05-1.73c-2.44-1.32-5.63-2.86-8.75-4.39l0,0a.22.22,0,0,0-.29.08.19.19,0,0,0,.1.27h0c3.13,1.52,6.31,3.08,8.75,4.4,1.19.64,2.18,1.21,3,1.72s1.77,1,2.44,1.35a10.88,10.88,0,0,0,3,.94l.22.37c1.85,3.32,3.7,6.84,5.54,10.39v0Z"
            style={{
              opacity: "0.4",
              transformOrigin: " 360.959px 301.244px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M391.89,234.29a11.64,11.64,0,0,1,1.61,5,24.92,24.92,0,0,1-.35,9.69c-.92,3.65-2.92,7.5-4.37,10.55s-2.35,5.32-2.92,6.4-.8,1-1.17.12-.85-2.46-1.59-5a67.48,67.48,0,0,1-2.12-8.7,16.53,16.53,0,0,1,.33-7.07,15.77,15.77,0,0,1,3.08-5.69,35.86,35.86,0,0,1,4.94-4.9c1.35-1.06,1.95-1.23,2.56-.46Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 387.281px 250.239px 0px",
          }}
          id="eldvmcfu7895j"
          className="animable"
        ></path>
        <g id="elwvttwhxohbb">
          <path
            d="M388.6,259.93c-1.34,2.86-2.2,5-2.74,6a3.54,3.54,0,0,1-.38.6l-.18-.09a3.51,3.51,0,0,1-.63-.44c-.36-.87-.85-2.47-1.57-4.91-.38-1.27-.81-2.78-1.21-4.32l.49.56c.34.4.62.72.8.44a4.94,4.94,0,0,0,.12-2.16c-.09-1-.32-2.16-.38-2.72s0-.53.15-.41.3.32.5,1.05.44,2,.58,2.69.19.79.3.73.28-.29.63-.91a13.1,13.1,0,0,1,1.14-1.88c.27-.25.28.24.31.92a17.81,17.81,0,0,0,.19,2c.08.44.17.45.27.3s.22-.47.78-1.51a35.93,35.93,0,0,1,2-3.42c.44-.58.34,0,.15,1s-.42,2.45-.67,3.48-.49,1.69-.58,2.38c0,.2,0,.39,0,.59Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 385.986px 259.375px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M384.59,265.54a46.48,46.48,0,0,0-2.88-6.18,34.4,34.4,0,0,0-5.14-6.64,31.53,31.53,0,0,0-5.81-4.69,14.52,14.52,0,0,0-5.05-2,26.87,26.87,0,0,0-4.82-.42c-1.14,0-1.48.14-1.51.59a7.92,7.92,0,0,0,.91,2.8,30.3,30.3,0,0,0,3.44,6.25,25.14,25.14,0,0,0,6,5.62,28,28,0,0,0,6.44,3c2.21.77,4.55,1.47,6.09,2s2.27.94,2.59,1,.25-.12-.28-1.45Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 372.211px 256.245px 0px",
          }}
          id="el9688ntj5cb5"
          className="animable"
        ></path>
        <g id="elzhabminhjtl">
          <path
            d="M384.59,265.54a46.48,46.48,0,0,0-2.88-6.18,32.23,32.23,0,0,0-2.33-3.42,8.54,8.54,0,0,0-.88-.53c-.56-.31-1.13-.89-.93-.61s1.2,1.43,2,2.41a7.71,7.71,0,0,1,1.44,2.08c0,.29-.54.07-1.41-.34s-2-1-2.93-1.46-1.56-.7-1.42-.34a12.56,12.56,0,0,0,1.86,2.1c.74.71,1.27,1.15,1.54,1.48s.3.56.12.61-.55-.07-1.25-.36-1.75-.77-2.86-1.17a27.25,27.25,0,0,0-3.09-.92c-.77-.19-1.13-.22-.41.24s2.55,1.4,3.77,2.09,1.86,1.12,2.29,1.41.69.44,0,.41-2.32-.22-3.62-.37l-.78-.08c1.11.51,2.22.93,3.38,1.34,2.21.77,4.55,1.47,6.09,2s2.27.94,2.59,1,.25-.12-.28-1.45Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 377.921px 260.833px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M385.59,265.65a46.67,46.67,0,0,1,3.88-5.62,17.24,17.24,0,0,1,6.2-5,32.67,32.67,0,0,1,9.66-2.52,29,29,0,0,1,8.4.17c2,.43,3.11,1.14,2.91,2.1S415,256.92,413,258.3a33.9,33.9,0,0,1-6.72,3.85,20.09,20.09,0,0,1-7,1.14,50,50,0,0,0-8.12.63,11.71,11.71,0,0,0-4.66,2.2,8.13,8.13,0,0,1-1.5,1c-.19,0-.18-.18.56-1.45Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 400.78px 259.702px 0px",
          }}
          id="el0ai7iyjobge"
          className="animable"
        ></path>
        <g id="el6bg50wdhi56">
          <path
            d="M385.59,265.65a46.67,46.67,0,0,1,3.88-5.62,20.34,20.34,0,0,1,1.52-1.69l.63-.37a16.41,16.41,0,0,1,4.89-1.5c1.42-.24,2.44-.31,2.37-.13a18.16,18.16,0,0,1-2.34,1.26,22.21,22.21,0,0,0-3,2.06c-.78.62-1.18,1-.72,1.12a14.4,14.4,0,0,0,2.79-.28c1-.12,1.57-.16,1.34,0s-1.29.4-2.05.7-1.18.64-.82.84a26.64,26.64,0,0,0,2.84.46c1.08.2,2.25.53,3.36.79l-.93,0a50,50,0,0,0-8.12.63,11.71,11.71,0,0,0-4.66,2.2,8.13,8.13,0,0,1-1.5,1c-.19,0-.18-.18.56-1.45Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 392.623px 261.679px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M386.78,264.49a.19.19,0,0,0-.23.07c-.09.21-.2.42-.3.6a3,3,0,0,1-.39.55,4.12,4.12,0,0,1-.52.5l-.22.18c.07-.27.15-.54.23-.8.12-.43.25-.85.39-1.27.28-.84.62-1.64.95-2.44h0a.17.17,0,0,0-.1-.22.16.16,0,0,0-.21.1h0c-.34.81-.68,1.62-1,2.45-.06.2-.13.41-.19.62v0c.07-.67.13-1.31.15-1.89s0-1.12,0-1.62-.06-1-.1-1.44a.16.16,0,0,0-.17-.15.18.18,0,0,0-.17.18c0,.47.08.95.1,1.43s0,1,0,1.58-.09,1.21-.16,1.87c0,.38-.08.77-.13,1.17-.28-1.05-.57-2.08-.89-3-.19-.58-.4-1.12-.63-1.65s-.44-1-.66-1.51a.17.17,0,0,0-.22-.08.15.15,0,0,0-.09.21c.22.49.44,1,.66,1.52s.43,1,.62,1.63c.28.78.52,1.64.76,2.53a7.87,7.87,0,0,0-.63-.91,25.89,25.89,0,0,0-2.22-2.26.16.16,0,0,0-.23,0,.16.16,0,0,0,0,.24,25.14,25.14,0,0,1,2.19,2.22,8.67,8.67,0,0,1,.71,1,3.47,3.47,0,0,1,.18.33,7.65,7.65,0,0,0-.72-.29c-.6-.2-1.41-.4-2.22-.61a.17.17,0,0,0-.09.32c.82.21,1.63.42,2.2.61a7.71,7.71,0,0,1,1.11.47,1.19,1.19,0,0,0,.08.16h0l0,0,0,0,0,0h0l0,0h.06s0,0,0,0h0l.63-.47a7.27,7.27,0,0,0,.56-.54,4.27,4.27,0,0,0,.41-.6c.12-.22.23-.42.32-.62A.17.17,0,0,0,386.78,264.49Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 383.953px 263.298px 0px",
          }}
          id="el06374yjv1oyr"
          className="animable"
        ></path>
        <g id="el1s4i1yhou47">
          <path
            d="M386.78,264.49a.19.19,0,0,0-.23.07c-.09.21-.2.42-.3.6a3,3,0,0,1-.39.55,4.12,4.12,0,0,1-.52.5l-.22.18c.07-.27.15-.54.23-.8.12-.43.25-.85.39-1.27.28-.84.62-1.64.95-2.44h0a.17.17,0,0,0-.1-.22.16.16,0,0,0-.21.1h0c-.34.81-.68,1.62-1,2.45-.06.2-.13.41-.19.62v0c.07-.67.13-1.31.15-1.89s0-1.12,0-1.62-.06-1-.1-1.44a.16.16,0,0,0-.17-.15.18.18,0,0,0-.17.18c0,.47.08.95.1,1.43s0,1,0,1.58-.09,1.21-.16,1.87c0,.38-.08.77-.13,1.17-.28-1.05-.57-2.08-.89-3-.19-.58-.4-1.12-.63-1.65s-.44-1-.66-1.51a.17.17,0,0,0-.22-.08.15.15,0,0,0-.09.21c.22.49.44,1,.66,1.52s.43,1,.62,1.63c.28.78.52,1.64.76,2.53a7.87,7.87,0,0,0-.63-.91,25.89,25.89,0,0,0-2.22-2.26.16.16,0,0,0-.23,0,.16.16,0,0,0,0,.24,25.14,25.14,0,0,1,2.19,2.22,8.67,8.67,0,0,1,.71,1,3.47,3.47,0,0,1,.18.33,7.65,7.65,0,0,0-.72-.29c-.6-.2-1.41-.4-2.22-.61a.17.17,0,0,0-.09.32c.82.21,1.63.42,2.2.61a7.71,7.71,0,0,1,1.11.47,1.19,1.19,0,0,0,.08.16h0l0,0,0,0,0,0h0l0,0h.06s0,0,0,0h0l.63-.47a7.27,7.27,0,0,0,.56-.54,4.27,4.27,0,0,0,.41-.6c.12-.22.23-.42.32-.62A.17.17,0,0,0,386.78,264.49Z"
            style={{
              opacity: "0.4",
              transformOrigin: " 383.953px 263.298px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M384.34,266.83a20.42,20.42,0,0,0-5-1.27,30.77,30.77,0,0,0-8.81.14,15.27,15.27,0,0,0-7.4,3.54,34.17,34.17,0,0,0-5.85,6.33c-1.16,1.71-1.1,2.4-.39,2.8a10.13,10.13,0,0,0,4,.52,26.25,26.25,0,0,0,7.29-.73,22.78,22.78,0,0,0,8-3.76c2-1.62,2.95-3.46,4.34-4.67a13.49,13.49,0,0,1,4.1-2.14c.83-.34.63-.41-.26-.76Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 370.762px 272.112px 0px",
          }}
          id="elqb776ge7z4"
          className="animable"
        ></path>
        <g id="eljgqizyyvv3i">
          <path
            d="M384.34,266.83a19.9,19.9,0,0,0-3.58-1,3.8,3.8,0,0,0-.5-.06,23.87,23.87,0,0,0-5,.18c-1.09.13-1.19.22-.88.26s1,0,2,.12a20,20,0,0,1,2.7.37c.47.13.14.24-.48.39s-1.53.37-2.42.63a22.11,22.11,0,0,0-2.14.76c-.42.19-.38.23.05.12s1.3-.36,2.21-.59a13,13,0,0,1,2.21-.43c.33,0,0,.24-.6.67s-1.58,1.06-2.11,1.5-.64.66-.66.76.05.09.55-.24a14.94,14.94,0,0,1,2.35-1.35,10.57,10.57,0,0,1,3-.73,27,27,0,0,1,2.71-.24l.85-.32c.83-.34.63-.41-.26-.76Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 379.436px 268.139px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M384.14,267.32a14.35,14.35,0,0,0-3.74,3.45,22.3,22.3,0,0,0-3.39,7.16,19.15,19.15,0,0,0-.63,7.22,12,12,0,0,0,1.51,4.68c.59,1,1.11,1.4,1.79,1.34s1.53-.56,3-2.74a43.64,43.64,0,0,0,4.55-8.92,10.4,10.4,0,0,0,.36-6.52,33.94,33.94,0,0,0-1.72-4.27c-.44-1-.5-1.5-.62-1.73s-.26-.2-1.1.33Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 382.114px 279.015px 0px",
          }}
          id="elnefj1ge0ogn"
          className="animable"
        ></path>
        <g id="elnq8p3xchsxj">
          <path
            d="M384.14,267.32a14.35,14.35,0,0,0-3.74,3.45,15.67,15.67,0,0,0-1.06,1.59c.42-.26,1.21-.82,1.89-1.28s1.27-.88,1.49-.82.1.58-.09,1.36-.47,1.82-.6,2.37-.15.64,0,.45.36-.66.69-1.4a14.59,14.59,0,0,1,1.06-2.11c.29-.35.43-.05.61.5s.39,1.36.53,1.84.22.65.25-.09,0-2.35,0-3.11.05-.69.2-.33.36,1,.56,1.72a10.67,10.67,0,0,1,.35,2.29c.05.83,0,1.73.06,2s.26-.16.41-.79a17.57,17.57,0,0,0,.29-2.45c0-.34,0-.71,0-1.06-.42-1.07-.89-2-1.18-2.7-.44-1-.5-1.5-.62-1.73s-.26-.2-1.1.33Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 383.19px 271.358px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M385.39,266.88a7.23,7.23,0,0,1,3.43-1.3,23.16,23.16,0,0,1,7.94.33,20.8,20.8,0,0,1,8.07,3.51,10.64,10.64,0,0,1,3.87,5.49,8.46,8.46,0,0,1,.07,5,2.17,2.17,0,0,1-2.11,1.55,10.74,10.74,0,0,1-4-.81,40.56,40.56,0,0,1-6.68-2.79,9.16,9.16,0,0,1-3.16-3,23.68,23.68,0,0,0-2.41-2.87,31,31,0,0,0-3.29-2.85c-1-.75-1.74-1.15-2.05-1.43s-.17-.44.36-.83Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 397.011px 273.421px 0px",
          }}
          id="el6iyyp4ocwpv"
          className="animable"
        ></path>
        <g id="elphfea6j118e">
          <path
            d="M385.39,266.88a7.23,7.23,0,0,1,3.43-1.3,23.16,23.16,0,0,1,7.94.33l.08,0a.54.54,0,0,1-.19.07,17,17,0,0,1-3,.16c-1.18,0-2.15-.07-2.68,0s-.6.27,0,.6,1.84.81,2,1-.7.1-1.63,0a12.91,12.91,0,0,0-2.3-.24c-.4.06-.21.35.36,1.08s1.52,1.9,1.79,2.29-.15,0-.73-.45a12.89,12.89,0,0,0-2-1.18,7.81,7.81,0,0,0-2.17-.73l-.09,0a13,13,0,0,1-1.16-.79c-.3-.28-.17-.44.36-.83Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 390.861px 268.206px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M384.82,257.07a.87.87,0,0,1,.85-.09,1,1,0,0,1,.5,1,5.21,5.21,0,0,1-.47,1.91c-.24.48-.47.55-.72.46a1.28,1.28,0,0,1-.69-.81,2.85,2.85,0,0,1-.11-1.53,1.44,1.44,0,0,1,.64-.92Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 385.151px 258.646px 0px",
          }}
          id="eloi68dicpn6s"
          className="animable"
        ></path>
        <path
          d="M382.39,260.57a.61.61,0,0,0,.41-.26,1.21,1.21,0,0,0,.13-.89,3.32,3.32,0,0,0-.61-1.24,2.1,2.1,0,0,0-1-.81c-.29,0-.49.23-.5.57a2.79,2.79,0,0,0,.41,1.26,10.65,10.65,0,0,0,.75,1.19c.19.23.27.21.39.18Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 381.892px 258.979px 0px",
          }}
          id="elpvnqjulx4bs"
          className="animable"
        ></path>
        <path
          d="M386.36,261.47c0,.5.22.7.45.75s.47-.08.75-.44a3.79,3.79,0,0,0,.67-1.44.78.78,0,0,0-.36-.91.71.71,0,0,0-.94.29,3.6,3.6,0,0,0-.57,1.75Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 387.313px 260.792px 0px",
          }}
          id="eloaqkuqvyswk"
          className="animable"
        ></path>
        <path
          d="M386.41,265.12a.9.9,0,0,1-.13-.73,2.51,2.51,0,0,1,.53-1.15,1.09,1.09,0,0,1,.85-.46c.26,0,.4.25.35.61a3.3,3.3,0,0,1-.54,1.14,1.94,1.94,0,0,1-.65.59c-.18.1-.3.12-.41,0Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 387.136px 263.991px 0px",
          }}
          id="elt34cin5wcm9"
          className="animable"
        ></path>
        <path
          d="M381.22,263.16c.39.12.66.06.81-.16a1,1,0,0,0,0-1,3.36,3.36,0,0,0-1-1.14,1.15,1.15,0,0,0-1-.24.68.68,0,0,0-.54.59,1.56,1.56,0,0,0,.51,1.11,3.61,3.61,0,0,0,1.26.84Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 380.827px 261.906px 0px",
          }}
          id="el8wzithg55gg"
          className="animable"
        ></path>
        <path
          d="M381.32,266c.47,0,.79-.08.86-.32s-.09-.56-.41-.85a2.43,2.43,0,0,0-1.25-.56c-.46-.07-.92,0-1.07.28s.05.69.43,1a2.89,2.89,0,0,0,1.44.47Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 380.798px 265.132px 0px",
          }}
          id="elw7a4cnmygme"
          className="animable"
        ></path>
        <path
          d="M404,291.29a8,8,0,0,1,0,3.67,17.14,17.14,0,0,1-2.27,6.37,42,42,0,0,1-5.11,6.1c-1.61,1.73-2.68,3.05-3.28,3.65s-.74.48-.81-.17,0-1.82,0-3.63a46.41,46.41,0,0,1,.41-6.23,11.61,11.61,0,0,1,1.7-4.63,11.07,11.07,0,0,1,3.24-3.14,24.41,24.41,0,0,1,4.32-2.22c1.11-.42,1.55-.41,1.79.23Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 398.356px 301.121px 0px",
          }}
          id="elsb6f4xnr05l"
          className="animable"
        ></path>
        <g id="elvhw5z5wr01">
          <path
            d="M396.48,307.65c-1.49,1.62-2.51,2.85-3.08,3.43a3.57,3.57,0,0,1-.38.32l-.1-.11a2.11,2.11,0,0,1-.33-.42c-.06-.65,0-1.82,0-3.59,0-.93,0-2,.1-3.13.07.16.14.33.21.48.14.34.26.61.43.46a3.48,3.48,0,0,0,.54-1.42c.15-.69.24-1.49.31-1.88s.13-.35.19-.24.13.27.11.8-.13,1.43-.18,1.91,0,.56,0,.55a2.09,2.09,0,0,0,.61-.47,9.93,9.93,0,0,1,1.15-1c.23-.11.14.22,0,.68a11.59,11.59,0,0,0-.29,1.35c0,.31,0,.34.11.26s.25-.27.84-.84a25.35,25.35,0,0,1,2-1.86c.42-.29.22.09-.11.72s-.8,1.54-1.18,2.17a17,17,0,0,0-.88,1.47,3.34,3.34,0,0,0-.16.38Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 395.761px 306.437px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M392.64,310.53a31.77,31.77,0,0,0-.62-4.71,24.63,24.63,0,0,0-2-5.49,22.27,22.27,0,0,0-2.88-4.33,10.1,10.1,0,0,0-2.95-2.37,18.41,18.41,0,0,0-3.12-1.29c-.76-.24-1-.22-1.13.07a5.31,5.31,0,0,0,0,2,20.94,20.94,0,0,0,1,4.88,17.35,17.35,0,0,0,2.83,5,19.06,19.06,0,0,0,3.64,3.36c1.31,1,2.72,1.94,3.62,2.63s1.32,1.09,1.51,1.22.19,0,.12-1Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 386.274px 301.858px 0px",
          }}
          id="elyntmfr98ut9"
          className="animable"
        ></path>
        <g id="elhlu400a2po">
          <path
            d="M392.64,310.53a31.77,31.77,0,0,0-.62-4.71,23.53,23.53,0,0,0-.83-2.76,4.43,4.43,0,0,0-.48-.53c-.3-.33-.56-.84-.49-.61s.5,1.2.82,2a5.73,5.73,0,0,1,.53,1.69c-.05.2-.37-.06-.86-.52s-1.14-1.11-1.65-1.59-.89-.79-.87-.52a8.18,8.18,0,0,0,.79,1.78c.35.63.61,1,.72,1.31s.08.44-.05.43-.35-.16-.76-.5-1-.88-1.65-1.38a20.21,20.21,0,0,0-1.86-1.25c-.47-.29-.71-.39-.33.07s1.4,1.46,2.07,2.18,1,1.14,1.23,1.42.36.43-.09.27-1.5-.64-2.33-1l-.5-.22c.63.57,1.28,1.09,2,1.6,1.31,1,2.72,1.94,3.62,2.63s1.32,1.09,1.51,1.22.19,0,.12-1Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 388.793px 306.722px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M393.28,310.81a33.65,33.65,0,0,1,3.76-2.92,12,12,0,0,1,5.17-2,22.52,22.52,0,0,1,6.94.35,20.37,20.37,0,0,1,5.56,1.87c1.27.71,1.82,1.41,1.49,2s-1.55,1.07-3.15,1.58a23.73,23.73,0,0,1-5.27,1.15,13.94,13.94,0,0,1-4.88-.7,34.42,34.42,0,0,0-5.54-1.29,8.17,8.17,0,0,0-3.56.49,5.74,5.74,0,0,1-1.2.34c-.13,0-.08-.16.68-.86Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 404.419px 309.308px 0px",
          }}
          id="el74vm44pgxcf"
          className="animable"
        ></path>
        <g id="el8l0wjjf2j6">
          <path
            d="M393.28,310.81a33.65,33.65,0,0,1,3.76-2.92,13.26,13.26,0,0,1,1.37-.8l.49-.11a11.42,11.42,0,0,1,3.56,0c1,.14,1.69.31,1.61.41a12.16,12.16,0,0,1-1.82.35,15.64,15.64,0,0,0-2.45.74c-.65.24-1,.43-.72.59a11.86,11.86,0,0,0,1.91.4c.68.12,1.08.22.9.25s-.94,0-1.5,0-.93.18-.72.38a15.37,15.37,0,0,0,1.79.9c.67.37,1.38.83,2.06,1.23l-.62-.16a34.42,34.42,0,0,0-5.54-1.29,8.17,8.17,0,0,0-3.56.49,5.74,5.74,0,0,1-1.2.34c-.13,0-.08-.16.68-.86Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 398.31px 309.535px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M394.31,310.29a.12.12,0,0,0-.16,0l-.33.33a2.63,2.63,0,0,1-.37.29,4,4,0,0,1-.46.22,1,1,0,0,1-.18.07l.32-.48c.17-.26.35-.52.53-.76.36-.5.75-1,1.14-1.43h0a.12.12,0,0,0,0-.17.11.11,0,0,0-.16,0h0c-.39.47-.79.94-1.15,1.43l-.26.37h0c.18-.43.36-.84.49-1.22s.25-.74.34-1.08.17-.66.24-1a.11.11,0,0,0-.09-.14.11.11,0,0,0-.14.08c-.08.32-.15.65-.24,1s-.19.68-.32,1.06-.32.78-.5,1.21c-.1.24-.22.49-.33.75,0-.76.06-1.5,0-2.18a12.15,12.15,0,0,0-.07-1.23c0-.39-.08-.77-.12-1.15a.12.12,0,0,0-.24,0c.05.37.09.74.13,1.14s.06.79.07,1.22,0,1.2,0,1.84a3.9,3.9,0,0,0-.23-.74,18.24,18.24,0,0,0-1-2,.12.12,0,1,0-.21.11,16.24,16.24,0,0,1,1,1.94,4.92,4.92,0,0,1,.26.83,2,2,0,0,1,.05.26,3.89,3.89,0,0,0-.41-.34c-.36-.26-.86-.57-1.35-.88a.12.12,0,0,0-.13.2c.5.31,1,.62,1.34.87a4.67,4.67,0,0,1,.63.54l0,.12h0l0,0,0,0v0h.11l.52-.19a3.07,3.07,0,0,0,.48-.24,3.25,3.25,0,0,0,.4-.31l.35-.35A.12.12,0,0,0,394.31,310.29Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 392.611px 308.755px 0px",
          }}
          id="eldvfixuw9mdd"
          className="animable"
        ></path>
        <g id="el6xn30cti14x">
          <path
            d="M394.31,310.29a.12.12,0,0,0-.16,0l-.33.33a2.63,2.63,0,0,1-.37.29,4,4,0,0,1-.46.22,1,1,0,0,1-.18.07l.32-.48c.17-.26.35-.52.53-.76.36-.5.75-1,1.14-1.43h0a.12.12,0,0,0,0-.17.11.11,0,0,0-.16,0h0c-.39.47-.79.94-1.15,1.43l-.26.37h0c.18-.43.36-.84.49-1.22s.25-.74.34-1.08.17-.66.24-1a.11.11,0,0,0-.09-.14.11.11,0,0,0-.14.08c-.08.32-.15.65-.24,1s-.19.68-.32,1.06-.32.78-.5,1.21c-.1.24-.22.49-.33.75,0-.76.06-1.5,0-2.18a12.15,12.15,0,0,0-.07-1.23c0-.39-.08-.77-.12-1.15a.12.12,0,0,0-.24,0c.05.37.09.74.13,1.14s.06.79.07,1.22,0,1.2,0,1.84a3.9,3.9,0,0,0-.23-.74,18.24,18.24,0,0,0-1-2,.12.12,0,1,0-.21.11,16.24,16.24,0,0,1,1,1.94,4.92,4.92,0,0,1,.26.83,2,2,0,0,1,.05.26,3.89,3.89,0,0,0-.41-.34c-.36-.26-.86-.57-1.35-.88a.12.12,0,0,0-.13.2c.5.31,1,.62,1.34.87a4.67,4.67,0,0,1,.63.54l0,.12h0l0,0,0,0v0h.11l.52-.19a3.07,3.07,0,0,0,.48-.24,3.25,3.25,0,0,0,.4-.31l.35-.35A.12.12,0,0,0,394.31,310.29Z"
            style={{
              opacity: "0.4",
              transformOrigin: " 392.611px 308.755px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M392.2,311.34a14.31,14.31,0,0,0-3.05-1.89,21.21,21.21,0,0,0-5.89-1.75,10.68,10.68,0,0,0-5.66.8,23.43,23.43,0,0,0-5.21,3c-1.13.89-1.24,1.37-.85,1.78a7,7,0,0,0,2.55,1.18,18.15,18.15,0,0,0,5,1.05,16.09,16.09,0,0,0,6.09-.83c1.68-.65,2.68-1.68,3.86-2.2a9.62,9.62,0,0,1,3.18-.56c.62,0,.5-.14,0-.56Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 381.989px 311.573px 0px",
          }}
          id="eldyfgji8xb7"
          className="animable"
        ></path>
        <g id="elo91i5poupw">
          <path
            d="M392.2,311.34A13.21,13.21,0,0,0,390,309.9l-.32-.14a17.22,17.22,0,0,0-3.36-.94c-.75-.14-.84-.1-.64,0s.67.25,1.31.51a13.13,13.13,0,0,1,1.72.81c.28.18,0,.19-.4.16s-1.1-.08-1.75-.09a13,13,0,0,0-1.58.06c-.32,0-.3.06,0,.09s.94,0,1.6.07a8.31,8.31,0,0,1,1.56.17c.21.08,0,.17-.55.32s-1.27.38-1.71.56-.57.3-.6.36,0,.07.41,0a11.39,11.39,0,0,1,1.85-.41,7.6,7.6,0,0,1,2.14.15,17,17,0,0,1,1.85.41l.64,0c.62,0,.5-.14,0-.56Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 388.669px 310.36px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M392,311.63a9.74,9.74,0,0,0-3.22,1.5,15.77,15.77,0,0,0-3.75,4.05,13.53,13.53,0,0,0-1.93,4.67,8.38,8.38,0,0,0,0,3.43c.18.79.44,1.16.91,1.27s1.13-.05,2.57-1.2a30.43,30.43,0,0,0,4.89-5,7.16,7.16,0,0,0,1.6-4.26,21.49,21.49,0,0,0-.25-3.19c-.07-.77,0-1.11,0-1.29s-.13-.18-.8,0Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 387.996px 319.027px 0px",
          }}
          id="elt1xe2bzc59r"
          className="animable"
        ></path>
        <g id="el7m7qmf2hhum">
          <path
            d="M392,311.63a9.74,9.74,0,0,0-3.22,1.5c-.33.24-.68.53-1,.84.33-.08,1-.29,1.52-.46a2.55,2.55,0,0,1,1.17-.23c.13.09-.06.41-.35.89s-.69,1.11-.9,1.45-.23.39-.11.29a10.71,10.71,0,0,0,.76-.79,10.11,10.11,0,0,1,1.14-1.18c.26-.17.3.06.3.46s0,1,0,1.34,0,.47.18,0,.48-1.57.65-2.07.18-.44.21-.18a12.43,12.43,0,0,1,0,1.26,7.9,7.9,0,0,1-.25,1.6c-.14.57-.36,1.15-.37,1.33s.21-.06.43-.45a11.45,11.45,0,0,0,.71-1.56c.08-.23.17-.47.24-.7,0-.8-.17-1.53-.22-2-.07-.77,0-1.11,0-1.29s-.13-.18-.8,0Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 390.445px 314.643px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M392.89,311.59a5.14,5.14,0,0,1,2.55-.14,16,16,0,0,1,5.21,1.88,14.54,14.54,0,0,1,4.63,4,7.5,7.5,0,0,1,1.43,4.46,6,6,0,0,1-1,3.33,1.53,1.53,0,0,1-1.74.59,7.66,7.66,0,0,1-2.51-1.38,28.26,28.26,0,0,1-3.86-3.27,6.3,6.3,0,0,1-1.47-2.64,16.62,16.62,0,0,0-1-2.42,23.24,23.24,0,0,0-1.59-2.58c-.51-.71-.92-1.13-1.06-1.38s0-.33.41-.48Z"
          style={{
            fill: " rgb(176, 22, 94)",
            fillRule: "evenodd",
            transformOrigin: " 399.569px 318.569px 0px",
          }}
          id="elg0f8k0zjvnn"
          className="animable"
        ></path>
        <g id="el7nezs1s14cj">
          <path
            d="M392.89,311.59a5.14,5.14,0,0,1,2.55-.14,16,16,0,0,1,5.21,1.88l.05,0a.27.27,0,0,1-.14,0,12.65,12.65,0,0,1-2.05-.53,16.58,16.58,0,0,0-1.78-.56c-.36-.07-.46.05-.13.39s1,.93,1.13,1.1-.49-.08-1.08-.35a10.31,10.31,0,0,0-1.48-.65c-.28,0-.21.19,0,.8s.6,1.58.7,1.89-.09,0-.39-.44a8.59,8.59,0,0,0-1.07-1.21,5.42,5.42,0,0,0-1.29-.94l-.06,0a7.42,7.42,0,0,1-.6-.77c-.15-.25,0-.33.41-.48Z"
            style={{
              fillRule: "evenodd",
              opacity: "0.2",
              transformOrigin: " 396.552px 313.448px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M394.57,305a.63.63,0,0,1,.58.12.68.68,0,0,1,.13.76,4,4,0,0,1-.72,1.17c-.25.27-.42.27-.57.15a.9.9,0,0,1-.29-.68,2,2,0,0,1,.25-1,1,1,0,0,1,.62-.48Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 394.521px 306.126px 0px",
          }}
          id="el7k0snxh204g"
          className="animable"
        ></path>
        <path
          d="M392.22,306.77a.38.38,0,0,0,.32-.09.78.78,0,0,0,.27-.56,2.41,2.41,0,0,0-.14-1,1.4,1.4,0,0,0-.48-.73c-.18-.1-.37,0-.45.27a2,2,0,0,0,0,.92,6.5,6.5,0,0,0,.26.95c.08.19.13.19.22.2Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 392.251px 305.564px 0px",
          }}
          id="el09ss5kcsfh95"
          className="animable"
        ></path>
        <path
          d="M394.67,308.2c-.11.33,0,.51.14.59s.33,0,.59-.14a2.64,2.64,0,0,0,.75-.81.55.55,0,0,0,0-.68.49.49,0,0,0-.69,0,2.49,2.49,0,0,0-.74,1Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 395.446px 307.92px 0px",
          }}
          id="elklk62owbf0b"
          className="animable"
        ></path>
        <path
          d="M393.94,310.64a.59.59,0,0,1,.07-.51,1.81,1.81,0,0,1,.58-.66.81.81,0,0,1,.67-.13c.16.08.21.25.1.48a2.1,2.1,0,0,1-.59.64,1.45,1.45,0,0,1-.56.27c-.14,0-.23,0-.27-.09Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 394.665px 310.023px 0px",
          }}
          id="elruwymrvpl1o"
          className="animable"
        ></path>
        <path
          d="M390.9,308.24c.23.17.42.19.57.07a.73.73,0,0,0,.18-.68,2.37,2.37,0,0,0-.44-1,.82.82,0,0,0-.6-.36.48.48,0,0,0-.48.28,1.06,1.06,0,0,0,.11.84,2.39,2.39,0,0,0,.66.82Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 390.88px 307.327px 0px",
          }}
          id="eljz9cjoh3t0g"
          className="animable"
        ></path>
        <path
          d="M390.37,310.16c.3.11.54.11.64,0a.7.7,0,0,0-.1-.66,1.75,1.75,0,0,0-.71-.63.74.74,0,0,0-.77,0c-.15.15-.11.47.08.74a2,2,0,0,0,.86.62Z"
          style={{
            fill: " rgb(255, 255, 255)",
            fillRule: "evenodd",
            transformOrigin: " 390.195px 309.502px 0px",
          }}
          id="elk4t93timkr"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--flowers-4--inject-18"
        style={{ transformOrigin: " 287.215px 302.023px 0px" }}
        className="animable"
      >
        <path
          d="M307.1,318l-18.93.55L269.23,318c-.81,12.78,1.68,25.82,5.13,32.18h0a8.57,8.57,0,0,0,3.75,3.81c5.58,3.23,14.61,3.23,20.16,0A8.38,8.38,0,0,0,302,350C305.45,343.63,307.91,330.67,307.1,318Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 288.166px 337.206px 0px",
          }}
          id="el79l0ftu4fes"
          className="animable"
        ></path>
        <g id="el9stk7kpt108">
          <path
            d="M307.1,318l-18.93.55L269.23,318c-.81,12.78,1.68,25.82,5.13,32.18h0a8.57,8.57,0,0,0,3.75,3.81c5.58,3.23,14.61,3.23,20.16,0A8.38,8.38,0,0,0,302,350C305.45,343.63,307.91,330.67,307.1,318Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.5",
              transformOrigin: " 288.166px 337.206px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M301.51,310.19c7.42,4.28,7.46,11.23.09,15.51s-19.36,4.29-26.78,0-7.46-11.22-.08-15.51S294.09,305.91,301.51,310.19Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 288.166px 317.945px 0px",
          }}
          id="elopfkg52ryx"
          className="animable"
        ></path>
        <g id="el4m2kkelo18h">
          <g
            style={{
              opacity: "0.7",
              transformOrigin: " 288.166px 317.945px 0px",
            }}
            className="animable"
          >
            <path
              d="M301.51,310.19c7.42,4.28,7.46,11.23.09,15.51s-19.36,4.29-26.78,0-7.46-11.22-.08-15.51S294.09,305.91,301.51,310.19Z"
              style={{
                fill: " rgb(255, 255, 255)",
                transformOrigin: " 288.166px 317.945px 0px",
              }}
              id="eli3i5gp6lvn"
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M299.34,311.46c6.21,3.58,6.24,9.39.07,13s-16.2,3.58-22.41,0-6.24-9.4-.07-13S293.13,307.87,299.34,311.46Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 288.17px 317.96px 0px",
          }}
          id="elbbaqpxjwi4a"
          className="animable"
        ></path>
        <path
          d="M289.29,320.27a.62.62,0,0,1-.55-.34l-.34-.63a.62.62,0,0,1,.19-.8,73.46,73.46,0,0,1,7.57-36.68.63.63,0,0,1,1.12.56,72.11,72.11,0,0,0-7.36,37.21.63.63,0,0,1-.46.65A.47.47,0,0,1,289.29,320.27Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 292.823px 300.901px 0px",
          }}
          id="el30t5pa6e6i1"
          className="animable"
        ></path>
        <g id="elkthwf6nluyi">
          <g
            style={{
              opacity: "0.4",
              transformOrigin: " 292.823px 300.901px 0px",
            }}
            className="animable"
          >
            <path
              d="M289.29,320.27a.62.62,0,0,1-.55-.34l-.34-.63a.62.62,0,0,1,.19-.8,73.46,73.46,0,0,1,7.57-36.68.63.63,0,0,1,1.12.56,72.11,72.11,0,0,0-7.36,37.21.63.63,0,0,1-.46.65A.47.47,0,0,1,289.29,320.27Z"
              id="elqv4275bh6v"
              style={{ transformOrigin: " 292.823px 300.901px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M305.48,269.9a1.91,1.91,0,0,0-.13-.75,1,1,0,0,0-.63-.54,1.52,1.52,0,0,0-1.08.23,16.79,16.79,0,0,0-3.54,2.39,4.83,4.83,0,0,0-1.08,1.23,1.84,1.84,0,0,0-.17,1.55,3.31,3.31,0,0,0,2.28,1.7,5.47,5.47,0,0,0,2.53.26c1.22-.2,2-.94,2-2C305.6,272.58,305.53,271.22,305.48,269.9Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 302.206px 272.304px 0px",
          }}
          id="elcwsl0ox9vth"
          className="animable"
        ></path>
        <g id="el7svzstfstcu">
          <path
            d="M305.48,269.9a1.91,1.91,0,0,0-.13-.75,1,1,0,0,0-.63-.54,1.52,1.52,0,0,0-1.08.23,16.79,16.79,0,0,0-3.54,2.39,4.83,4.83,0,0,0-1.08,1.23,1.84,1.84,0,0,0-.17,1.55,3.31,3.31,0,0,0,2.28,1.7,5.47,5.47,0,0,0,2.53.26c1.22-.2,2-.94,2-2C305.6,272.58,305.53,271.22,305.48,269.9Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 302.206px 272.304px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elxp4nq1wxxfg">
          <path
            d="M301.89,271.3l.21.21a1.74,1.74,0,0,0,2.42,0,3.51,3.51,0,0,0,.47-.69,5.28,5.28,0,0,0,.45-1.32,3,3,0,0,1,0,.43c0,1.32.12,2.68.16,4.08,0,1-.76,1.79-2,2a5.47,5.47,0,0,1-2.53-.26,3.31,3.31,0,0,1-2.28-1.7,1.84,1.84,0,0,1,.17-1.55,4.83,4.83,0,0,1,1.08-1.23,16.22,16.22,0,0,1,1.3-1A1.87,1.87,0,0,0,301.89,271.3Z"
            style={{
              opacity: "0.2",
              transformOrigin: " 302.146px 272.779px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M292.91,279a8,8,0,0,1,1.75-3.42,27.18,27.18,0,0,0,2.25-3,4.2,4.2,0,0,0,.57-3.31,2.1,2.1,0,0,1-.22-1,.68.68,0,0,1,.86-.48c.37.16.32.62.54.92.41.55,1.61.41,2,1s-.39,1.28-.12,1.91,1.09.7,1.52,1.18a1.37,1.37,0,0,1-.23,1.89A18.73,18.73,0,0,1,300,276a6.9,6.9,0,0,0-1.75,2.42,13.49,13.49,0,0,1-1.51,2.69c-.52.65-2.1,2.15-3,1.28A4,4,0,0,1,292.91,279Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 297.579px 275.207px 0px",
          }}
          id="elobph1no5vo"
          className="animable"
        ></path>
        <g id="el0t2efsajtj4">
          <path
            d="M292.91,279a8,8,0,0,1,1.75-3.42,27.18,27.18,0,0,0,2.25-3,4.2,4.2,0,0,0,.57-3.31,2.1,2.1,0,0,1-.22-1,.68.68,0,0,1,.86-.48c.37.16.32.62.54.92.41.55,1.61.41,2,1s-.39,1.28-.12,1.91,1.09.7,1.52,1.18a1.37,1.37,0,0,1-.23,1.89A18.73,18.73,0,0,1,300,276a6.9,6.9,0,0,0-1.75,2.42,13.49,13.49,0,0,1-1.51,2.69c-.52.65-2.1,2.15-3,1.28A4,4,0,0,1,292.91,279Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 297.579px 275.207px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elckqyhsyhlvs">
          <path
            d="M299.21,273.22a1,1,0,0,0,.37-1.31,1.28,1.28,0,0,1-.08-.9c.11-.34.36-.68.18-1s-.47-.34-.74-.48a1.43,1.43,0,0,1-.76-1.71c.3.19.27.6.48.89.41.55,1.61.41,2,1s-.39,1.28-.12,1.91,1.09.7,1.52,1.18a1.37,1.37,0,0,1-.23,1.89A18.73,18.73,0,0,1,300,276a6.9,6.9,0,0,0-1.75,2.42,13.49,13.49,0,0,1-1.51,2.69c-.52.65-2.1,2.15-3,1.28a4,4,0,0,1-.86-3.41c0-.09,0-.18.07-.27A23,23,0,0,1,299.21,273.22Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 297.565px 275.237px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M297.84,285.82a6.17,6.17,0,0,0,6.47-2.52,18.21,18.21,0,0,0,1.41-4.28,4.37,4.37,0,0,1,2.77-3.17c.71-.21,1.7-.37,1.65-1a1,1,0,0,0-.63-.72c-.5-.25-.53-.14-.92,0a2.36,2.36,0,0,1-2.14-.16c-.43-.28-.83-.73-1.34-.69s-.73.61-1.21.77-1.18-.23-1.79-.3a3,3,0,0,0-1.68.46c-1.2.63-2.52,1-3.64,1.71-1.52,1-3.79,3.21-3.94,5.19C292.69,283.3,295.76,285.39,297.84,285.82Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 301.493px 279.628px 0px",
          }}
          id="el39l72c35h91"
          className="animable"
        ></path>
        <g id="el8m3zbsx12l9">
          <path
            d="M297.84,285.82a6.17,6.17,0,0,0,6.47-2.52,18.21,18.21,0,0,0,1.41-4.28,4.37,4.37,0,0,1,2.77-3.17c.71-.21,1.7-.37,1.65-1a1,1,0,0,0-.63-.72c-.5-.25-.53-.14-.92,0a2.36,2.36,0,0,1-2.14-.16c-.43-.28-.83-.73-1.34-.69s-.73.61-1.21.77-1.18-.23-1.79-.3a3,3,0,0,0-1.68.46c-1.2.63-2.52,1-3.64,1.71-1.52,1-3.79,3.21-3.94,5.19C292.69,283.3,295.76,285.39,297.84,285.82Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 301.493px 279.628px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M265.1,278.63h0c1.4,3.13,3.06,6.47,4.74,10s3.4,7.13,5,10.81a64.29,64.29,0,0,1,4.89,18.08,3.46,3.46,0,0,0,3.68,3h0a3.32,3.32,0,0,0,3.06-3.77,70.83,70.83,0,0,0-5.45-20.1,40.74,40.74,0,0,0-7-10.91A31.82,31.82,0,0,0,265.1,278.63Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 275.801px 299.58px 0px",
          }}
          id="el6igxqteq7f4"
          className="animable"
        ></path>
        <g id="elc9k8q2gapp9">
          <path
            d="M271,285.76h0c1.36,2.12,2.82,4.64,4.25,7.39A80.19,80.19,0,0,1,279.1,302a81.13,81.13,0,0,1,4.25,17.66,53.18,53.18,0,0,0-.91-8.52,57.35,57.35,0,0,0-2.59-9.42,59.39,59.39,0,0,0-4.08-8.86A56.89,56.89,0,0,0,271,285.76Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 277.175px 302.71px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el8ahw6mkgj5m">
          <path
            d="M286.47,316.69a70.83,70.83,0,0,0-5.45-20.1,40.74,40.74,0,0,0-7-10.91,31.82,31.82,0,0,0-8.93-7.05h0c1.4,3.13,3.06,6.47,4.74,10s3.4,7.13,5,10.81a64.29,64.29,0,0,1,4.89,18.08,3.46,3.46,0,0,0,3.68,3h0A3.32,3.32,0,0,0,286.47,316.69Z"
            style={{ opacity: "0.1", transformOrigin: " 275.8px 299.58px 0px" }}
            className="animable"
          ></path>
        </g>
        <path
          d="M306.51,277.58h0a37.63,37.63,0,0,0-7.84,8.31,50,50,0,0,0-5.95,11.44,105.55,105.55,0,0,0-5.16,19.87,3.36,3.36,0,0,0,2.89,3.9h0a3.45,3.45,0,0,0,3.85-2.85,99.43,99.43,0,0,1,4.85-18.66C302,291.9,304.82,284.22,306.51,277.58Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 297.011px 299.355px 0px",
          }}
          id="elb3dejvzvrjk"
          className="animable"
        ></path>
        <g id="elwj8r0ricvmp">
          <path
            d="M301.75,285.55h0a78.75,78.75,0,0,0-4,7.61,83,83,0,0,0-3.53,9.14,79.62,79.62,0,0,0-3.64,18,138.87,138.87,0,0,1,4.4-17.76c1-3.14,2.15-6.26,3.33-9.14S300.66,287.85,301.75,285.55Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 296.165px 302.925px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elqi908vgsm0s">
          <path
            d="M306.51,277.58a37.63,37.63,0,0,0-7.84,8.31,50,50,0,0,0-5.95,11.44,105.55,105.55,0,0,0-5.16,19.87,3.36,3.36,0,0,0,2.89,3.9h0a3.45,3.45,0,0,0,3.85-2.85,99.43,99.43,0,0,1,4.85-18.66c2.82-7.69,5.67-15.37,7.36-22Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 297.011px 299.355px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M315.09,297.88h0a21.05,21.05,0,0,0-7,3.12,27,27,0,0,0-6.33,6A46.84,46.84,0,0,0,295,319.08a2.23,2.23,0,0,0,1.39,2.94h0a2.33,2.33,0,0,0,2.87-1.35,42.76,42.76,0,0,1,6.11-11C308.68,305.44,312.23,301.44,315.09,297.88Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 304.967px 310.005px 0px",
          }}
          id="elfb5ruepymg"
          className="animable"
        ></path>
        <g id="ellyepe4tu0rl">
          <path
            d="M310.1,301.53h0a36.57,36.57,0,0,0-4.26,3.82,39.25,39.25,0,0,0-4.09,5.09,37.14,37.14,0,0,0-5.15,11.07,52.83,52.83,0,0,1,5.59-10.77,53.59,53.59,0,0,1,3.94-5.12C307.51,304.07,308.87,302.68,310.1,301.53Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 303.35px 311.52px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el79ys0pj8ie7">
          <path
            d="M308.11,301a27,27,0,0,0-6.33,6A46.84,46.84,0,0,0,295,319.08a2.23,2.23,0,0,0,1.39,2.94h0a2.33,2.33,0,0,0,2.87-1.35,42.76,42.76,0,0,1,6.11-11c3.27-4.24,6.82-8.24,9.68-11.8h0A21.05,21.05,0,0,0,308.11,301Z"
            style={{ opacity: "0.1", transformOrigin: " 304.947px 310px 0px" }}
            className="animable"
          ></path>
        </g>
        <path
          d="M259.38,303.83h0c3.42,2.55,7.5,5.39,11.3,8.6a35.36,35.36,0,0,1,7.5,8.77A2.15,2.15,0,0,0,281,322h0a2.07,2.07,0,0,0,.77-2.92,39.66,39.66,0,0,0-8.46-9.88,24.17,24.17,0,0,0-7-4.08A18.92,18.92,0,0,0,259.38,303.83Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 270.733px 313.033px 0px",
          }}
          id="elgxeisj1uvkg"
          className="animable"
        ></path>
        <g id="elqfrrxueqdnr">
          <path
            d="M264.7,306h0c1.37.78,2.89,1.75,4.46,2.86a45.24,45.24,0,0,1,4.6,3.86,44.19,44.19,0,0,1,7,8.81h0a31.9,31.9,0,0,0-6.69-9.17,32.69,32.69,0,0,0-4.73-3.8A33.05,33.05,0,0,0,264.7,306Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 272.73px 313.765px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elkhiaezt8q0m">
          <path
            d="M281.8,319a39.66,39.66,0,0,0-8.46-9.88,24.17,24.17,0,0,0-7-4.08,18.92,18.92,0,0,0-7-1.24h0c3.42,2.55,7.5,5.39,11.3,8.6a35.36,35.36,0,0,1,7.5,8.77A2.15,2.15,0,0,0,281,322h0A2.07,2.07,0,0,0,281.8,319Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 270.744px 313.022px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M284.35,321.94h-.05a.64.64,0,0,1-.58-.67c.67-9.76,0-33.1-4.61-45.45a.63.63,0,0,1,.37-.81.62.62,0,0,1,.8.37c4.7,12.53,5.37,36.13,4.69,46A.62.62,0,0,1,284.35,321.94Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 282.133px 298.455px 0px",
          }}
          id="elwm8mks4asgq"
          className="animable"
        ></path>
        <path
          d="M285.88,318.69h0a.63.63,0,0,1-.61-.65,268.38,268.38,0,0,1,7.41-54.7.63.63,0,0,1,.76-.47.64.64,0,0,1,.46.76,266.63,266.63,0,0,0-7.37,54.45A.63.63,0,0,1,285.88,318.69Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 289.593px 290.772px 0px",
          }}
          id="elhvvcdrb5nwi"
          className="animable"
        ></path>
        <g id="elsr5vnrsca2">
          <g
            style={{
              opacity: "0.4",
              transformOrigin: " 282.133px 298.455px 0px",
            }}
            className="animable"
          >
            <path
              d="M284.35,321.94h-.05a.64.64,0,0,1-.58-.67c.67-9.76,0-33.1-4.61-45.45a.63.63,0,0,1,.37-.81.62.62,0,0,1,.8.37c4.7,12.53,5.37,36.13,4.69,46A.62.62,0,0,1,284.35,321.94Z"
              id="el35k5rreczr7"
              style={{ transformOrigin: " 282.133px 298.455px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <g id="ely2nnua58p6s">
          <g
            style={{
              opacity: "0.4",
              transformOrigin: " 289.593px 290.772px 0px",
            }}
            className="animable"
          >
            <path
              d="M285.88,318.69h0a.63.63,0,0,1-.61-.65,268.38,268.38,0,0,1,7.41-54.7.63.63,0,0,1,.76-.47.64.64,0,0,1,.46.76,266.63,266.63,0,0,0-7.37,54.45A.63.63,0,0,1,285.88,318.69Z"
              id="elzm6d7w6c69j"
              style={{ transformOrigin: " 289.593px 290.772px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M263.17,294h0c3.2,4.54,7.36,9.61,11.26,14.88a59.2,59.2,0,0,1,7.43,13.35,2.81,2.81,0,0,0,3.52,1.57h0a2.71,2.71,0,0,0,1.6-3.59,64.41,64.41,0,0,0-8.19-14.68,35.19,35.19,0,0,0-7.41-7.37A27,27,0,0,0,263.17,294Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 275.178px 308.979px 0px",
          }}
          id="el1ih5rdt5k1e"
          className="animable"
        ></path>
        <g id="elxh5ek9s423o">
          <g
            style={{
              opacity: "0.3",
              transformOrigin: " 277.085px 310.955px 0px",
            }}
            className="animable"
          >
            <path
              d="M269,298.74h0c1.43,1.46,3,3.2,4.63,5.13a74,74,0,0,1,4.67,6.3,75.41,75.41,0,0,1,6.87,13h0a50.29,50.29,0,0,0-6.33-13.39,54.08,54.08,0,0,0-4.84-6.26A50,50,0,0,0,269,298.74Z"
              style={{
                fill: " rgb(255, 255, 255)",
                transformOrigin: " 277.085px 310.955px 0px",
              }}
              id="ellnq390rj6y"
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M284,282.85h0c.19,6,1,13.16,1.55,20.29a70.37,70.37,0,0,1-.71,16.66,3,3,0,0,0,2.4,3.44h0a3,3,0,0,0,3.5-2.46,75,75,0,0,0,.76-18.21A40,40,0,0,0,289,291.51,30.58,30.58,0,0,0,284,282.85Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 287.87px 303.07px 0px",
          }}
          id="el3i9cedcqvbf"
          className="animable"
        ></path>
        <g id="elysvj24xulas">
          <path
            d="M286.43,290.62h0c.44,2.18.87,4.71,1.23,7.41s.56,5.61.65,8.51a91.52,91.52,0,0,1-1,16,59.05,59.05,0,0,0,1.69-16,61.76,61.76,0,0,0-.84-8.56A58.9,58.9,0,0,0,286.43,290.62Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 287.73px 306.58px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M313.29,287.27h0a35.08,35.08,0,0,0-8.38,6.63,45.8,45.8,0,0,0-7,9.82,95.44,95.44,0,0,0-7.32,17.75,3.16,3.16,0,0,0,2.2,4h0a3.24,3.24,0,0,0,3.92-2.16,89.11,89.11,0,0,1,6.86-16.65C307.15,299.9,310.82,293.19,313.29,287.27Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 301.867px 306.424px 0px",
          }}
          id="elnk36kt5vln"
          className="animable"
        ></path>
        <g id="el56nkdwqkd3h">
          <path
            d="M307.8,294h0a70.52,70.52,0,0,0-4.72,6.51,75.4,75.4,0,0,0-4.47,8A72.24,72.24,0,0,0,293,324.73a123.7,123.7,0,0,1,6.32-15.9c1.35-2.78,2.8-5.51,4.27-8S306.49,296,307.8,294Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 300.4px 309.365px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M296.64,248.46a3.3,3.3,0,0,1,.78-.67,1.07,1.07,0,0,1,1-.06,1.54,1.54,0,0,1,.64,1.09,20.84,20.84,0,0,1,.56,5.28,6.54,6.54,0,0,1-.29,2.06,2.86,2.86,0,0,1-1.28,1.59,3.5,3.5,0,0,1-3.18-.3,5.25,5.25,0,0,1-2-1.76,2.69,2.69,0,0,1,.21-3.37C294.23,251,295.44,249.74,296.64,248.46Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 296px 252.817px 0px",
          }}
          id="els64pon3b4kb"
          className="animable"
        ></path>
        <g id="elv3hnumi3th">
          <path
            d="M296.64,248.46a3.3,3.3,0,0,1,.78-.67,1.07,1.07,0,0,1,1-.06,1.54,1.54,0,0,1,.64,1.09,20.84,20.84,0,0,1,.56,5.28,6.54,6.54,0,0,1-.29,2.06,2.86,2.86,0,0,1-1.28,1.59,3.5,3.5,0,0,1-3.18-.3,5.25,5.25,0,0,1-2-1.76,2.69,2.69,0,0,1,.21-3.37C294.23,251,295.44,249.74,296.64,248.46Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 296px 252.817px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elkhrl5xumrsn">
          <path
            d="M298.14,252.71l-.36,0A1.72,1.72,0,0,1,296,250.8a5.47,5.47,0,0,1,.26-1.06,8.54,8.54,0,0,1,.83-1.69c-.15.13-.28.27-.42.41-1.2,1.28-2.41,2.56-3.61,3.86a2.69,2.69,0,0,0-.21,3.37,5.25,5.25,0,0,0,2,1.76,3.5,3.5,0,0,0,3.18.3,2.86,2.86,0,0,0,1.28-1.59,6.54,6.54,0,0,0,.29-2.06,17.9,17.9,0,0,0-.07-2.07A2.68,2.68,0,0,1,298.14,252.71Z"
            style={{
              opacity: "0.2",
              transformOrigin: " 295.98px 253.025px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M298.09,267a10.29,10.29,0,0,0,1.75-4.34,36,36,0,0,1,1-4.6,6.64,6.64,0,0,1,2.78-3.69,3.57,3.57,0,0,0,1.19-.82c.29-.4.23-1.09-.24-1.23s-.89.37-1.38.49c-.9.22-1.74-.92-2.62-.65s-.9,1.59-1.71,2-1.47-.2-2.22-.1a2,2,0,0,0-1.47,1.95,23.49,23.49,0,0,0,.22,2.64,9,9,0,0,1-.77,3.48,18.14,18.14,0,0,0-1.12,3.41c-.16.93-.26,3.36,1.05,3.42A4.63,4.63,0,0,0,298.09,267Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 299.197px 260.539px 0px",
          }}
          id="el938iucj3smh"
          className="animable"
        ></path>
        <g id="elfouo0j5jexj">
          <path
            d="M298.09,267a10.29,10.29,0,0,0,1.75-4.34,36,36,0,0,1,1-4.6,6.64,6.64,0,0,1,2.78-3.69,3.57,3.57,0,0,0,1.19-.82c.29-.4.23-1.09-.24-1.23s-.89.37-1.38.49c-.9.22-1.74-.92-2.62-.65s-.9,1.59-1.71,2-1.47-.2-2.22-.1a2,2,0,0,0-1.47,1.95,23.49,23.49,0,0,0,.22,2.64,9,9,0,0,1-.77,3.48,18.14,18.14,0,0,0-1.12,3.41c-.16.93-.26,3.36,1.05,3.42A4.63,4.63,0,0,0,298.09,267Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 299.197px 260.539px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elqxtb1a10uy">
          <path
            d="M298.46,256.72a1.46,1.46,0,0,1,.92-1.55,1.85,1.85,0,0,0,.9-.8c.24-.41.37-1,.81-1.12a2,2,0,0,1,1.06.13,2.19,2.19,0,0,0,2.36-1.1c-.45-.06-.84.39-1.3.51-.9.22-1.74-.92-2.62-.65s-.9,1.59-1.71,2-1.47-.2-2.22-.1a2,2,0,0,0-1.47,1.95,23.49,23.49,0,0,0,.22,2.64,9,9,0,0,1-.77,3.48,18.14,18.14,0,0,0-1.12,3.41c-.16.93-.26,3.36,1.05,3.42a4.63,4.63,0,0,0,3.52-1.94,1.92,1.92,0,0,0,.18-.28A27.91,27.91,0,0,0,298.46,256.72Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 298.969px 260.519px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M289.19,268.19a6.84,6.84,0,0,1-2.33-6.86,24.73,24.73,0,0,1,2.18-4.56c.74-1.51,1.23-3.33.53-4.86-.32-.72-.86-1.6-.33-2.17a1,1,0,0,1,1-.22c.54.13.48.26.64.68a2.05,2.05,0,0,0,1.62,1.47c.54.07,1.21,0,1.54.38s0,1.13.24,1.66,1.05.72,1.56,1.13a3.15,3.15,0,0,1,.86,1.78c.35,1.54,1,2.93,1.24,4.51.26,2.12,0,5.87-1.6,7.56S290.88,269.52,289.19,268.19Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 292.353px 259.548px 0px",
          }}
          id="elyw6dtf22azs"
          className="animable"
        ></path>
        <g id="el040oz7srmyil">
          <path
            d="M289.19,268.19a6.84,6.84,0,0,1-2.33-6.86,24.73,24.73,0,0,1,2.18-4.56c.74-1.51,1.23-3.33.53-4.86-.32-.72-.86-1.6-.33-2.17a1,1,0,0,1,1-.22c.54.13.48.26.64.68a2.05,2.05,0,0,0,1.62,1.47c.54.07,1.21,0,1.54.38s0,1.13.24,1.66,1.05.72,1.56,1.13a3.15,3.15,0,0,1,.86,1.78c.35,1.54,1,2.93,1.24,4.51.26,2.12,0,5.87-1.6,7.56S290.88,269.52,289.19,268.19Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 292.353px 259.548px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M276.36,260.07a3,3,0,0,0-.77-.66,1.07,1.07,0,0,0-1-.07,1.54,1.54,0,0,0-.64,1.1,21.23,21.23,0,0,0-.57,5.27,6.87,6.87,0,0,0,.3,2.07,2.82,2.82,0,0,0,1.28,1.59,3.54,3.54,0,0,0,3.18-.31,5.16,5.16,0,0,0,2-1.76,2.69,2.69,0,0,0-.22-3.37C278.78,262.64,277.57,261.36,276.36,260.07Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 277.004px 264.429px 0px",
          }}
          id="elos31cnhsg4f"
          className="animable"
        ></path>
        <g id="el62nigrnxuww">
          <path
            d="M276.36,260.07a3,3,0,0,0-.77-.66,1.07,1.07,0,0,0-1-.07,1.54,1.54,0,0,0-.64,1.1,21.23,21.23,0,0,0-.57,5.27,6.87,6.87,0,0,0,.3,2.07,2.82,2.82,0,0,0,1.28,1.59,3.54,3.54,0,0,0,3.18-.31,5.16,5.16,0,0,0,2-1.76,2.69,2.69,0,0,0-.22-3.37C278.78,262.64,277.57,261.36,276.36,260.07Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 277.004px 264.429px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el4zpd63aiwt5">
          <path
            d="M274.87,264.32l.35,0a1.72,1.72,0,0,0,1.82-1.95,5.37,5.37,0,0,0-.26-1.05,8.83,8.83,0,0,0-.83-1.69,5.14,5.14,0,0,1,.41.4c1.21,1.29,2.42,2.57,3.61,3.86a2.69,2.69,0,0,1,.22,3.37,5.16,5.16,0,0,1-2,1.76,3.54,3.54,0,0,1-3.18.31,2.82,2.82,0,0,1-1.28-1.59,6.87,6.87,0,0,1-.3-2.07c0-.69,0-1.38.07-2.07A2.67,2.67,0,0,0,274.87,264.32Z"
            style={{
              opacity: "0.2",
              transformOrigin: " 277.055px 264.6px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M274.92,278.6a10.34,10.34,0,0,1-1.75-4.34,35.6,35.6,0,0,0-1-4.6,6.55,6.55,0,0,0-2.77-3.69,3.53,3.53,0,0,1-1.2-.83c-.28-.39-.23-1.09.24-1.23s.9.37,1.39.49c.89.23,1.73-.92,2.61-.64s.91,1.59,1.71,2,1.48-.21,2.23-.1a2,2,0,0,1,1.47,1.95,25.93,25.93,0,0,1-.23,2.63,9,9,0,0,0,.77,3.49,17.85,17.85,0,0,1,1.13,3.4c.16.94.26,3.36-1.06,3.43A4.62,4.62,0,0,1,274.92,278.6Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 273.82px 272.138px 0px",
          }}
          id="el8g0gx4k08ei"
          className="animable"
        ></path>
        <g id="elnsuzhww2i2">
          <path
            d="M274.92,278.6a10.34,10.34,0,0,1-1.75-4.34,35.6,35.6,0,0,0-1-4.6,6.55,6.55,0,0,0-2.77-3.69,3.53,3.53,0,0,1-1.2-.83c-.28-.39-.23-1.09.24-1.23s.9.37,1.39.49c.89.23,1.73-.92,2.61-.64s.91,1.59,1.71,2,1.48-.21,2.23-.1a2,2,0,0,1,1.47,1.95,25.93,25.93,0,0,1-.23,2.63,9,9,0,0,0,.77,3.49,17.85,17.85,0,0,1,1.13,3.4c.16.94.26,3.36-1.06,3.43A4.62,4.62,0,0,1,274.92,278.6Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 273.82px 272.138px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elliettbo91as">
          <path
            d="M274.54,268.34a1.44,1.44,0,0,0-.91-1.55,1.94,1.94,0,0,1-.91-.81c-.23-.41-.36-1-.81-1.12a2,2,0,0,0-1.06.14,2.19,2.19,0,0,1-2.35-1.1c.44-.07.84.39,1.3.5.89.23,1.73-.92,2.61-.64s.91,1.59,1.71,2,1.48-.21,2.23-.1a2,2,0,0,1,1.47,1.95,25.93,25.93,0,0,1-.23,2.63,9,9,0,0,0,.77,3.49,17.85,17.85,0,0,1,1.13,3.4c.16.94.26,3.36-1.06,3.43a4.62,4.62,0,0,1-3.51-1.94c-.07-.09-.12-.19-.19-.28A27.92,27.92,0,0,1,274.54,268.34Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 274.041px 272.138px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M283.81,279.81a6.83,6.83,0,0,0,2.33-6.86,23.49,23.49,0,0,0-2.17-4.56,5.85,5.85,0,0,1-.54-4.87c.33-.71.87-1.59.34-2.17a1,1,0,0,0-1-.21c-.55.13-.48.25-.64.68a2.09,2.09,0,0,1-1.63,1.47c-.54.06-1.2-.06-1.53.37s0,1.14-.24,1.67-1.06.72-1.57,1.13a3,3,0,0,0-.85,1.77,45,45,0,0,0-1.24,4.51c-.27,2.13,0,5.87,1.59,7.56S282.13,281.14,283.81,279.81Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 280.65px 271.164px 0px",
          }}
          id="elxiyk319c3uf"
          className="animable"
        ></path>
        <g id="el71crfg90jcb">
          <path
            d="M283.81,279.81a6.83,6.83,0,0,0,2.33-6.86,23.49,23.49,0,0,0-2.17-4.56,5.85,5.85,0,0,1-.54-4.87c.33-.71.87-1.59.34-2.17a1,1,0,0,0-1-.21c-.55.13-.48.25-.64.68a2.09,2.09,0,0,1-1.63,1.47c-.54.06-1.2-.06-1.53.37s0,1.14-.24,1.67-1.06.72-1.57,1.13a3,3,0,0,0-.85,1.77,45,45,0,0,0-1.24,4.51c-.27,2.13,0,5.87,1.59,7.56S282.13,281.14,283.81,279.81Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 280.65px 271.164px 0px",
            }}
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--flowers-2--inject-18"
        style={{ transformOrigin: " 202.441px 225.687px 0px" }}
        className="animable"
      >
        <path
          d="M192.71,237.28l13.38.39,13.39-.39c.57,9-1.19,18.25-3.62,22.75h0a6.09,6.09,0,0,1-2.65,2.7,15.72,15.72,0,0,1-14.26,0,6,6,0,0,1-2.65-2.77C193.88,255.44,192.13,246.28,192.71,237.28Z"
          style={{
            fill: " rgb(55, 71, 79)",
            transformOrigin: " 206.093px 250.86px 0px",
          }}
          id="elgmyh1ffz53"
          className="animable"
        ></path>
        <path
          d="M196.66,231.8c-5.25,3-5.27,7.94-.06,11s13.68,3,18.93,0,5.27-7.94.06-11S201.9,228.77,196.66,231.8Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 206.095px 237.294px 0px",
          }}
          id="elsz3ze4a8hs"
          className="animable"
        ></path>
        <path
          d="M198.73,233c-4.09,2.36-4.11,6.19,0,8.55a16.29,16.29,0,0,0,14.77,0c4.09-2.36,4.12-6.19.05-8.55A16.23,16.23,0,0,0,198.73,233Z"
          style={{
            fill: " rgb(38, 50, 56)",
            transformOrigin: " 206.12px 237.265px 0px",
          }}
          id="el7yuzze2ajjv"
          className="animable"
        ></path>
        <path
          d="M206.21,238.63a.77.77,0,0,0,.77-.74,68.22,68.22,0,0,0-6.13-31.56.77.77,0,0,0-1-.37.78.78,0,0,0-.38,1,66.6,66.6,0,0,1,6,30.84.77.77,0,0,0,.74.81Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 203.231px 222.263px 0px",
          }}
          id="el6n2q87ugdd4"
          className="animable"
        ></path>
        <g id="elvjiwgg8zlac">
          <g
            style={{
              opacity: "0.6",
              transformOrigin: " 203.231px 222.263px 0px",
            }}
            className="animable"
          >
            <path
              d="M206.21,238.63a.77.77,0,0,0,.77-.74,68.22,68.22,0,0,0-6.13-31.56.77.77,0,0,0-1-.37.78.78,0,0,0-.38,1,66.6,66.6,0,0,1,6,30.84.77.77,0,0,0,.74.81Z"
              id="elm4muepuezf"
              style={{ transformOrigin: " 203.231px 222.263px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M195,190.77a3.68,3.68,0,0,0-2.16-1.64c-1.42-.32-2.84.53-3.93,1.49A11.22,11.22,0,0,0,186,194.3a7,7,0,0,0-.54,4.58,4.87,4.87,0,0,0,7.43,3.14,6.93,6.93,0,0,0,2.88-3.67A8.53,8.53,0,0,0,195,190.77Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 190.808px 195.934px 0px",
          }}
          id="elvq10wlivxtn"
          className="animable"
        ></path>
        <path
          d="M205,190.12a6.41,6.41,0,0,0-4.35-3.1,5.39,5.39,0,0,0-5,1.74,8,8,0,0,0-1.5,3.37,10.67,10.67,0,0,0-.36,3.64,5.28,5.28,0,0,0,1.49,3.29,4.92,4.92,0,0,0,4,1.18,7.53,7.53,0,0,0,3.86-1.85c1-.82,2.46-2.19,2.79-3.45A7.05,7.05,0,0,0,205,190.12Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 199.893px 193.615px 0px",
          }}
          id="el1y26a94jubn"
          className="animable"
        ></path>
        <g id="el9tu1xa4cave">
          <path
            d="M205,190.12a6.41,6.41,0,0,0-4.35-3.1,5.39,5.39,0,0,0-5,1.74,8,8,0,0,0-1.5,3.37,10.67,10.67,0,0,0-.36,3.64,5.28,5.28,0,0,0,1.49,3.29,4.92,4.92,0,0,0,4,1.18,7.53,7.53,0,0,0,3.86-1.85c1-.82,2.46-2.19,2.79-3.45A7.05,7.05,0,0,0,205,190.12Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 199.893px 193.615px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M200.64,191.37a3,3,0,0,0-2.81-.39,14.86,14.86,0,0,0-2,1.45,15.35,15.35,0,0,1-3.76,1.16,6.37,6.37,0,0,0-3.17,2.11,4.9,4.9,0,0,0-1.05,3.62,4,4,0,0,0,2.15,3c1.59.76,3.48.24,5.15-.35a14.8,14.8,0,0,0,5.13-2.75C202.45,197.25,203.45,193.39,200.64,191.37Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 195.09px 196.746px 0px",
          }}
          id="elu8rr8dlu3p"
          className="animable"
        ></path>
        <g id="elaulv9wzeay">
          <path
            d="M200.64,191.37a3,3,0,0,0-2.81-.39,14.86,14.86,0,0,0-2,1.45,15.35,15.35,0,0,1-3.76,1.16,6.37,6.37,0,0,0-3.17,2.11,4.9,4.9,0,0,0-1.05,3.62,4,4,0,0,0,2.15,3c1.59.76,3.48.24,5.15-.35a14.8,14.8,0,0,0,5.13-2.75C202.45,197.25,203.45,193.39,200.64,191.37Z"
            style={{
              opacity: "0.2",
              transformOrigin: " 195.09px 196.746px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M198.51,195.1a2.38,2.38,0,0,0,0-1.76,1.35,1.35,0,0,0-1.45-.8,1.9,1.9,0,0,0-1,.79,7.32,7.32,0,0,0-1.2,2.46c-.27,1,0,3.37,1.63,2.69.49-.21.72-.82.94-1.25A19.12,19.12,0,0,0,198.51,195.1Z"
          style={{
            fill: " rgb(55, 71, 79)",
            transformOrigin: " 196.724px 195.562px 0px",
          }}
          id="el88fue29q09j"
          className="animable"
        ></path>
        <path
          d="M194.93,196.43a3,3,0,0,0-2-.78,2.14,2.14,0,0,0-1,.24,1.27,1.27,0,0,0-.64.81,1.39,1.39,0,0,0,.42,1.27,3.13,3.13,0,0,0,1.21.7,2.36,2.36,0,0,0,2.54-.22C196.06,197.8,195.45,196.91,194.93,196.43Z"
          style={{
            fill: " rgb(55, 71, 79)",
            transformOrigin: " 193.488px 197.296px 0px",
          }}
          id="elh5cg2nkm828"
          className="animable"
        ></path>
        <path
          d="M197.59,195.87a4.94,4.94,0,0,1-1.75,1.47c-1,.37-2.07.15-3,.61a2.9,2.9,0,0,0-1.34,3.06,4.53,4.53,0,0,0,4.47,3.56,5.8,5.8,0,0,0,4.93-3.27,9.06,9.06,0,0,0,.44-6C200.77,193,198.52,194.8,197.59,195.87Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 196.549px 199.377px 0px",
          }}
          id="elm8k9dfqylt"
          className="animable"
        ></path>
        <path
          d="M189.91,200.14c-.87-.64-1.87-1.43-2.9-1.12a2.06,2.06,0,0,0-1.32,1.75,4.67,4.67,0,0,0,.42,2.26,14.35,14.35,0,0,0,9,8.37,6.53,6.53,0,0,0,5.17-.19,4.27,4.27,0,0,0,2.05-4c-.2-2.48-2.27-3.85-4.49-4.08A15.85,15.85,0,0,1,189.91,200.14Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 194.012px 205.397px 0px",
          }}
          id="elq5u0s8kfngk"
          className="animable"
        ></path>
        <g id="elsy22088pg1k">
          <path
            d="M189.91,200.14c-.87-.64-1.87-1.43-2.9-1.12a2.06,2.06,0,0,0-1.32,1.75,4.67,4.67,0,0,0,.42,2.26,14.35,14.35,0,0,0,9,8.37,6.53,6.53,0,0,0,5.17-.19,4.27,4.27,0,0,0,2.05-4c-.2-2.48-2.27-3.85-4.49-4.08A15.85,15.85,0,0,1,189.91,200.14Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 194.012px 205.397px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M208.41,202.49a11.21,11.21,0,0,0-2.42-8.63c-.87-1.05-2.25-2-3.49-1.44a3.66,3.66,0,0,0-1.57,1.86l-2.86,5.62a11.33,11.33,0,0,0-1.66,5.2,5.73,5.73,0,0,0,2.35,4.45C203.6,213,207.79,206.83,208.41,202.49Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 202.463px 201.406px 0px",
          }}
          id="el6vw9a554n38"
          className="animable"
        ></path>
        <g id="eldbknecvshlr">
          <path
            d="M208.41,202.49a11.21,11.21,0,0,0-2.42-8.63c-.87-1.05-2.25-2-3.49-1.44a3.66,3.66,0,0,0-1.57,1.86l-2.86,5.62a11.33,11.33,0,0,0-1.66,5.2,5.73,5.73,0,0,0,2.35,4.45C203.6,213,207.79,206.83,208.41,202.49Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.4",
              transformOrigin: " 202.463px 201.406px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M188.54,217.54c6.88-4.27,14.23-1.4,16.41,6.41C198.06,228.22,190.71,225.35,188.54,217.54Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 196.745px 220.745px 0px",
          }}
          id="elamdb3g55m57"
          className="animable"
        ></path>
        <g id="ely1aw6rkkrmm">
          <path
            d="M189.93,218.09a91.37,91.37,0,0,1,13.63,5.31A91,91,0,0,1,189.93,218.09Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 196.745px 220.745px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M217.08,208.06c-8-1.08-13.57,4.54-12.36,12.55C212.75,221.69,218.28,216.07,217.08,208.06Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 210.899px 214.335px 0px",
          }}
          id="els4ztt05uyg8"
          className="animable"
        ></path>
        <g id="el6xdrc111lpe">
          <path
            d="M216,209.12a89.44,89.44,0,0,0-10.26,10.43A90.25,90.25,0,0,0,216,209.12Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 210.87px 214.335px 0px",
            }}
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--flowers-1--inject-18"
        style={{ transformOrigin: " 88.8917px 286.425px 0px" }}
        className="animable"
      >
        <path
          d="M104.69,293.3l-17.93.53-17.94-.53c-.77,12.12,1.59,24.46,4.85,30.49h0a8.14,8.14,0,0,0,3.55,3.61c5.29,3.05,13.84,3.05,19.1,0a8,8,0,0,0,3.55-3.71C103.12,317.63,105.46,305.36,104.69,293.3Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 86.7555px 311.494px 0px",
          }}
          id="elvhyxa8c111c"
          className="animable"
        ></path>
        <g id="elei81nd44gd">
          <path
            d="M104.69,293.3l-17.93.53-17.94-.53c-.77,12.12,1.59,24.46,4.85,30.49h0a8.14,8.14,0,0,0,3.55,3.61c5.29,3.05,13.84,3.05,19.1,0a8,8,0,0,0,3.55-3.71C103.12,317.63,105.46,305.36,104.69,293.3Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.5",
              transformOrigin: " 86.7555px 311.494px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M99.4,286c7,4.06,7.06,10.63.08,14.69s-18.34,4.06-25.36,0S67.05,290,74,286,92.37,281.9,99.4,286Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 86.7519px 293.349px 0px",
          }}
          id="eln9dvl4wbag"
          className="animable"
        ></path>
        <g id="elqnpypsfrdck">
          <g
            style={{
              opacity: "0.7",
              transformOrigin: " 86.7519px 293.349px 0px",
            }}
            className="animable"
          >
            <path
              d="M99.4,286c7,4.06,7.06,10.63.08,14.69s-18.34,4.06-25.36,0S67.05,290,74,286,92.37,281.9,99.4,286Z"
              style={{
                fill: " rgb(255, 255, 255)",
                transformOrigin: " 86.7519px 293.349px 0px",
              }}
              id="eltixnv6njop"
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M97.34,287.16c5.88,3.39,5.91,8.9.06,12.29s-15.34,3.4-21.22,0-5.91-8.9-.07-12.29S91.45,283.76,97.34,287.16Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 86.7594px 293.305px 0px",
          }}
          id="el5g2lzmy8o1c"
          className="animable"
        ></path>
        <path
          d="M89.74,294.34a.76.76,0,0,1-.76-.72A67.65,67.65,0,0,1,95,262.37a.76.76,0,1,1,1.39.63,66.1,66.1,0,0,0-5.93,30.54.77.77,0,0,1-.73.8Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 92.6816px 278.131px 0px",
          }}
          id="el47a7cpwvadk"
          className="animable"
        ></path>
        <g id="elw67923zevz">
          <g
            style={{
              opacity: "0.2",
              transformOrigin: " 92.6816px 278.131px 0px",
            }}
            className="animable"
          >
            <path
              d="M89.74,294.34a.76.76,0,0,1-.76-.72A67.65,67.65,0,0,1,95,262.37a.76.76,0,1,1,1.39.63,66.1,66.1,0,0,0-5.93,30.54.77.77,0,0,1-.73.8Z"
              id="elqjo1u9ljb8s"
              style={{ transformOrigin: " 92.6816px 278.131px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M100.87,247a3.6,3.6,0,0,1,2.14-1.63c1.41-.32,2.81.52,3.89,1.47a11.12,11.12,0,0,1,2.85,3.65,6.93,6.93,0,0,1,.54,4.54,4.82,4.82,0,0,1-7.36,3.1,6.82,6.82,0,0,1-2.85-3.63A8.43,8.43,0,0,1,100.87,247Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 104.998px 252.106px 0px",
          }}
          id="el00l9hlq0bbmu"
          className="animable"
        ></path>
        <g id="elpav9yg63owp">
          <path
            d="M100.87,247a3.6,3.6,0,0,1,2.14-1.63c1.41-.32,2.81.52,3.89,1.47a11.12,11.12,0,0,1,2.85,3.65,6.93,6.93,0,0,1,.54,4.54,4.82,4.82,0,0,1-7.36,3.1,6.82,6.82,0,0,1-2.85-3.63A8.43,8.43,0,0,1,100.87,247Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.1",
              transformOrigin: " 104.998px 252.106px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M90.94,246.31a6.4,6.4,0,0,1,4.32-3.07,5.37,5.37,0,0,1,4.92,1.72,8.07,8.07,0,0,1,1.48,3.34,10.5,10.5,0,0,1,.36,3.61,5.24,5.24,0,0,1-1.48,3.25,4.86,4.86,0,0,1-4,1.18,7.43,7.43,0,0,1-3.82-1.84c-.95-.81-2.44-2.16-2.76-3.42A7,7,0,0,1,90.94,246.31Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 95.9638px 249.781px 0px",
          }}
          id="el2vijz4dlzmi"
          className="animable"
        ></path>
        <path
          d="M95.26,247.54a2.92,2.92,0,0,1,2.78-.38,15.42,15.42,0,0,1,2,1.43,14.5,14.5,0,0,0,3.72,1.15,6.38,6.38,0,0,1,3.14,2.09,4.88,4.88,0,0,1,1,3.59,3.94,3.94,0,0,1-2.12,3c-1.59.75-3.46.24-5.1-.35a14.72,14.72,0,0,1-5.09-2.72C93.46,253.37,92.47,249.55,95.26,247.54Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 100.741px 252.881px 0px",
          }}
          id="elgalz2leaeh9"
          className="animable"
        ></path>
        <g id="elyks4chccipm">
          <path
            d="M95.26,247.54a2.92,2.92,0,0,1,2.78-.38,15.42,15.42,0,0,1,2,1.43,14.5,14.5,0,0,0,3.72,1.15,6.38,6.38,0,0,1,3.14,2.09,4.88,4.88,0,0,1,1,3.59,3.94,3.94,0,0,1-2.12,3c-1.59.75-3.46.24-5.1-.35a14.72,14.72,0,0,1-5.09-2.72C93.46,253.37,92.47,249.55,95.26,247.54Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 100.741px 252.881px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M97.36,251.24a2.43,2.43,0,0,1,0-1.74,1.34,1.34,0,0,1,1.44-.79,1.85,1.85,0,0,1,1,.78,7.43,7.43,0,0,1,1.19,2.43c.27,1,0,3.34-1.62,2.67-.48-.2-.71-.81-.92-1.24A18,18,0,0,1,97.36,251.24Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 99.1401px 251.701px 0px",
          }}
          id="elf3uws2kvhmi"
          className="animable"
        ></path>
        <g id="elibp876ku20g">
          <path
            d="M97.36,251.24a2.43,2.43,0,0,1,0-1.74,1.34,1.34,0,0,1,1.44-.79,1.85,1.85,0,0,1,1,.78,7.43,7.43,0,0,1,1.19,2.43c.27,1,0,3.34-1.62,2.67-.48-.2-.71-.81-.92-1.24A18,18,0,0,1,97.36,251.24Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 99.1401px 251.701px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M100.91,252.56a3,3,0,0,1,1.94-.77,2.12,2.12,0,0,1,1,.23,1.27,1.27,0,0,1,.64.81,1.41,1.41,0,0,1-.43,1.26,3.08,3.08,0,0,1-1.19.69,2.32,2.32,0,0,1-2.52-.22C99.79,253.92,100.39,253,100.91,252.56Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 102.317px 253.421px 0px",
          }}
          id="el2cm0jvpgzow"
          className="animable"
        ></path>
        <g id="elz5mqti6pdlm">
          <path
            d="M100.91,252.56a3,3,0,0,1,1.94-.77,2.12,2.12,0,0,1,1,.23,1.27,1.27,0,0,1,.64.81,1.41,1.41,0,0,1-.43,1.26,3.08,3.08,0,0,1-1.19.69,2.32,2.32,0,0,1-2.52-.22C99.79,253.92,100.39,253,100.91,252.56Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 102.317px 253.421px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M98.27,252a5,5,0,0,0,1.74,1.45c.94.37,2,.15,2.95.6a2.88,2.88,0,0,1,1.33,3,4.49,4.49,0,0,1-4.43,3.52A5.73,5.73,0,0,1,95,257.38a8.82,8.82,0,0,1-.43-5.93C95.13,249.16,97.36,250.94,98.27,252Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 99.2943px 255.453px 0px",
          }}
          id="elmcwl9te89ws"
          className="animable"
        ></path>
        <path
          d="M105.88,256.24c.86-.64,1.85-1.42,2.87-1.12a2.06,2.06,0,0,1,1.31,1.74,4.66,4.66,0,0,1-.41,2.23,14.25,14.25,0,0,1-8.92,8.29,6.45,6.45,0,0,1-5.12-.19,4.2,4.2,0,0,1-2-3.9c.2-2.46,2.25-3.82,4.45-4.05A15.74,15.74,0,0,0,105.88,256.24Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 101.834px 261.437px 0px",
          }}
          id="elmpc71k13gmg"
          className="animable"
        ></path>
        <g id="eloclejyqdmb">
          <path
            d="M105.88,256.24c.86-.64,1.85-1.42,2.87-1.12a2.06,2.06,0,0,1,1.31,1.74,4.66,4.66,0,0,1-.41,2.23,14.25,14.25,0,0,1-8.92,8.29,6.45,6.45,0,0,1-5.12-.19,4.2,4.2,0,0,1-2-3.9c.2-2.46,2.25-3.82,4.45-4.05A15.74,15.74,0,0,0,105.88,256.24Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 101.834px 261.437px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M87.56,258.56A11.15,11.15,0,0,1,90,250c.86-1,2.23-2,3.46-1.42A3.67,3.67,0,0,1,95,250.43c.94,1.86,1.89,3.71,2.83,5.56a11.19,11.19,0,0,1,1.64,5.16,5.66,5.66,0,0,1-2.33,4.4C92.33,269,88.18,262.86,87.56,258.56Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 93.4658px 257.485px 0px",
          }}
          id="elmp49a6yglaj"
          className="animable"
        ></path>
        <g id="el5cyoaha5rr5">
          <path
            d="M87.56,258.56A11.15,11.15,0,0,1,90,250c.86-1,2.23-2,3.46-1.42A3.67,3.67,0,0,1,95,250.43c.94,1.86,1.89,3.71,2.83,5.56a11.19,11.19,0,0,1,1.64,5.16,5.66,5.66,0,0,1-2.33,4.4C92.33,269,88.18,262.86,87.56,258.56Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 93.4658px 257.485px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M107.24,273.47c-6.82-4.23-14.09-1.39-16.25,6.34C97.81,284,105.09,281.19,107.24,273.47Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 99.115px 276.63px 0px",
          }}
          id="elf3lmm7lvsa7"
          className="animable"
        ></path>
        <g id="elffq8830qt0e">
          <path
            d="M107.24,273.47c-6.82-4.23-14.09-1.39-16.25,6.34C97.81,284,105.09,281.19,107.24,273.47Z"
            style={{
              opacity: "0.3",
              transformOrigin: " 99.115px 276.63px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="el4f0y0h5ss0n">
          <path
            d="M105.86,274a89.16,89.16,0,0,0-13.49,5.27A89.16,89.16,0,0,0,105.86,274Z"
            style={{
              fill: " rgb(176, 22, 94)",
              opacity: "0.6",
              transformOrigin: " 99.115px 276.635px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M83.45,284.07c-1.41-4.59-5.8-6.17-9.82-3.54C75,285.12,79.44,286.71,83.45,284.07Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 78.54px 282.302px 0px",
          }}
          id="el6plt5bpm0xc"
          className="animable"
        ></path>
        <g id="elvbq7jihrdv">
          <path
            d="M83.45,284.07c-1.41-4.59-5.8-6.17-9.82-3.54C75,285.12,79.44,286.71,83.45,284.07Z"
            style={{
              opacity: "0.3",
              transformOrigin: " 78.54px 282.302px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elzrkeqpqcigp">
          <path
            d="M82.62,283.77a53.53,53.53,0,0,0-8.15-2.94A53.53,53.53,0,0,0,82.62,283.77Z"
            style={{
              fill: " rgb(176, 22, 94)",
              opacity: "0.6",
              transformOrigin: " 78.545px 282.3px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M84.53,293.43h0a.77.77,0,0,1-.75-.78,38.68,38.68,0,0,0-5.33-20.32.78.78,0,0,1,.27-1.05.76.76,0,0,1,1,.27,40.21,40.21,0,0,1,5.54,21.13A.76.76,0,0,1,84.53,293.43Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 81.8075px 282.311px 0px",
          }}
          id="elksx2r28vv4"
          className="animable"
        ></path>
        <g id="elcskxx6c1red">
          <g
            style={{
              opacity: "0.2",
              transformOrigin: " 81.8075px 282.311px 0px",
            }}
            className="animable"
          >
            <path
              d="M84.53,293.43h0a.77.77,0,0,1-.75-.78,38.68,38.68,0,0,0-5.33-20.32.78.78,0,0,1,.27-1.05.76.76,0,0,1,1,.27,40.21,40.21,0,0,1,5.54,21.13A.76.76,0,0,1,84.53,293.43Z"
              id="elufcm66p9u1"
              style={{ transformOrigin: " 81.8075px 282.311px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M75.18,259.56a3,3,0,0,0-1.76-1.34,3.82,3.82,0,0,0-3.18,1.21,9.16,9.16,0,0,0-2.34,3,5.77,5.77,0,0,0-.44,3.72,4,4,0,0,0,6,2.54,5.61,5.61,0,0,0,2.34-3A6.9,6.9,0,0,0,75.18,259.56Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 71.7885px 263.742px 0px",
          }}
          id="els5ilu3cbbno"
          className="animable"
        ></path>
        <g id="el9t8wki6ofkc">
          <path
            d="M75.18,259.56a3,3,0,0,0-1.76-1.34,3.82,3.82,0,0,0-3.18,1.21,9.16,9.16,0,0,0-2.34,3,5.77,5.77,0,0,0-.44,3.72,4,4,0,0,0,6,2.54,5.61,5.61,0,0,0,2.34-3A6.9,6.9,0,0,0,75.18,259.56Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.1",
              transformOrigin: " 71.7885px 263.742px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M83.31,259a5.23,5.23,0,0,0-3.53-2.51,4.4,4.4,0,0,0-4,1.41,6.74,6.74,0,0,0-1.21,2.73,8.48,8.48,0,0,0-.29,3,4.19,4.19,0,0,0,1.21,2.66,4,4,0,0,0,3.26,1,6.16,6.16,0,0,0,3.13-1.51,7.06,7.06,0,0,0,2.26-2.8A5.73,5.73,0,0,0,83.31,259Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 79.2309px 261.881px 0px",
          }}
          id="el90rjirii4x"
          className="animable"
        ></path>
        <path
          d="M79.78,260a2.4,2.4,0,0,0-2.28-.32,13.53,13.53,0,0,0-1.66,1.18,12.8,12.8,0,0,1-3,.94,5.21,5.21,0,0,0-2.58,1.71,4,4,0,0,0-.85,2.94A3.23,3.23,0,0,0,71.11,269c1.3.62,2.83.2,4.18-.29a12.1,12.1,0,0,0,4.16-2.22C81.25,264.81,82.06,261.68,79.78,260Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 75.2797px 264.418px 0px",
          }}
          id="elvnu1dgaxs1i"
          className="animable"
        ></path>
        <g id="ellpszej2jvsh">
          <path
            d="M79.78,260a2.4,2.4,0,0,0-2.28-.32,13.53,13.53,0,0,0-1.66,1.18,12.8,12.8,0,0,1-3,.94,5.21,5.21,0,0,0-2.58,1.71,4,4,0,0,0-.85,2.94A3.23,3.23,0,0,0,71.11,269c1.3.62,2.83.2,4.18-.29a12.1,12.1,0,0,0,4.16-2.22C81.25,264.81,82.06,261.68,79.78,260Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 75.2797px 264.418px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M78.05,263.06a1.94,1.94,0,0,0,0-1.42,1.09,1.09,0,0,0-1.18-.65,1.52,1.52,0,0,0-.8.64,6.24,6.24,0,0,0-1,2c-.22.79,0,2.73,1.33,2.18.39-.16.58-.66.76-1A15.41,15.41,0,0,0,78.05,263.06Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 76.5902px 263.441px 0px",
          }}
          id="el0gr2ei3xnc3a"
          className="animable"
        ></path>
        <g id="el8uifiiwc4v4">
          <path
            d="M78.05,263.06a1.94,1.94,0,0,0,0-1.42,1.09,1.09,0,0,0-1.18-.65,1.52,1.52,0,0,0-.8.64,6.24,6.24,0,0,0-1,2c-.22.79,0,2.73,1.33,2.18.39-.16.58-.66.76-1A15.41,15.41,0,0,0,78.05,263.06Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 76.5902px 263.441px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M75.14,264.14a2.44,2.44,0,0,0-1.58-.63,1.73,1.73,0,0,0-.84.19,1,1,0,0,0-.52.66,1.13,1.13,0,0,0,.35,1,2.57,2.57,0,0,0,1,.57,1.94,1.94,0,0,0,2.07-.18C76.06,265.26,75.57,264.53,75.14,264.14Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 73.9899px 264.829px 0px",
          }}
          id="elm6aymtyd2fn"
          className="animable"
        ></path>
        <g id="ely022bpl2p2k">
          <path
            d="M75.14,264.14a2.44,2.44,0,0,0-1.58-.63,1.73,1.73,0,0,0-.84.19,1,1,0,0,0-.52.66,1.13,1.13,0,0,0,.35,1,2.57,2.57,0,0,0,1,.57,1.94,1.94,0,0,0,2.07-.18C76.06,265.26,75.57,264.53,75.14,264.14Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 73.9899px 264.829px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M77.3,263.69a4,4,0,0,1-1.42,1.19c-.77.3-1.67.13-2.41.49a2.37,2.37,0,0,0-1.09,2.49A3.69,3.69,0,0,0,76,270.75a4.7,4.7,0,0,0,4-2.66,7.31,7.31,0,0,0,.36-4.86C79.88,261.36,78.06,262.82,77.3,263.69Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 76.4752px 266.536px 0px",
          }}
          id="elodc73nx8p5n"
          className="animable"
        ></path>
        <path
          d="M71.07,267.15c-.7-.52-1.51-1.16-2.35-.91a1.65,1.65,0,0,0-1.06,1.42,3.75,3.75,0,0,0,.33,1.83,11.65,11.65,0,0,0,7.3,6.79,5.28,5.28,0,0,0,4.2-.16,3.45,3.45,0,0,0,1.66-3.19,3.75,3.75,0,0,0-3.65-3.31A13,13,0,0,1,71.07,267.15Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 74.4042px 271.412px 0px",
          }}
          id="el5brhbm3iuw"
          className="animable"
        ></path>
        <g id="el2swxat9c6cq">
          <path
            d="M71.07,267.15c-.7-.52-1.51-1.16-2.35-.91a1.65,1.65,0,0,0-1.06,1.42,3.75,3.75,0,0,0,.33,1.83,11.65,11.65,0,0,0,7.3,6.79,5.28,5.28,0,0,0,4.2-.16,3.45,3.45,0,0,0,1.66-3.19,3.75,3.75,0,0,0-3.65-3.31A13,13,0,0,1,71.07,267.15Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 74.4042px 271.412px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M86.08,269.06a9.12,9.12,0,0,0-2-7c-.7-.85-1.82-1.62-2.83-1.17A3,3,0,0,0,80,262.4q-1.16,2.28-2.32,4.55a9.15,9.15,0,0,0-1.34,4.23,4.65,4.65,0,0,0,1.9,3.6C82.17,277.57,85.57,272.57,86.08,269.06Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 81.2499px 268.175px 0px",
          }}
          id="elvv313ucm31o"
          className="animable"
        ></path>
        <g id="ellfwz7juhrt">
          <path
            d="M86.08,269.06a9.12,9.12,0,0,0-2-7c-.7-.85-1.82-1.62-2.83-1.17A3,3,0,0,0,80,262.4q-1.16,2.28-2.32,4.55a9.15,9.15,0,0,0-1.34,4.23,4.65,4.65,0,0,0,1.9,3.6C82.17,277.57,85.57,272.57,86.08,269.06Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.3",
              transformOrigin: " 81.2499px 268.175px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M83.22,281.78c5.44-1,7.8-5.9,5.27-10.83C83.05,272,80.69,276.85,83.22,281.78Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 85.855px 276.365px 0px",
          }}
          id="el4i56hyx3fch"
          className="animable"
        ></path>
        <g id="ele50zgayqlgv">
          <path
            d="M83.22,281.78c5.44-1,7.8-5.9,5.27-10.83C83.05,272,80.69,276.85,83.22,281.78Z"
            style={{
              opacity: "0.3",
              transformOrigin: " 85.855px 276.365px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elrunjnrsc7ko">
          <path
            d="M83.66,280.86a61.25,61.25,0,0,0,4.39-9A61.25,61.25,0,0,0,83.66,280.86Z"
            style={{
              fill: " rgb(176, 22, 94)",
              opacity: "0.6",
              transformOrigin: " 85.855px 276.36px 0px",
            }}
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--Character--inject-18"
        style={{ transformOrigin: " 202.519px 321.174px 0px" }}
        className="animable"
      >
        <path
          d="M270.47,229.58c-3.3-4.11-7.56-6.17-9.53-4.59a3.18,3.18,0,0,0-1,2.72h0v.17c.26,6.28,1.38,14.47,11.65,12.52h0a2.39,2.39,0,0,0,1.26-.5C274.83,238.32,273.76,233.7,270.47,229.58Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 266.881px 232.576px 0px",
          }}
          id="elcx4w51d9mmc"
          className="animable"
        ></path>
        <g id="elcsw6v7cvgm">
          <path
            d="M271,233.62a20.08,20.08,0,0,0-3.86-4.9,12,12,0,0,0-4.09-2.9,5.84,5.84,0,0,0-2.62-.33,3.74,3.74,0,0,0-.51,2.22h0v.17c.26,6.28,1.38,14.47,11.65,12.52h0a1.76,1.76,0,0,0,.41-.1,6,6,0,0,0,.15-.61A9.67,9.67,0,0,0,271,233.62Z"
            style={{
              opacity: "0.2",
              transformOrigin: " 266.066px 233.076px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M252.39,265.16l10.71-28.88a2.44,2.44,0,0,1,3,.94l-8.76,36.29Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 259.245px 254.8px 0px",
          }}
          id="elsqb6t37lmj"
          className="animable"
        ></path>
        <g id="el0jvmwwydqpva">
          <path
            d="M266.14,237.22a1.9,1.9,0,0,0-1.27-1L255.29,270l2.09,3.49Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 260.715px 254.855px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M258.08,272.75h0a96.78,96.78,0,0,0-10.61-20.12l-30.9,17.42s1.75,14.91,4.76,23.45h0c.76,2.31,2.74,4,5.92,4.58,7.75,1.48,19.66-3.88,26.6-12C258.21,281,259.57,276.09,258.08,272.75Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 237.616px 275.478px 0px",
          }}
          id="ellnl8jlb2dab"
          className="animable"
        ></path>
        <g id="elv7wirocega">
          <path
            d="M258.08,272.75h0a96.78,96.78,0,0,0-10.61-20.12l-30.9,17.42s1.75,14.91,4.76,23.45h0c.76,2.31,2.74,4,5.92,4.58,7.75,1.48,19.66-3.88,26.6-12C258.21,281,259.57,276.09,258.08,272.75Z"
            style={{
              opacity: "0.2",
              transformOrigin: " 237.616px 275.478px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M220.57,260.21c-5.88,6.85-5.33,13.41,1.24,14.67s16.65-3.29,22.53-10.14,5.32-13.43-1.24-14.68S226.45,253.35,220.57,260.21Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 232.453px 262.471px 0px",
          }}
          id="elblepiczhngo"
          className="animable"
        ></path>
        <g id="eltbd69ky5vqd">
          <g
            style={{
              opacity: "0.4",
              transformOrigin: " 232.453px 262.471px 0px",
            }}
            className="animable"
          >
            <path
              d="M220.57,260.21c-5.88,6.85-5.33,13.41,1.24,14.67s16.65-3.29,22.53-10.14,5.32-13.43-1.24-14.68S226.45,253.35,220.57,260.21Z"
              id="el979nasut816"
              style={{ transformOrigin: " 232.453px 262.471px 0px" }}
              className="animable"
            ></path>
          </g>
        </g>
        <path
          d="M234.37,258.8h0a6.53,6.53,0,0,0-.9-1.5h0c.33.53.14,1.37-.6,2.23a5.21,5.21,0,0,1-4.23,1.9,1.13,1.13,0,0,1-.89-.62h0a6.16,6.16,0,0,0,.89,1.5h0a1.21,1.21,0,0,0,.84.54,5.25,5.25,0,0,0,4.23-1.9C234.42,260.13,234.63,259.33,234.37,258.8Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 231.114px 260.077px 0px",
          }}
          id="elhj6xd3ngodd"
          className="animable"
        ></path>
        <g id="eltwj0fcdllpn">
          <path
            d="M234.37,258.8h0a6.53,6.53,0,0,0-.9-1.5h0c.33.53.14,1.37-.6,2.23a5.21,5.21,0,0,1-4.23,1.9,1.13,1.13,0,0,1-.89-.62h0a6.16,6.16,0,0,0,.89,1.5h0a1.21,1.21,0,0,0,.84.54,5.25,5.25,0,0,0,4.23-1.9C234.42,260.13,234.63,259.33,234.37,258.8Z"
            style={{
              opacity: "0.2",
              transformOrigin: " 231.114px 260.077px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M228.64,261.43a5.21,5.21,0,0,0,4.23-1.9c.74-.86.93-1.7.6-2.23a1.16,1.16,0,0,0-.83-.52,5.2,5.2,0,0,0-4.23,1.9c-.69.81-.91,1.6-.66,2.13A1.13,1.13,0,0,0,228.64,261.43Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 230.638px 259.105px 0px",
          }}
          id="el011zm8lwns8r"
          className="animable"
        ></path>
        <path
          d="M219.42,258.56A26.21,26.21,0,0,1,227,247.7l-2.42-1.35a26,26,0,0,0-7.21,10.5c-2.18,6-1.83,12.93,1.05,21.23l2.58,1.79C218.73,272.8,217,265.32,219.42,258.56Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 221.481px 263.11px 0px",
          }}
          id="elzh6vpgpjbz"
          className="animable"
        ></path>
        <path
          d="M219.42,258.56c-2.46,6.76-.69,14.24,1.6,21.31,0,0,0-2.4,0-3.48-1.69-5.93-2.63-12-.63-17.48A25.18,25.18,0,0,1,228,248.23l-.93-.53A26.21,26.21,0,0,0,219.42,258.56Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 223.116px 263.785px 0px",
          }}
          id="ellmnouiief0k"
          className="animable"
        ></path>
        <g id="elmlnx9tro4qs">
          <path
            d="M219.42,258.56c-2.46,6.76-.69,14.24,1.6,21.31,0,0,0-2.4,0-3.48-1.69-5.93-2.63-12-.63-17.48A25.18,25.18,0,0,1,228,248.23l-.93-.53A26.21,26.21,0,0,0,219.42,258.56Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 223.116px 263.785px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M146,354.62l15.75,7.92c-2-12.33-4.2-24.5-6.24-36.82C149.61,333.38,146.1,344.93,146,354.62Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 153.875px 344.13px 0px",
          }}
          id="el7nrd86smrav"
          className="animable"
        ></path>
        <g id="elxgohspiu7tq">
          <path
            d="M146,354.62l15.75,7.92c-2-12.33-4.2-24.5-6.24-36.82C149.61,333.38,146.1,344.93,146,354.62Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 153.875px 344.13px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M171,427.17a35.08,35.08,0,0,0,16,9.13c1.74.45,3.79,1,4.43,2.66s-.45,3.35-1.81,4.37a10.83,10.83,0,0,1-7.71,1.74,34.4,34.4,0,0,1-7.78-2.18,28.75,28.75,0,0,0-7.82-2,34.48,34.48,0,0,1-3.81-.22,4.67,4.67,0,0,1-3.21-1.87c0-7.78,2-10.56,2-10.56Z"
          style={{
            fill: " rgb(55, 71, 79)",
            transformOrigin: " 175.454px 436.182px 0px",
          }}
          id="el08y837mx0ut7"
          className="animable"
        ></path>
        <path
          d="M171.19,423.73V429c-3.55,3.87-9.16,1.29-9.85-.76l-.17-4.51Z"
          style={{
            fill: " rgb(255, 168, 167)",
            transformOrigin: " 166.18px 427.365px 0px",
          }}
          id="elnl8mz3re5nf"
          className="animable"
        ></path>
        <path
          d="M144.72,404.86c6.3-5.7,9.79-5.47,11.31-4.33s4.25,4.78-2.73,10.93-6.46,10-11.32,10-3.94-4.86-3.94-4.86a21.3,21.3,0,0,1,.76-5Z"
          style={{
            fill: " rgb(55, 71, 79)",
            transformOrigin: " 147.912px 410.67px 0px",
          }}
          id="elkcwiohwvw6o"
          className="animable"
        ></path>
        <path
          d="M147,408.5v3.72c-3,2.54-7.93,1.1-8.19-.64l.22-3.69Z"
          style={{
            fill: " rgb(255, 168, 167)",
            transformOrigin: " 142.905px 410.742px 0px",
          }}
          id="el2zfn8qz3vlq"
          className="animable"
        ></path>
        <path
          d="M175.84,305.1l2.74,64.68-7.39,54c-3.95,2.53-10,0-10,0-.81-16.6-4.46-40.13-1.57-52.73l-5.47-34.77-1.82,27.94C152,380.56,147.75,398,147,408.5a9.14,9.14,0,0,1-8-.61c-2.45-21.81-7.31-33.55-2.65-49.14-3.24-29.35-6-47.57-2-55Z"
          style={{
            fill: " rgb(38, 50, 56)",
            transformOrigin: " 155.472px 364.327px 0px",
          }}
          id="elw56n1jwsjd"
          className="animable"
        ></path>
        <g id="eltscl7ww6ibk">
          <path
            d="M175.84,305.1l2.74,64.68-7.39,54c-3.95,2.53-10,0-10,0-.81-16.6-4.46-40.13-1.57-52.73l-5.47-34.77-1.82,27.94C152,380.56,147.75,398,147,408.5a9.14,9.14,0,0,1-8-.61c-2.45-21.81-7.31-33.55-2.65-49.14-3.24-29.35-6-47.57-2-55Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.1",
              transformOrigin: " 155.472px 364.327px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="elovbdf0hm2kl">
          <path
            d="M153.09,329.6l1,6.63-.57,8.81-2.09-13.82a12.63,12.63,0,0,1-9-5.77A23.5,23.5,0,0,0,153.09,329.6Z"
            style={{
              opacity: "0.2",
              transformOrigin: " 148.26px 335.245px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M163.27,244.53,144.2,242c-8-.78-11.41,8-11.3,16.08a40.41,40.41,0,0,0,.4,4.49,137,137,0,0,1-1.38,42.23,36.11,36.11,0,0,0-.65,6.15c-1.89,9.29,31.69,14.51,43.77,8.29a4.43,4.43,0,0,0,2.39-4.1c-.55-16.94-2.63-48.47-2.63-48.47Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 154.313px 281.95px 0px",
          }}
          id="elh77923rsdy"
          className="animable"
        ></path>
        <g id="elb3m88vpq03">
          <path
            d="M163.27,244.53,144.2,242c-8-.78-11.41,8-11.3,16.08a40.41,40.41,0,0,0,.4,4.49,137,137,0,0,1-1.38,42.23,36.11,36.11,0,0,0-.65,6.15c-1.89,9.29,31.69,14.51,43.77,8.29a4.43,4.43,0,0,0,2.39-4.1c-.55-16.94-2.63-48.47-2.63-48.47Z"
            style={{
              opacity: "0.3",
              transformOrigin: " 154.313px 281.95px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="eljtlr8zdhjeq">
          <path
            d="M163.27,244.53,144.2,242c-8-.78-11.41,8-11.3,16.08a40.41,40.41,0,0,0,.4,4.49,137,137,0,0,1-1.38,42.23,36.11,36.11,0,0,0-.65,6.15c-1.89,9.29,31.69,14.51,43.77,8.29a4.43,4.43,0,0,0,2.39-4.1c-.55-16.94-2.63-48.47-2.63-48.47Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 154.313px 281.95px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M219.53,259.91a193.55,193.55,0,0,1-21.2,27.24,5.16,5.16,0,0,1-6.51.73c-10.79-7.09-19.72-19.17-19.72-19.17l11.66-8,10.1,13.12L213,255l3.23-5.68a8.79,8.79,0,0,1,5.27-4.09l3.37-.93a3,3,0,0,1,2.88.69,1.59,1.59,0,0,1,.32.44,1.12,1.12,0,0,1-.23,1.23h.62a3.18,3.18,0,0,1,3.07,2.42h0a3.17,3.17,0,0,1-.16,2l-2.58,6.09a4.62,4.62,0,0,1-4.3,2.81Z"
          style={{
            fill: " rgb(255, 168, 167)",
            transformOrigin: " 201.861px 266.448px 0px",
          }}
          id="elsfzbhesd007"
          className="animable"
        ></path>
        <path
          d="M202.43,263.25a2.37,2.37,0,0,0-2.2.59l-2.68,2.55a2.36,2.36,0,0,0-.7,2l0,.25.77-.73c9.53,3,8.49,12.55,8.49,12.55l-1.34,1.71a2.32,2.32,0,0,0,2.24-.86l3.33-4.2a2.38,2.38,0,0,0,.51-1.56C210.75,272.91,209.72,265.07,202.43,263.25Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 203.841px 272.694px 0px",
          }}
          id="el0rjxm0b5txf"
          className="animable"
        ></path>
        <g id="elqrqh1gfvlc">
          <path
            d="M202.43,263.25a2.37,2.37,0,0,0-2.2.59l-2.68,2.55a2.36,2.36,0,0,0-.7,2l0,.25.77-.73c9.53,3,8.49,12.55,8.49,12.55l-1.34,1.71a2.32,2.32,0,0,0,2.24-.86l3.33-4.2a2.38,2.38,0,0,0,.51-1.56C210.75,272.91,209.72,265.07,202.43,263.25Z"
            style={{
              opacity: "0.3",
              transformOrigin: " 203.841px 272.694px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M197.66,268l-.77.73-3.22,3L192.54,270l-13-17A21.6,21.6,0,0,0,165,244.74l-1.74-.21s-3.49,14.63,4,22.78l14.3,15.14a56.51,56.51,0,0,0,9.55,7.36,6.67,6.67,0,0,0,8.87-1.48l6.16-7.83S207.19,271,197.66,268Z"
          style={{
            fill: " rgb(176, 22, 94)",
            transformOrigin: " 184.311px 267.705px 0px",
          }}
          id="ele9q29v0h4e6"
          className="animable"
        ></path>
        <g id="elt3mfe5ttb6c">
          <path
            d="M197.66,268l-.77.73-3.22,3L192.54,270l-13-17A21.6,21.6,0,0,0,165,244.74l-1.74-.21s-3.49,14.63,4,22.78l14.3,15.14a56.51,56.51,0,0,0,9.55,7.36,6.67,6.67,0,0,0,8.87-1.48l6.16-7.83S207.19,271,197.66,268Z"
            style={{
              opacity: "0.2",
              transformOrigin: " 184.311px 267.705px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <g id="eloqlljrei9m">
          <path
            d="M197.66,268l-.77.73-3.22,3L192.54,270l-13-17A21.6,21.6,0,0,0,165,244.74l-1.74-.21s-3.49,14.63,4,22.78l14.3,15.14a56.51,56.51,0,0,0,9.55,7.36,6.67,6.67,0,0,0,8.87-1.48l6.16-7.83S207.19,271,197.66,268Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 184.311px 267.705px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M168.05,213.67a2.19,2.19,0,0,0,.32-2.41,2.74,2.74,0,0,0,2.29-.32,2.12,2.12,0,0,0,1-1.95,1.77,1.77,0,0,0-1.48-1.56,2.88,2.88,0,0,0,1.75-1.2,2.8,2.8,0,0,0,.55-2,3.72,3.72,0,0,0-2.57-2.86,9,9,0,0,0-4-.21,3.23,3.23,0,0,0-1.69-3.8,4,4,0,0,0-3.68.6,11.88,11.88,0,0,0-2.6,2.87,11.8,11.8,0,0,0-9.6-.61,12,12,0,0,0-6.7,7,7.85,7.85,0,0,0-5.09,5.31,12.42,12.42,0,0,0,.44,7.45,34,34,0,0,0,3.48,6.72l1.92,3c.81,1.28,2.87,4.44,3.68,5.71a11.93,11.93,0,0,0,11.36-.69,19.34,19.34,0,0,0,7.3-9.06A61.66,61.66,0,0,0,168.05,213.67Z"
          style={{
            fill: " rgb(38, 50, 56)",
            transformOrigin: " 154.336px 216.841px 0px",
          }}
          id="el3ykq84txqtb"
          className="animable"
        ></path>
        <path
          d="M169.81,221.56l2.43,4.22-2.4.89C169.91,225,169.91,223.26,169.81,221.56Z"
          style={{
            fill: " rgb(242, 143, 143)",
            transformOrigin: " 171.025px 224.115px 0px",
          }}
          id="elgk5v4g4fwks"
          className="animable"
        ></path>
        <path
          d="M168.05,213.67a34.14,34.14,0,0,1,1.76,7.89c.1,1.7.1,3.41,0,5.11a48.84,48.84,0,0,1-.84,7.13,7.79,7.79,0,0,1-1.4,3.58,5.66,5.66,0,0,1-3.89,1.79,16.47,16.47,0,0,1-4.36-.42v6.92c-5.25,1.24-9.6,1.78-13.72-1.39l.44-8.9a12.79,12.79,0,0,0,7.39-1.16c3.63-2,4.65-5.09,4.14-6.84a2.73,2.73,0,0,1-2.84,1,3.83,3.83,0,0,1-2.36-1.87,8.08,8.08,0,0,1-.88-2.95,5.35,5.35,0,0,1,.54-3.64,3.81,3.81,0,0,1,4.11-1.39,5.92,5.92,0,0,1,3.46,2.89,9.39,9.39,0,0,1,.61,1.33.82.82,0,0,0,1.59-.21,11,11,0,0,0-1-5.79,4.13,4.13,0,0,0,1.94.45,2.45,2.45,0,0,0,1.86-.86,1.67,1.67,0,0,0,.07-2C166.4,215.25,168.05,213.67,168.05,213.67Z"
          style={{
            fill: " rgb(255, 168, 167)",
            transformOrigin: " 157.743px 230.157px 0px",
          }}
          id="el79sq7jxn41b"
          className="animable"
        ></path>
        <polygon
          points="146.14 271.79 148.74 278.49 146.11 282.18 140.89 279.17 138.29 272.46 140.92 268.77 146.14 271.79"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 143.515px 275.475px 0px",
          }}
          id="el87e4vmfi8w5"
          className="animable"
        ></polygon>
        <g id="ela7uyyupp1mk">
          <g
            style={{
              opacity: "0.2",
              transformOrigin: " 143.515px 275.475px 0px",
            }}
            className="animable"
          >
            <polygon
              points="146.14 271.79 148.74 278.49 146.11 282.18 140.89 279.17 138.29 272.46 140.92 268.77 146.14 271.79"
              style={{
                fill: " rgb(255, 255, 255)",
                transformOrigin: " 143.515px 275.475px 0px",
              }}
              id="elih784kcnmjc"
              className="animable"
            ></polygon>
          </g>
        </g>
        <path
          d="M145.63,273.33c7.44-9.54,12.05-16.36,17.64-28.8a5,5,0,0,1,3.73.55c-6.19,14.8-20.49,30.69-20.49,30.69Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 156.315px 260.078px 0px",
          }}
          id="elikbyo70ma0c"
          className="animable"
        ></path>
        <path
          d="M139.58,272.82l1.54-2.16c-2.65-10.67-1.39-23.45,1.41-28.7-1.14-.34-2.95.79-2.95.79C135.75,253.41,137.2,264,139.58,272.82Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 139.875px 257.358px 0px",
          }}
          id="elwurzhk8dve"
          className="animable"
        ></path>
        <path
          d="M177.74,278.4s5.16,50.71,4,86.76c0,0-3.13,4.62-7,3.89,1.33-14.39-2.51-53.48-7-82.16A29,29,0,0,0,174,274.45Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 174.825px 321.789px 0px",
          }}
          id="eln2653p751g"
          className="animable"
        ></path>
        <g id="elja8gbgq66fg">
          <path
            d="M177.74,278.4s5.16,50.71,4,86.76c0,0-3.13,4.62-7,3.89,1.33-14.39-2.51-53.48-7-82.16A29,29,0,0,0,174,274.45Z"
            style={{
              fill: " rgb(255, 255, 255)",
              opacity: "0.2",
              transformOrigin: " 174.825px 321.789px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M145.59,280.32l1.45-1.53c4.32,3.55,19.55,9.14,23.16,9.26l.38,2.42C163.54,289.2,150.54,284.77,145.59,280.32Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 158.085px 284.63px 0px",
          }}
          id="elqs9sif03k4"
          className="animable"
        ></path>
        <path
          d="M140.8,276.06l.76,2.2c-2.28,1.86-7.29,5-7.29,5a5.44,5.44,0,0,1,.06-3A19,19,0,0,0,140.8,276.06Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 137.824px 279.66px 0px",
          }}
          id="el0nc29kk2dn5f"
          className="animable"
        ></path>
        <path
          d="M133.44,294.5c9.35,4.75,31.6,6,37.53,3.22l.33,2.75c-5.92,2.79-28.89,1.5-38.24-3.25A4.43,4.43,0,0,1,133.44,294.5Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 152.146px 298.213px 0px",
          }}
          id="elb7v5khe532"
          className="animable"
        ></path>
        <path
          d="M247.07,247.94a13.88,13.88,0,0,0-.81-1.15,11.34,11.34,0,0,0-.91-1c-.23-.23-.47-.45-.7-.65l-.06-.05a7.92,7.92,0,0,0-.76-.57,12.81,12.81,0,0,1,1.2,1.63,29.23,29.23,0,0,1,2.62,6.76c.06.23.09.32.15.55l.17.56,2.29,2.91-.37-.61C249.17,253.62,248.12,249.67,247.07,247.94Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 247.045px 250.725px 0px",
          }}
          id="el0b6n9tyxjjtd"
          className="animable"
        ></path>
        <g id="elj8zxn4b7ly">
          <path
            d="M247.07,247.94a13.88,13.88,0,0,0-.81-1.15,11.34,11.34,0,0,0-.91-1c-.23-.23-.47-.45-.7-.65l-.06-.05a7.92,7.92,0,0,0-.76-.57,12.81,12.81,0,0,1,1.2,1.63,29.23,29.23,0,0,1,2.62,6.76c.06.23.09.32.15.55l.17.56,2.29,2.91-.37-.61C249.17,253.62,248.12,249.67,247.07,247.94Z"
            style={{
              opacity: "0.3",
              transformOrigin: " 247.045px 250.725px 0px",
            }}
            className="animable"
          ></path>
        </g>
        <path
          d="M234.44,243.23a12.11,12.11,0,0,1,7-.89,10.07,10.07,0,0,1,5.7,4c-3.06-4.14-5.51-5.15-7.87-5.59a12,12,0,0,0-7,.88,25.76,25.76,0,0,0-7.74,4.76L227,247.7A25.64,25.64,0,0,1,234.44,243.23Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 235.835px 244.135px 0px",
          }}
          id="el5gsfvq5so6"
          className="animable"
        ></path>
        <path
          d="M250.79,255.74c-.73-2.73-1.73-6.48-2.86-8.33-.15-.24-.31-.47-.46-.7a1.21,1.21,0,0,1-.1-.14l-.2-.27a10.07,10.07,0,0,0-5.7-4,12.11,12.11,0,0,0-7,.89A25.64,25.64,0,0,0,227,247.7l.93.53a24.49,24.49,0,0,1,6.86-4,11.07,11.07,0,0,1,6.44-.85,7.53,7.53,0,0,1,2.58,1.16,7.92,7.92,0,0,1,.76.57l.06.05c.23.2.47.42.7.65a11.34,11.34,0,0,1,.91,1,13.88,13.88,0,0,1,.81,1.15c1.05,1.73,2.1,5.68,2.82,8.35l.37.61.59,1A7.9,7.9,0,0,0,250.79,255.74Z"
          style={{
            fill: " rgb(69, 90, 100)",
            transformOrigin: " 238.943px 250.024px 0px",
          }}
          id="elosnmt7sk0mg"
          className="animable"
        ></path>
        <g id="ele7gqn73pukc">
          <path
            d="M250.79,255.74c-.73-2.73-1.73-6.48-2.86-8.33-.15-.24-.31-.47-.46-.7a1.21,1.21,0,0,1-.1-.14l-.2-.27a10.07,10.07,0,0,0-5.7-4,12.11,12.11,0,0,0-7,.89A25.64,25.64,0,0,0,227,247.7l.93.53a24.49,24.49,0,0,1,6.86-4,11.07,11.07,0,0,1,6.44-.85,7.53,7.53,0,0,1,2.58,1.16,7.92,7.92,0,0,1,.76.57l.06.05c.23.2.47.42.7.65a11.34,11.34,0,0,1,.91,1,13.88,13.88,0,0,1,.81,1.15c1.05,1.73,2.1,5.68,2.82,8.35l.37.61.59,1A7.9,7.9,0,0,0,250.79,255.74Z"
            style={{
              opacity: "0.1",
              transformOrigin: " 238.943px 250.024px 0px",
            }}
            className="animable"
          ></path>
        </g>
      </g>
    </svg>
  );
}
